var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "649",
      "height": "277",
      "viewBox": "0 0 649 277",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M448.315 84.4129L448.801 84.9938L447.861 85.2519L447.083 85.6068L445.171 85.865L443.453 86.2845L442.675 87.188L443.29 88.0592L443.744 89.0917L443.096 89.963L443.355 90.7696L443.064 91.5118L441.378 91.4473L442.383 92.8025L441.378 93.351L440.924 94.5772L441.281 95.8356L440.697 96.4165L440.016 96.2229L438.72 96.5133L438.655 97.0618H437.326L436.58 98.2557L436.84 99.9982L434.7 100.869L433.436 100.676L433.144 101.128L432.042 100.869L430.324 101.192L427.212 100.127L428.476 98.2557L428.12 96.9327L426.726 96.5778L426.337 95.2548L425.462 93.6092L425.98 92.4798L425.17 92.1572L425.332 90.6406L425.526 88.0592L427.439 88.8659L428.703 88.5755L428.833 87.6397L430.13 87.3493L430.972 86.7039L430.908 85.0583L432.269 84.6388L432.366 83.9289L433.306 84.4775L433.825 84.542H434.798L436.191 84.9938L436.775 85.2196L437.877 84.5743L438.558 84.9615L438.85 84.0257L439.887 84.058L440.081 83.7676L440.016 82.9286L440.568 82.2188L441.637 82.6705L441.605 83.3158L442.156 83.4126L442.448 85.1551L443.323 85.8327L443.809 85.381L444.522 85.1874L445.333 84.2516L446.565 84.4129H448.315Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M363.449 184.573L363.644 185.218L363.417 186.219L363.709 187.187L363.417 187.961L363.547 188.671L359.754 188.639L359.495 195.253L360.662 196.931L361.829 198.222L358.457 199.061L354.081 198.771L352.849 197.803L345.491 197.867L345.232 198.028L344.162 197.093L342.995 197.028L341.893 197.383L341.018 197.77L340.855 196.48L341.147 194.64L341.796 192.737L341.893 191.865L342.509 189.994L342.963 189.155L344.032 187.8L344.648 186.864L344.843 185.347L344.745 184.153L344.227 183.411L343.741 182.153L343.319 180.927L343.416 180.475L343.967 179.668L343.449 177.668L343.06 176.28L342.152 174.957L342.347 174.57L343.092 174.28L343.643 174.312L344.292 174.086L349.705 174.118L350.126 175.635L350.645 176.893L351.067 177.571L351.747 178.636L352.979 178.474L353.563 178.184L354.567 178.474L354.859 177.958L355.345 176.764L356.48 176.667L356.577 176.312H357.517L357.355 177.055L359.56 177.022L359.592 178.345L359.949 179.12L359.657 180.378L359.786 181.669L360.37 182.443L360.24 184.896L360.694 184.702L361.472 184.766L362.607 184.444L363.449 184.573Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M342.088 173.928L341.602 172.38L342.347 171.476L342.898 171.121L343.579 171.831L342.931 172.283L342.606 172.799L342.542 173.702L342.088 173.928Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.69 73.5742L352.82 73.9614L353.274 73.7678L353.663 74.3164L354.084 74.5422L354.279 75.2844L354.116 75.9943L354.441 76.8655L355.186 77.3495L355.219 77.8981L354.668 78.1885L354.635 78.8661L353.922 79.8664L353.63 79.7373L353.565 79.2856L352.56 78.5757L352.334 77.6077L352.366 76.1879L352.528 75.5748L352.236 75.2521L352.074 74.5745L352.69 73.5742Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M420.178 108.647L420.599 110.293H419.692V111.648L420.048 111.939L419.27 112.358L419.335 113.197L418.914 114.036V114.875L418.589 115.327L413.111 114.294L412.236 112.165L412.139 111.713L412.43 111.584L412.56 112.165L413.922 111.842L415.413 111.906L416.515 111.971L417.585 110.551L418.784 109.228L419.756 107.938L420.178 108.647Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M216.896 274.824L215.923 274.759H214.302L212.357 270.371L213.362 271.275L214.756 272.759L217.285 273.953L219.651 274.437L219.392 275.405L217.965 275.502L216.896 274.824Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.01 208.031L210.673 211.387L212.164 211.71L214.53 213.259L216.443 214.065L216.799 214.969L215.438 218.131L217.318 218.68L219.36 219.002L220.722 218.68L222.116 217.066L222.213 215.259L223.056 214.84L224.093 216.066L224.223 217.712L222.861 218.841L221.791 219.68L220.073 221.713L218.128 224.52L217.966 226.198L217.837 228.328L218.226 230.393L217.934 230.845L218.064 232.167L218.161 233.265L220.689 235.039L220.754 236.459L222.018 237.363L222.116 238.363L221.046 241.009L218.777 242.138L215.47 242.558L213.525 242.332L214.206 243.59L214.239 245.107L214.822 246.139L214.012 246.881L212.358 247.172L210.543 246.397L210.057 246.946L210.867 248.979L212.164 249.592L212.909 248.947L213.72 250.011L212.358 250.657L211.418 251.947L211.807 253.98L211.775 255.077H210.219L209.246 256.11L209.279 257.659L211.386 259.143L213.072 259.53L213.136 261.37L211.645 262.499L211.451 264.854L210.316 265.629L210.024 266.565L211.386 268.662L212.877 269.791L212.196 269.695L210.608 269.372L206.686 269.114L205.551 267.952L204.935 266.468L203.93 266.597L203.087 265.855L202.082 263.757L202.958 262.854L202.99 261.595L202.407 260.563L202.634 258.82L202.277 256.142L201.693 254.948L202.277 254.561L201.823 253.787L200.915 253.4L201.175 252.528L200.17 251.754L198.971 249.398L199.522 248.979L198.452 246.462L198.193 244.365L198.128 242.525L198.938 241.783L197.868 239.75L197.35 237.879L198.322 236.524L197.868 234.781L198.387 232.781L197.933 230.877L197.415 230.49L195.826 226.908L196.507 224.778L195.956 222.778L196.248 220.874L197.09 218.938L198.16 217.647L197.512 216.84L197.771 216.163L197.252 212.71L199.068 211.71L199.457 209.548L199.165 209.032L200.462 207.16L202.893 207.676L204.092 209.161L204.611 207.483L206.686 207.58L207.01 208.031Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M398.977 81.6373L398.394 81.7019L397.486 80.508L397.421 80.1853H396.676L396.06 79.6367L395.736 79.669L394.958 79.0882L393.596 78.5719L393.564 77.5716L393.143 76.8617L395.412 76.5391L395.865 77.0553L396.579 77.4103L396.352 77.9266L397.389 78.6365L397.033 79.3141L397.875 79.8626L398.686 80.1853L398.977 81.6373Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M565.014 246.397L566.214 247.107L567.283 246.816L568.872 246.429L569.78 246.558L568.321 249.01L567.251 249.688L565.954 251.366L565.76 250.785L563.62 252.205L563.361 252.108L562.389 252.044L562.551 250.301L563.199 248.946L563.394 247.139L564.042 246.203L565.014 246.397Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M581.385 190.441L581.774 192.054L583.071 191.28L583.524 192.151L584.27 192.958L583.913 193.893L583.978 195.668L584.043 196.701L584.465 196.959L584.594 198.734L584.205 199.798L584.465 201.186L586.215 202.283L587.252 203.251L588.29 204.154L587.933 204.671L588.679 205.961L588.841 208.22L589.684 207.768L590.17 208.64L590.688 208.349L590.461 210.543L591.402 211.802L592.017 212.576L592.925 214.254V215.932L592.601 217.126L592.017 218.384L592.244 220.159L591.434 221.998L590.753 222.966L589.521 224.806L589.035 226L588.03 227.484L586.409 229.355L584.627 230.388L583.2 231.969L582.131 233.002L580.704 234.776L579.505 235.809L578.241 237.358L577.236 238.778L576.976 239.455L575.583 240.165L573.605 240.23L571.563 241.101L570.331 241.875L568.775 242.779L567.9 241.843L567.057 241.488L567.9 240.423L566.765 240.81L564.431 242.295L563.264 241.746L562.486 241.423L561.579 241.262L560.25 240.681L559.828 239.391L560.315 237.842L560.444 236.777L559.99 235.938L558.467 235.712L559.504 234.68L559.796 233.163L558.272 234.583L556.554 234.97L558.013 233.841L558.823 232.647L559.958 231.614L560.477 230.098L558.272 231.84L556.878 232.55L555.485 234.196L554.512 233.357L555.063 232.259L554.609 230.743L554.026 229.969L554.545 229.484L552.826 228.226L551.595 228.194L550.298 227.161L547.089 227.355L544.528 228.097L542.291 228.807L540.67 228.678L538.401 229.743L536.683 230.194L535.938 231.291L534.965 232.13L533.442 232.195L532.275 232.356L530.913 232.001L529.552 232.227L528.32 232.324L526.861 233.421L526.375 233.324L525.273 233.905L524.171 234.551L522.939 234.486H521.804L520.475 233.163L519.697 232.776L520.184 231.582L521.124 231.291L521.61 230.84L521.804 230.098L522.55 228.646L522.777 227.419L522.55 225.322L522.615 224.128L523.069 222.966L522.777 221.611L522.874 220.998L522.323 220.159L522.55 218.546L521.934 216.9L521.902 216.029L522.485 216.932L522.323 214.996L523.069 215.609L523.425 216.416L523.62 215.351L523.101 213.706L523.069 213.06L522.809 212.447L523.231 211.253L523.717 210.737L524.138 209.705L524.171 208.478L525.176 206.994L525.046 208.575L526.051 207.155L527.639 206.445L528.677 205.574L530.2 204.8L531.043 204.638L531.497 204.897L533.053 204.122L534.187 203.896L534.544 203.445L535.03 203.251L536.035 203.316L538.045 202.702L539.179 201.767L539.828 200.67L541.092 199.637L541.319 198.798L541.546 197.669L543.134 195.894L543.588 197.701L544.431 197.281L543.944 196.313L544.69 195.313L545.403 195.765L545.889 194.184L547.024 193.151L547.608 192.345L548.548 191.99L548.677 191.409L549.423 191.635L549.552 191.118L550.395 190.828L551.303 190.538L552.502 191.506L553.345 192.732H554.48L555.614 192.925L555.387 191.796L556.522 190.15L557.397 189.602L557.203 189.086L558.143 187.892L559.342 187.149L560.217 187.408L561.806 187.02L561.903 185.956L560.639 185.278L561.644 184.988L562.811 185.504L563.686 186.343L565.145 186.859L565.696 186.665L566.765 187.311L567.9 186.698L568.548 186.891L569.035 186.472L569.748 187.504L569.099 188.634L568.289 189.473L567.673 189.537L567.77 190.344L567.057 191.377L566.247 192.409L566.312 192.99L567.543 194.152L568.84 194.797L569.65 195.507L570.72 196.733H571.239L572.082 197.281L572.244 197.927L573.832 198.604L575.161 197.895L575.745 196.797L576.296 195.862L576.717 194.732L577.56 193.087L577.495 192.086L577.722 191.473L577.69 190.312L578.143 188.731L578.565 188.311L578.37 187.633L578.954 186.536L579.44 185.407L579.57 184.794L580.315 184.02L580.737 185.052L580.704 186.343L581.126 186.601L581.093 187.472L581.612 188.505L581.579 189.699L581.385 190.441Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M347.045 61.5636L346.948 61.8218L347.175 62.4994L347.11 63.3384H346.202L346.559 63.7901L346.137 65.0808L345.846 65.4358L344.419 65.468L343.641 65.952L342.28 65.7907L339.914 65.2421L339.492 64.5645L337.904 64.9195L337.742 65.3067L336.737 65.0163L335.894 64.9517L335.148 64.5645L335.375 64.0805L335.311 63.7256L335.764 63.6288L336.64 64.1773L336.834 63.6288L338.26 63.7256L339.395 63.3706L340.173 63.4352L340.724 63.8546L340.854 63.4997L340.529 62.1767L341.081 61.9186L341.599 60.9828L342.831 61.6605L343.674 60.8215L344.225 60.6602L345.522 61.2732L346.267 61.1764L347.045 61.5636Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M398.394 81.7018L397.163 81.4114L396.125 80.4757L395.736 79.669L396.06 79.6367L396.676 80.1853H397.422L397.487 80.5079L398.394 81.7018Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M400.437 76.217L401.247 75.3781L402.382 76.4429L403.549 77.9272L404.359 78.024L404.975 78.5725L403.613 78.7339L403.646 80.3473L403.516 81.0571L402.965 81.5411L403.224 82.5414L402.803 82.6705L401.539 81.5734L401.928 80.5731L401.312 79.96L400.696 80.1214L398.978 81.638L398.686 80.1859L397.876 79.8632L397.033 79.3147L397.389 78.6371L396.352 77.9272L396.579 77.4109L395.866 77.056L395.412 76.5397L395.769 76.1847L397.13 76.7978L398.07 76.8946L398.265 76.6688L397.195 75.5394L397.584 75.2812L398.07 75.3458L399.464 76.572L400.242 76.7333L400.437 76.217Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M374.372 171.149L374.178 171.181V171.085L373.529 169.116L373.526 169.097L373.497 168.761L373.043 167.826L374.178 167.987L374.729 166.793L375.733 166.922L375.831 167.729L376.22 168.213V168.89L375.766 169.31L375.02 170.407L374.372 171.149Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M329.511 57.1482L329.382 58.5034L328.96 58.568L328.831 59.6973L327.404 58.7616L326.594 58.9229L325.459 57.9872L324.681 57.1805L323.968 57.1482L323.709 56.4383L324.973 56.0511L326.14 56.2124L327.599 55.793L328.604 56.6642L329.511 57.1482Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M326.331 137.78L326.266 138.457L326.688 139.684L326.331 140.523L326.526 141.071L325.618 142.362L325.067 143.007L324.71 144.298L324.775 145.621L324.678 148.944L323.154 149.203L322.7 147.783L322.798 143.007L322.409 142.588L322.344 141.555L321.696 140.845L321.145 140.232L321.371 139.135L322.02 138.909L322.376 138.006L323.284 137.812L323.673 137.199L324.289 136.586H324.937L326.331 137.78Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M320.434 131.004L320.272 132.005L320.531 132.94L321.536 134.296L321.601 135.296L323.708 135.78L323.675 137.2L323.286 137.813L322.379 138.006L322.022 138.91L321.374 139.136L319.785 139.104L318.942 138.942L318.359 139.265L317.549 139.104L314.372 139.2L314.307 140.394L314.566 141.943L313.302 141.427L312.459 141.491L311.811 142.008L311.001 141.588L310.676 140.878L309.866 140.427L309.736 139.233L310.255 138.361L310.19 137.652L311.649 135.941L311.941 134.522L312.427 134.005L313.302 134.296L314.08 133.876L314.339 133.328L315.733 132.424L316.09 131.779L317.808 130.908L318.813 130.617L319.267 131.004H320.434Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M486.432 116.261L486.626 117.745L485.946 117.422L486.302 119.1L485.622 118.035L485.362 116.971L484.876 115.97L483.968 114.776L482.283 114.68L482.574 115.551L482.185 116.68L481.343 116.261L481.148 116.648L480.597 116.422L479.884 116.228L479.365 114.518L478.522 112.969L478.62 111.711L477.42 111.162L477.712 110.42L478.684 109.646L477.193 108.549L477.582 107.129L479.171 108.032L480.046 108.129L480.435 109.581L482.185 109.872L483.839 109.839L484.941 110.194L484.422 111.937L483.644 112.066L483.255 113.227L484.422 114.325L484.519 112.969H485.006L486.432 116.261Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M367.149 71.5073L366.403 72.3462L365.982 73.7982L366.663 74.9599L365.172 74.7017L363.551 75.3471L363.648 76.3796L362.157 76.5733L360.893 75.8311L359.596 76.4119L358.364 76.3474L358.105 74.9921L357.197 74.3145L357.424 74.0564L357.23 73.7982L357.424 73.1529L358.008 72.5075L357.1 71.6363L356.873 70.8619L357.23 70.4102L357.813 71.2491L358.429 71.12L359.726 71.4105L362.189 71.5395L362.935 71.0232L364.847 70.5392L366.144 71.2814L367.149 71.5073Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M351.067 69.1494L351.683 69.1172L351.327 70.0206L352.202 70.8273L352.04 71.7631L351.683 71.8599L351.392 72.0535L350.873 72.5375L350.743 73.6669L349.187 72.8925L348.507 72.0212L347.826 71.5695L347.015 70.7951L346.594 70.182L345.719 69.214L345.978 68.375L346.626 68.859L346.951 68.4073L347.696 68.375L349.155 68.7299L350.289 68.6977L351.067 69.1494Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M370.064 52.4997L368.8 52.4352L368.541 52.6288L369.027 53.2741L369.675 54.5648L368.346 54.6616L367.925 55.1134L368.022 56.1137L367.341 55.9201L365.947 56.0169L365.461 55.5329L364.91 55.8878L364.294 55.5974L363.03 55.5651L361.182 55.0811L359.594 54.9198L358.362 54.9843L357.584 55.5006L356.839 55.5974L356.676 54.6939L356.061 53.7904L356.968 53.3709L356.839 52.5965L356.287 51.8544L356.093 50.9832H357.616L359.172 50.241L359.335 49.1439L360.502 48.4986L360.177 47.6273L361.053 47.3047L362.544 46.5625L364.262 47.0465L364.554 47.5305L365.332 47.3047L366.888 47.7564L367.244 48.6922L367.017 49.2084L368.249 50.4991L368.93 50.8541V51.209L370.032 51.564L370.583 52.0802L370.064 52.4997Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.123 129.007H157.572L157.994 126.684L158.221 125.038L158.253 124.715L158.48 124.619L158.772 124.877L159.582 123.618L159.939 123.586L159.906 123.909H160.23L160.133 124.489L159.712 125.361L159.841 125.683L159.55 126.425L159.647 126.619L159.323 127.684L158.901 128.232L158.545 128.297L158.123 129.007Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M214.756 203.735L214.659 203.09L212.908 202.025L211.223 201.993L208.111 202.606L207.43 204.413L207.495 205.542L207.009 208.027L206.685 207.575L204.61 207.478L204.091 209.156L202.892 207.672L200.461 207.156L199.164 209.027L197.9 209.318L196.895 206.446L195.696 204.123L196.052 202.122L195.015 201.251L194.626 199.767L193.589 198.347L194.529 196.12L193.589 194.378L193.945 193.668L193.556 192.894L194.172 191.861L194.075 190.119V188.634L194.431 187.957L192.648 184.601L194.01 184.794L194.95 184.73L195.307 184.117L196.863 183.278L197.803 182.503L200.169 182.148L200.039 183.697L200.331 184.504L200.234 185.891L202.341 187.731L204.415 188.086L205.161 188.86L206.425 189.28L207.236 189.86H208.37L209.472 190.473L209.634 191.667L210.023 192.28L210.121 193.152L209.57 193.184L210.477 195.604L213.946 195.701L213.784 196.895L214.043 197.701L215.08 198.282L215.631 199.573L215.437 201.219L215.016 202.122L215.275 203.284L214.756 203.735Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.828 157.983L216.833 158.177L217.027 157.725L216.703 157.338L216.898 156.725L217.643 156.919L218.518 156.693L219.556 157.144L220.366 157.564L220.917 157.015L221.339 157.08L221.598 157.661L222.473 157.532L223.186 156.725L223.77 155.208L224.872 153.305L225.52 153.208L225.942 154.369L226.914 157.983L227.919 158.338L227.951 159.758L226.558 161.468L227.109 162.081L230.383 162.404L230.448 164.501L231.841 163.146L234.143 163.888L237.222 165.147L238.13 166.341L237.838 167.502L239.978 166.857L243.544 167.954L246.299 167.89L249.022 169.6L251.421 171.923L252.847 172.504L254.403 172.601L255.084 173.246L255.732 175.892L256.089 177.15L255.408 180.571L254.533 181.926L252.037 184.798L250.934 187.153L249.638 188.928L249.184 188.992L248.763 190.509L249.054 194.381L248.698 197.576L248.601 198.931L248.082 199.77L247.92 202.545L246.234 205.223L246.072 207.385L244.678 208.256L244.322 209.515H242.377L239.621 210.289L238.422 211.225L236.477 211.838L234.5 213.484L233.17 215.549L233.073 217.097L233.495 218.227L233.397 220.324L233.138 221.325L232.036 222.486L230.577 226.132L229.281 227.746L228.243 228.746L227.757 230.714L226.817 231.876L226.136 230.714L226.72 229.714L225.488 228.327L223.932 227.165L221.89 225.842L221.274 225.907L219.232 224.293L218.129 224.519L220.074 221.712L221.792 219.679L222.862 218.84L224.224 217.711L224.094 216.065L223.057 214.839L222.214 215.258L222.441 214.064L222.538 212.838L222.441 211.677L221.76 211.322L221.112 211.644L220.431 211.547L220.172 210.773L219.815 208.869L219.426 208.256L218.162 207.675L217.449 208.095L215.536 207.675L215.406 204.868L214.758 203.739L215.277 203.287L215.017 202.125L215.439 201.222L215.633 199.576L215.082 198.286L214.045 197.705L213.786 196.898L213.948 195.704L210.479 195.607L209.572 193.187L210.123 193.155L210.025 192.284L209.636 191.671L209.474 190.477L208.372 189.864H207.238L206.427 189.283L205.163 188.863L204.417 188.089L202.343 187.734L200.236 185.895L200.333 184.507L200.041 183.701L200.171 182.152L197.805 182.507L196.865 183.281L195.309 184.12L194.952 184.733L194.012 184.798L192.65 184.604L191.613 184.959L190.77 184.733L190.738 181.603L189.312 182.797L187.691 182.765L186.945 181.635L185.713 181.539L186.038 180.635L184.968 179.377L184.125 177.505L184.611 177.15L184.546 176.247L185.649 175.666L185.422 174.537L185.875 173.827L185.973 172.859L188.015 171.439L189.506 171.052L189.765 170.729L191.419 170.826L192.132 165.147L192.164 164.243L191.872 163.082L191.03 162.307L191.062 160.791L192.099 160.468L192.456 160.694L192.521 159.887L191.451 159.661V158.371L195.017 158.435L195.633 157.693L196.151 158.371L196.476 159.597L196.832 159.339L197.837 160.436L199.263 160.307L199.62 159.661L200.981 159.177L201.759 158.822L201.986 157.951L203.315 157.37L203.218 156.919L201.662 156.757L201.435 155.434L201.532 154.047L200.722 153.53L201.079 153.337L202.408 153.595L203.866 154.111L204.417 153.627L205.747 153.305L207.821 152.53L208.502 151.723L208.275 151.143L209.247 151.078L209.636 151.53L209.377 152.466L210.025 152.756L210.414 153.724L209.896 154.466L209.572 156.209L210.025 157.273L210.123 158.242L211.257 159.21L212.165 159.306L212.359 158.887L212.943 158.79L213.786 158.435L214.369 157.887L215.406 158.08L215.828 157.983Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M529.389 152.561L530.102 151.787L531.593 150.625L531.561 151.658L531.528 152.981L530.653 152.916L530.296 153.626L529.389 152.561Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M482.609 104.389L483.452 105.067L483.614 106.325L482.155 106.39L480.631 106.261L479.594 106.583L477.811 105.777L477.682 105.389L478.524 103.84L479.367 103.324L480.761 103.776L481.701 103.84L482.609 104.389Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M365.526 198.673L366.142 200.319L366.499 200.706L367.017 201.9L368.995 204.159L369.74 204.384L369.708 205.127L370.194 206.45L371.588 206.772L372.69 207.708L370.065 209.225L368.379 210.773L367.731 212.161L367.147 212.935L366.175 213.097L365.786 214.097L365.591 214.742L364.424 215.194L362.965 215.097L362.155 214.516L361.409 214.291L360.502 214.742L360.016 215.743L359.14 216.356L358.233 217.291L356.936 217.517L356.579 216.775L356.774 215.517L355.801 213.548L355.348 213.226L355.542 207.192L357.325 207.127L357.584 199.738L358.946 199.673L361.766 198.931L362.414 199.802L363.614 198.996H364.165L365.202 198.512L365.526 198.673Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M363.481 144.079L364.745 144.886L365.75 145.725L365.782 146.402L367.046 147.467L367.824 148.37L368.278 149.597L369.672 150.436L369.964 151.081L369.38 151.307L368.181 151.275L366.819 151.049L366.139 151.21L365.847 151.726L365.263 151.791L364.55 151.339L362.508 152.372L361.665 152.178L361.406 152.339L360.887 153.598L359.493 153.178L358.164 152.985L356.997 152.21L355.474 151.5L354.501 152.178L353.788 153.211L353.626 154.663L352.459 154.566L351.195 154.211L350.125 155.308L349.153 157.244L348.958 156.631L348.861 155.695L348.018 155.018L347.337 153.953L347.175 153.211L346.3 152.114L346.462 151.5L346.268 150.629L346.397 149.016L346.851 148.661L347.759 146.564L349.25 146.402L349.574 145.854L349.898 145.918L350.352 146.37L352.654 145.595L353.432 144.789L354.372 144.047L354.177 143.337L354.696 143.143L356.479 143.272L358.164 142.304L359.461 140.045L360.369 139.207L361.536 138.852L361.762 139.723L362.832 141.013V141.885L362.573 142.724L362.703 143.369L363.318 143.982L363.481 144.079Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M215.857 65.6946L216.959 65.985L218.483 65.9205L217.413 66.7594L216.765 66.8885L214.982 66.0173L214.787 65.3396L215.598 64.7266L215.857 65.6946Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M220.529 60.5383L219.751 60.5706L217.871 59.9575L216.736 58.9895L217.352 58.8281L219.265 59.3444L220.626 60.1834L220.529 60.5383Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M120.719 61.7284L119.714 62.0188L117.672 61.1153V60.4054L116.732 59.6955L116.829 59.1147L115.436 58.7598L115.63 57.6627L116.116 57.2109L117.445 57.6304L118.223 57.9531L119.552 58.1467L119.617 58.8566L119.747 59.7923L120.784 60.6313L120.719 61.7284Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M230.644 57.3715L229.023 59.114L230.287 58.4363L231.227 58.8881L230.449 59.5657L231.681 60.1143L232.589 59.6302L233.983 60.2433L233.075 61.7276L234.307 61.3727L234.209 62.4375L234.372 63.696L233.205 65.5029L232.427 65.5675L231.486 65.1803L232.297 63.5346L231.908 63.2765L229.542 65.0189L228.569 64.9544L229.995 63.9864L228.569 63.5024L226.786 63.6314L223.674 63.5669L223.609 62.9861L224.841 62.2439L224.29 61.7276L226.041 60.5015L228.699 57.307L230.06 56.1776L231.681 55.5L232.362 55.5645L231.875 56.1131L230.644 57.3715Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M113.945 50.4648L114.431 50.723L116.052 50.5616L113.718 52.7881L113.815 54.4015H113.199L112.972 53.498L113.134 52.5622L112.875 51.9492L113.296 51.0779L113.945 50.4648Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.811 35.1382L204.644 36.1063L204.093 35.9449L204.061 35.3964L204.19 35.2673L205.098 34.7188L205.649 34.751L205.811 35.1382Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.664 34.106L200.33 35.1385L199.357 35.074V34.59L200.978 33.7188L202.923 33.751L202.664 34.106Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M201.66 28.6877L201.368 29.4944L202.243 29.2039L202.729 29.688L203.864 30.3333L205.096 30.8819L204.642 31.7531L205.776 31.624L206.392 32.2371L204.771 32.8179L202.859 32.3662L202.6 31.5272L200.557 32.5275L197.899 33.4633L198.126 32.3984L196.084 32.5598L197.932 31.6563L199.099 30.2042L200.752 28.5586L201.66 28.6877Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M216.213 26.0045L214.625 26.1013L214.852 25.2301L216.084 24.2298L217.478 24.0039L218.223 24.4879L217.737 25.2301L217.445 25.4882L216.213 26.0045Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M192.067 22.5531L190.738 23.1662L189.376 22.6499L188.112 22.8112L187.01 22.0368L188.631 21.4882L190.219 20.7461L191.191 21.2301L191.71 21.5528L191.84 21.8755L192.067 22.5531Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M209.243 68.5724L208.53 67.4107L209.47 64.668L208.951 64.0872L207.752 64.4099L207.395 63.8936L205.612 65.4102L204.575 66.9913L203.667 67.927L202.857 68.2497L202.306 68.3465L201.949 68.8305H198.935L196.406 68.8628L195.531 69.2177L193.327 70.6375V70.6052L193.035 70.4762L192.387 70.7666L191.771 71.1861L191.187 70.8311L189.664 71.0892L188.399 71.3797L187.783 71.6378L187.038 72.3154L187.621 72.5413L188.172 72.4122H188.27L188.172 73.0253L186.617 73.2512L185.709 73.5093L185.158 73.832L184.315 73.6384L183.796 73.7352L182.856 74.316L181.365 74.9613L180.49 74.8323L181.138 74.1224L182.338 72.993L183.667 72.3154L184.023 71.7346L184.315 70.7666L185.547 69.6372L185.839 68.3465L186.195 69.6049L187.427 69.8954L188.205 69.2177L187.751 67.6689L187.459 67.0235L186.163 66.6363L184.931 66.4105H183.667L182.565 66.1523L182.435 65.7006L181.981 65.991L181.592 65.9264L182.208 65.2488L181.624 64.9907L182.24 64.2163L181.851 63.6354L182.402 63.0546L180.717 62.7642L180.684 61.6026L180.425 61.3445L179.355 61.2799L178.026 60.8927L177.54 61.1508L176.957 61.6349L175.887 61.9575L174.882 62.7642L173.131 62.2157L171.705 62.4738L170.441 61.8607L168.95 61.5381L167.88 61.409L167.556 61.0863L167.848 59.9892H167.297L166.875 60.7636H163.569H158.058H152.612H147.782H142.985H138.219H133.325H131.769H127.003H122.433H122.206L120.455 58.7953L119.937 57.9241L117.668 57.0851L118.089 55.3104L119.256 54.1165L117.927 53.2453L118.932 51.6642L118.251 50.2444L119.061 49.2119L120.715 48.2761L121.752 47.0499L120.261 45.8238L120.715 43.5973L121.071 42.2421L120.553 41.3708L120.293 40.5964L120.488 39.5961L118.381 40.2092L115.917 41.274L115.82 40.0479L115.658 39.2089L114.75 38.6926L113.389 38.6281L124.929 28.0766L132.903 21.4941L134.848 21.9135L135.918 22.7525L137.117 22.9138L139.159 22.2039L141.429 21.6554L143.147 21.849L146.032 21.1068L148.69 20.6874L148.755 21.3972L150.213 20.9778L151.478 20.1711L152.158 20.3647L152.612 21.9135L155.692 20.7196L154.427 22.0426L156.372 21.7522L157.41 21.2682L158.901 21.365L160.165 22.0749L162.596 22.7202L164.12 23.0106L165.546 22.9138L166.486 23.8173L163.731 24.6885L165.805 25.0435L169.663 24.8499L171.089 24.5272L171.543 25.592L173.845 24.7208L173.164 23.9464L174.623 23.3656L176.308 23.2688L177.572 23.1074L178.253 23.5269L178.739 24.4627L180.36 24.3336L182.078 25.1403L184.412 24.8499L186.357 24.8821L187.135 23.785L188.594 23.4946L190.182 24.0755L188.788 25.7534L190.798 24.3336L191.836 24.3981L193.91 22.6234L193.391 21.5586L192.451 20.8487L194.234 18.9449L196.892 17.7188L198.351 18.0092L198.999 18.7513L199.129 20.6874L197.249 21.5263L199.421 21.8813L197.995 23.656L200.88 22.3007L201.593 23.4301L200.199 24.7208L200.62 25.9147L202.987 24.6563L205.094 23.1074L206.617 21.2036L208.4 21.3327L210.151 21.5909L211.318 22.4621L210.766 23.3333L209.113 24.2691L209.405 25.2048L208.627 26.076L205.094 27.3345L202.987 27.6249L201.949 27.0763L200.88 27.9798L198.481 29.4964L197.508 30.3031L195.012 31.5293L192.905 31.6583L191.252 32.4327L190.312 33.6589L188.464 33.8848L185.644 35.4014L182.597 37.4987L180.976 38.9831L179.388 41.2095L181.333 41.5322L180.846 43.3069L180.587 44.7912L182.954 44.404L185.223 45.243L186.292 45.9851L186.843 46.8886L188.432 47.4371L189.599 48.2438L192.062 48.3729L193.618 48.5665L192.451 50.2444L191.9 52.2127L191.933 54.4392L193.359 56.343L194.883 55.6976L196.698 53.6325L197.443 50.5348L196.892 49.5023L199.81 48.5665L202.241 47.2113L203.797 45.856L204.348 44.5653L204.218 42.9197L203.181 41.4677L206.066 39.4671L206.39 37.7569L207.655 34.8528L208.886 34.4011L211.058 34.9173L212.42 35.111L213.878 34.5947L214.883 35.24L216.05 36.3371L216.115 37.047L218.611 37.2083L217.768 38.7894L217.023 41.1772L218.255 41.4999L218.773 42.6293L221.431 41.5645L223.863 39.4348L225.224 38.5636L225.581 40.2738L226.423 42.6938L227.072 45.0171L225.97 46.2432L227.526 47.3403L228.466 48.4374L230.702 48.9537L231.48 49.5668V51.2447L232.582 51.5029L232.939 52.245L232.291 54.4715L230.897 55.2136L229.535 55.9235L226.683 56.6334L224.122 58.2468L221.334 58.6017L218.06 58.15H215.694L213.976 58.279L212.128 59.7311L209.729 60.6346L206.455 63.2805L203.894 65.152L205.418 64.8293L208.951 62.1511L212.938 60.4732L215.402 60.2796L216.472 61.2799L214.494 62.6352L214.3 64.7971L214.332 66.3459L216.148 67.3462L218.935 67.0558L221.269 64.7648L220.945 66.2491L221.756 66.9913L219.357 68.3142L215.337 69.5404L213.457 70.3471L211.123 71.8314L209.924 71.6701L210.41 69.9599L213.781 68.2497L211.155 68.3142L209.243 68.5724Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M174.725 15.7133L173.201 16.4877L176.605 16.0037L177.448 16.8427L179.814 15.9714L180.398 16.52L179.684 18.1656L181.078 17.488L181.986 15.7778L183.38 15.5197L184.352 15.7778L185.065 16.4555L184.19 18.1011L183.412 19.295L184.774 20.134L186.395 20.9729L185.552 21.7151L183.25 21.8764L183.509 22.5217L182.472 23.1671L180.3 22.909L178.453 22.4249L176.799 22.5217L173.72 23.1348L170.057 23.393L167.496 23.5543L167.593 22.7154L166.264 22.2636L164.87 22.4572L164.676 21.0697L165.746 20.8761L168.112 20.5857L169.895 20.6825L171.905 20.3598L169.798 19.9726L166.848 20.1017L165 20.0694V19.4563L168.793 18.7464L166.75 18.7787L165 18.327L167.528 17.0685L169.214 16.3909L173.817 15.3906L174.725 15.7133Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M187.528 15.231L185.259 16.3281L184.514 15.1664L185.194 14.9083L186.977 14.8438L187.528 15.231Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M222.733 15.7455L222.506 16.1973L221.177 16.165L219.848 16.1327L218.26 16.3586L217.968 16.2295L217.287 15.3583L217.838 14.7775L218.551 14.6484L221.274 14.842L222.733 15.7455Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M209.831 15.6508L209.929 16.6833L212.263 15.3604L216.055 14.6827L216.801 16.3929L215.764 17.49L218.681 17.006L220.399 16.3284L222.603 17.1673L223.803 17.974L223.446 18.7162L226.104 18.329L226.72 19.4261L229.443 20.1037L230.156 20.7813L230.448 22.4269L227.498 23.2336L229.994 24.3953L231.907 24.7825L232.977 26.3959L235.084 26.5249L234.014 27.7834L230.481 29.8807L229.184 29.1063L227.952 27.3639L226.04 27.5898L225.294 28.6546L226.169 29.6871L227.628 30.5261L227.952 31.0101L227.92 32.8494L226.753 34.1723L225.229 33.656L222.441 32.204L223.608 33.7851L224.516 34.9145L224.419 35.5598L220.885 34.8177L218.422 33.7206L217.19 32.8494L217.968 32.3008L216.412 31.3651L214.888 30.4938L214.597 31.0101L210.35 31.3005L209.572 30.6874L211.323 29.3322L213.948 29.2999L216.963 29.0741L216.898 28.4287L217.903 27.5252L220.756 25.7828L220.885 24.9761L220.723 24.3953L219.2 23.524L216.898 22.9432L218.033 22.4915L217.384 21.3944L216.282 21.2976L215.666 20.7168L214.597 21.233L212.036 21.4589L207.498 21.0717L205.099 20.5554L203.186 20.2973L202.57 19.6842L204.613 18.9098H202.765L203.835 17.1996L206.136 15.7153L208.081 15.0377L211.712 14.5859L209.831 15.6508Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M193.492 14.5234L194.659 14.8784L197.123 14.6525L196.961 15.1365L194.983 15.9432L196.215 16.6531L194.529 18.1697L191.806 18.815L190.704 18.6859L190.413 18.0406L188.5 16.7499L189.051 16.2013L191.45 16.395L191.158 15.3301L193.492 14.5234Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M200.816 16.3017L198.288 17.5601L196.861 17.4956L197.445 16.0113L198.288 15.2046L199.649 14.4947L201.335 14.043L203.896 14.1075L205.905 14.4947L202.631 15.979L200.816 16.3017Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M163.277 18.6178L158.901 19.4568L159.095 18.7146L157.15 17.8111L158.577 17.1012L161.008 15.8751L163.472 14.778L163.601 13.7777L168.139 13.5195L169.501 13.8745L172.58 13.9713L173.196 14.423L173.715 15.1329L171.608 15.5524L167.102 16.714L164.12 17.9079L163.277 18.6178Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M203.866 12.683L202.537 13.2961L200.852 13.167L199.814 12.7476L201.273 12.0377L203.51 11.5859L203.964 12.1668L203.866 12.683Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M201.011 9.875L201.076 10.6172L200.168 11.4238L198.288 12.65L196.051 12.8113L195.014 12.5532L196.116 11.6174L193.977 11.7142L195.37 10.4881L196.602 10.5526L199.098 10.0041L200.687 10.1009L201.011 9.875Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.24 10.7131L188.013 11.2617L189.44 11.0035L190.606 11.068L189.861 11.8747L188.208 12.6169L183.702 12.875L179.715 13.5849L177.77 13.6172L178.256 13.1009L181.724 12.3587L175.922 12.5524L174.561 12.2619L178.353 10.7131L180.104 10.2614L182.794 10.8099L183.734 11.7457L185.712 11.8747L185.939 10.3582L187.819 9.77734L188.824 9.93868L188.24 10.7131Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.298 9.29602L207.044 9.8123H209.443L209.896 10.3286L208.989 10.9094L209.994 11.2643L210.383 11.6516L211.971 11.7161L213.624 11.8452L215.926 11.5225L218.551 11.3611L220.432 11.4902L221.177 12.1033L220.853 12.7486L219.686 13.2004L217.514 13.5553L216.12 13.3295L212.295 13.5876L209.702 13.6199L207.887 13.4263L205.099 12.91L205.617 12.0065L206.298 11.2321L205.844 10.5222L203.575 10.3286L202.732 9.84457L203.964 9.19922L206.298 9.29602Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M181.76 8.45703L179.88 9.65093L178.161 10.1995L176.93 10.264L173.72 10.9416L171.419 11.1998L170.252 10.8448L174.045 9.65093L177.999 8.65064L179.782 8.6829L181.76 8.45703Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.078 8.64808L207.495 8.68034L205.355 8.58354L205.582 8.16406L207.916 8.19633L208.435 8.45447L208.078 8.64808Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M189.02 8.35731L186.167 8.80905L185.098 8.32504L186.751 7.84103L188.696 7.67969L190.025 7.90556L189.02 8.35731Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M191.549 7.00338L189.701 7.29379H187.756L188.08 7.06792L189.928 6.64844L190.479 6.71297L191.549 7.00338Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.719 7.81109L204.579 8.13376L204.061 7.77882L204.255 7.23027L204.968 6.61719L206.395 6.68172L206.946 6.77853L207.691 7.29481L206.719 7.81109Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.243 7.4247L201.887 8.03778L200.169 7.87644L198.872 7.39243L196.344 7.32789L198.062 6.90841L197.154 6.55347L197.867 5.97266L199.845 6.16626L202.276 6.71481L202.243 7.4247Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M219.783 5.45591L220.658 5.93992L218.551 6.3594L215.115 7.48877L212.911 7.58557L210.706 7.39196L210.188 6.77888L210.868 6.2626L212.262 5.87539H210.123L209.475 5.39138L209.604 4.77829L211.193 4.16521L212.522 3.74573L213.818 3.64893L213.721 3.32625L216.412 3.26172L216.93 3.9716L218.454 4.26201L220.01 4.55242L219.783 5.45591Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M245.456 0.937664L248.276 1.03447L250.448 1.1958L252.133 1.51848L251.777 1.84115L248.6 2.3897L245.683 2.64784L244.386 2.93825H246.817L243.413 3.74494L241.209 4.13215L238.194 5.26151L235.569 5.48739L234.564 5.81006L230.901 5.93913L232.327 6.13274L231.257 6.39088L231.484 7.13303L229.863 7.64931L227.627 8.06879L226.492 8.6496L224.353 9.13362L224.191 9.48856L226.298 9.42403L225.941 9.81124L221.824 10.747L219.069 10.2952L215.276 10.5534L213.655 10.3598L211.451 10.263L212.132 9.52083L214.725 9.16588L215.374 8.06879L216.216 7.97199L218.648 8.61734L218.096 7.64931L216.508 7.3589L218.129 6.77809L220.593 6.42314L221.5 5.90686L220.528 5.35832L220.884 4.64843L223.931 4.6807L224.645 4.84204L227.011 4.32575L224.645 4.16442L220.56 4.26122L219.134 3.80947L218.874 3.26093L218.064 2.87372L218.421 2.45424L220.366 2.1961L221.727 2.16383L224.126 1.97022L226.33 1.48621L227.594 1.55075L228.372 1.90569L229.993 1.26034L231.679 1.06673L233.786 0.937664L237.157 0.873129L237.579 1.0022L240.917 0.808594L243.186 0.873129L245.456 0.937664Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M335.314 63.7303L335.379 64.0852L335.152 64.5692L335.897 64.9564L336.74 65.021L336.643 65.8277L335.962 66.1826L334.73 65.9245L334.406 66.7312L333.628 66.7957L333.336 66.473L332.461 67.1829L331.651 67.2797L330.938 66.828L330.354 65.9567L329.576 66.2794V65.3436L330.743 64.2143L330.678 63.698L331.424 63.8916L331.845 63.5367H333.207L333.531 63.1172L335.314 63.7303Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M519.373 123.233L517.979 124.234L516.391 123.588L516.066 121.813L516.78 120.878L518.66 120.297L519.729 120.329L520.248 121.136L519.6 122.039L519.373 123.233Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M526.956 59.8617L529.873 61.3138L531.818 63.1853H534.282L535.124 62.4109L537.361 61.7978L537.782 63.637L537.685 64.3792L538.593 66.5734L538.787 68.574L536.551 68.219L535.611 68.9289L537.134 70.6713L538.398 73.0914L537.588 73.1237L538.204 74.1885L536.421 72.9623V74.124L534.346 74.9952L535.254 76.0923L533.763 75.9955L532.596 75.3501L532.239 76.8344L530.975 77.9315L530.294 79.2545L528.252 79.8353L527.474 80.8034L525.918 81.3842L526.34 80.4161L525.594 79.6095L526.242 78.222L524.784 77.1571L523.682 77.867L522.515 79.319L522.093 80.642L520.472 80.7388L520.051 81.7068L521.607 83.0943L523.163 83.4493L523.617 84.3528L525.27 84.9659L526.502 83.4816L528.414 84.2883L529.549 84.3528L530.294 85.4176L528.122 85.9984L527.798 87.1278L526.567 88.1604L526.275 89.6124L528.576 90.7418L530.067 92.7746L531.85 94.6784L533.633 96.2595L534.152 97.8083L533.244 98.3892L534.022 99.4863L535.286 100.132L535.546 101.81L535.578 103.455L534.671 103.649L533.99 105.875L533.244 108.618L532.142 111.07L530.067 112.974L527.928 114.749L525.951 114.975L525.011 115.878L524.265 115.233L523.455 116.233L521.121 117.298L519.241 117.588L519.014 119.783L518.009 119.912L517.296 118.395L517.587 117.621L515.059 116.943L514.281 117.298L512.368 116.749L511.363 115.91L511.461 114.717L509.743 114.329L508.738 113.555L507.409 114.652L505.691 114.91L504.264 114.878L503.389 115.394L502.514 115.685L503.162 118.072L502.19 118.008L501.93 117.524L501.768 116.653L500.536 117.266L499.694 116.878L498.235 116.104L498.494 114.394L497.295 113.974L496.517 112.071L494.702 112.426L494.475 109.973L495.836 108.231L495.544 106.521L495.123 104.939L494.248 104.455L493.373 103.229L492.368 103.391L490.39 103.068L490.779 102.197L489.612 100.906L488.575 101.777L486.987 101.293L485.236 102.584L483.972 104.133L482.61 104.391L481.703 103.842L480.763 103.778L479.369 103.326L478.526 103.842L477.683 105.391L477.197 103.746L476.192 104.197L474.085 103.971L471.978 103.52L470.357 102.584L468.898 102.197L468.088 101.196L467.018 100.906L464.944 99.5508L463.388 98.9054L462.772 99.3895L459.984 97.9374L457.974 96.6467L456.937 94.3557L458.266 94.6461L458.071 93.5813L457.099 92.5165L456.84 90.8386L454.344 88.3862L451.264 87.5795L450.324 85.9662L448.8 84.9981L448.314 84.4173L447.731 83.2557L447.569 82.449L446.369 81.965L445.883 82.1909L444.878 80.2548L445.235 79.8031L444.846 79.319L446.175 78.351L447.212 77.9315L449.092 78.222L449.287 76.899L451.361 76.6731L451.685 75.8342L453.922 74.7371L453.987 74.2853L453.436 73.0914L454.376 72.5751L451.523 69.0257L454.473 68.219L455.122 67.7673L454.797 64.121L458.298 64.7987L458.817 63.8629L458.007 61.8623L459.238 61.6687L459.854 60.3135L460.405 60.1521L461.475 61.5719L463.323 62.6367L465.981 63.3789L467.861 65.0245L468.315 67.3801L469.287 68.2836L471.394 68.6385L473.728 68.8966L476.322 70.1873L477.424 70.4132L479.045 72.2847L480.568 73.5109L482.383 73.4464L486.046 73.9304L488.121 73.64L489.936 73.9304L492.984 75.1888H494.993L496.063 75.8019L497.489 74.7048L499.823 73.9949L502.287 73.9304L503.875 73.2205L504.524 72.1234L505.302 71.4135L504.686 70.7359L503.746 69.9615L503.908 68.6385L504.945 68.8321L506.858 69.2516L507.895 68.1545L509.97 67.3801L510.391 66.0248L511.201 65.444L513.406 65.1859L514.832 65.4117L514.573 64.7019L512.239 63.2821L510.553 62.6367L509.743 63.3789L507.96 63.0562L507.214 63.3144L506.307 62.5077L506.209 60.4748L506.015 58.9582L508.414 59.7327L509.84 58.4742L509.224 57.5707L509.159 55.4733L509.581 54.828L508.77 53.7309L507.571 53.2791L508.122 52.2789L509.775 51.9239L511.785 51.8594L514.573 52.4725L516.518 53.1823L519.014 55.1829L520.245 56.0542L521.704 57.2803L523.714 59.2164L526.956 59.8617Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.865 140.431L310.675 140.883L310.999 141.593L311.81 142.012L312.458 141.496L313.301 141.431L314.565 141.948L315.051 144.916L314.273 146.626L313.787 148.982L314.565 150.757L314.5 151.596H313.657L312.393 151.208H311.194L309.022 151.596L307.758 152.176L305.942 152.951L305.586 152.886L305.715 151.176L305.91 150.918L305.845 150.111L305.067 149.24L304.483 149.111L303.965 148.53L304.354 147.594L304.192 146.594L304.257 146.013H304.548L304.678 145.11L304.548 144.69L304.71 144.4L305.391 144.174L304.937 142.496L304.516 141.657L304.678 140.947L305.035 140.786L305.294 140.592L305.78 140.915H307.206L307.531 140.334L307.855 140.367L308.373 140.141L308.665 141.012L309.087 140.754L309.865 140.431Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M347.758 146.558L346.851 148.656L346.397 149.011L346.267 150.624L346.462 151.495L346.3 152.108L347.175 153.205L347.337 153.948L348.018 155.012L348.86 155.69L348.958 156.626L349.152 157.239L349.023 158.336L347.564 157.852L346.073 157.303L343.771 157.239L343.544 157.11L342.442 157.368L341.34 157.11L340.465 157.239L337.45 157.207L337.742 155.561L336.996 154.173L336.153 153.851L335.797 152.915L335.311 152.625L335.343 152.044L335.797 150.559L336.672 148.559H337.191L338.293 147.333L338.974 147.3L340.011 148.172L341.275 147.462L341.437 146.591L341.859 145.752L342.118 144.719L343.09 143.88L343.447 142.428L343.836 141.944L344.095 140.879L344.549 139.556L346.073 137.943L346.17 137.265L346.364 136.878L345.619 136.071L345.684 135.394L346.17 135.297L346.915 136.62L347.078 137.975L347.013 139.363L348.05 141.234H347.013L346.494 141.363L345.651 141.17L345.262 142.138L346.364 143.364L347.175 143.719L347.434 144.558L348.018 145.977L347.758 146.558Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M369.968 151.079L371.102 152.789L371.945 153.047L372.431 152.693L373.274 152.822L374.279 152.402L374.733 153.273L376.386 154.661L376.289 157.081L377.034 157.371L376.418 158.081L375.738 158.662L375.025 159.727L374.636 160.695L374.538 162.341L374.117 163.147L374.084 164.696L373.566 165.277L373.501 166.503L373.242 166.664L373.047 167.826L373.501 168.762L373.533 169.084L373.144 172.408L373.631 173.57L373.306 174.441L373.89 175.925L374.992 177.055L375.219 178.184L375.738 178.732L375.64 179.087L375.349 178.991L372.853 179.345L372.366 179.604L371.815 180.927L372.204 181.83L371.848 184.282L371.556 186.348L372.042 186.735L373.306 187.541L373.825 187.154L373.89 189.381H372.496L371.783 188.251L371.135 187.348L369.741 187.057L369.352 185.993L368.217 186.638L366.791 186.348L366.175 185.412L365.04 185.218L364.165 185.25L364.068 184.605L363.452 184.573L362.609 184.444L361.475 184.766L360.697 184.702L360.243 184.896L360.372 182.443L359.789 181.669L359.659 180.378L359.951 179.12L359.595 178.345L359.562 177.022L357.358 177.055L357.52 176.312H356.58L356.483 176.667L355.348 176.764L354.862 177.958L354.57 178.474L353.565 178.184L352.982 178.474L351.75 178.636L351.069 177.571L350.648 176.893L350.129 175.635L349.708 174.118L344.294 174.086L343.646 174.312L343.095 174.279L342.349 174.57L342.09 173.925L342.544 173.699L342.608 172.795L342.933 172.279L343.581 171.827L344.067 172.053L344.716 171.246L345.72 171.279L345.818 171.859L346.498 172.214L347.601 170.924L348.67 169.923L349.124 169.246L349.092 167.536L349.902 165.535L350.745 164.47L351.944 163.47L352.171 162.825L352.204 162.05L352.495 161.34L352.398 160.146L352.625 158.307L352.982 157.016L353.533 155.919L353.63 154.661L353.792 153.209L354.505 152.176L355.478 151.499L357.001 152.209L358.168 152.983L359.497 153.177L360.891 153.596L361.41 152.338L361.669 152.176L362.512 152.37L364.554 151.337L365.267 151.789L365.851 151.724L366.143 151.208L366.823 151.047L368.185 151.273L369.384 151.305L369.968 151.079Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M353.631 154.659L353.534 155.917L352.982 157.014L352.626 158.305L352.399 160.144L352.496 161.338L352.204 162.048L352.172 162.822L351.945 163.468L350.746 164.468L349.903 165.533L349.093 167.534L349.125 169.244L348.671 169.921L347.601 170.922L346.499 172.212L345.819 171.857L345.721 171.277L344.716 171.244L344.068 172.051L343.582 171.825L342.901 171.115L342.35 171.47L341.604 172.374L340.113 170.179L341.507 169.018L340.826 167.663L341.475 167.146L342.707 166.888L342.836 165.952L343.841 166.953L345.462 167.05L346.013 166.081L346.24 164.694L346.045 163.081L345.17 161.854L345.981 159.434L345.527 159.047L344.165 159.208L343.647 158.144L343.776 157.24L346.078 157.305L347.569 157.853L349.028 158.337L349.157 157.24L350.13 155.304L351.2 154.207L352.464 154.562L353.631 154.659Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M189.44 137.527L188.241 137.882L187.722 138.915L186.977 139.495L186.393 140.27L186.101 141.754L185.518 142.98L186.458 143.109L186.653 144.045L187.042 144.529L187.139 145.336L186.912 146.11L186.944 146.562L187.398 146.723L187.787 147.433L190.153 147.24L191.223 147.498L192.455 149.305L193.201 149.079L194.53 149.176L195.567 148.95L196.215 149.305L195.826 150.402L195.405 151.112L195.21 152.596L195.567 153.984L196.053 154.597L196.118 155.048L195.178 156.081L195.826 156.533L196.313 157.275L196.831 159.34L196.475 159.598L196.15 158.372L195.632 157.694L195.016 158.436L191.45 158.372V159.663L192.52 159.889L192.455 160.695L192.098 160.469L191.061 160.792L191.029 162.309L191.872 163.083L192.163 164.245L192.131 165.148L191.418 170.827L190.478 169.73L189.927 169.698L191.061 167.568L189.635 166.6L188.533 166.794L187.852 166.439L186.847 166.987L185.486 166.697L184.351 164.535L183.508 164.019L182.925 163.018L181.693 162.05L181.207 162.244L180.429 161.76L179.521 161.082L179.002 161.405L177.446 161.115L176.993 160.211L176.636 160.243L174.821 159.082L174.594 158.436L175.274 158.275L175.21 157.243L175.663 156.468L176.571 156.339L177.382 155.048L178.095 153.951L177.446 153.467L177.835 152.273L177.479 150.37L177.9 149.821L177.673 148.079L176.96 146.949L177.252 145.949L177.835 146.11L178.192 145.497L177.835 144.271L178.062 143.981L179.002 144.045L180.461 142.593L181.239 142.367L181.271 141.69L181.725 139.915L182.827 138.979L183.962 138.915L184.156 138.495L185.583 138.656L187.074 137.624L187.82 137.172L188.76 136.172L189.408 136.301L189.829 136.849L189.44 137.527Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M166.814 139.268L167.203 140.398L167.852 141.237L168.662 142.108L167.949 142.301L167.917 143.14L168.273 143.431L167.981 143.689L168.046 144.044L167.852 144.463L167.755 144.883L166.782 144.431L166.425 143.979L166.652 143.624L166.62 143.173L166.134 142.689L165.421 142.269L164.837 142.011L164.74 141.398L164.286 141.043L164.351 141.624L163.962 142.14L163.573 141.559L163.022 141.333L162.795 140.946L162.827 140.301L163.119 139.656L162.633 139.365L163.087 138.946L163.378 138.688L164.545 139.236L164.967 138.978L165.55 139.139L165.81 139.559L166.361 139.72L166.814 139.268Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M176.603 114.778L177.219 115.521L178.904 115.295L179.488 115.779L180.849 117.069L181.887 118.005L182.47 117.973L183.508 118.392L183.313 118.973L184.61 119.07L185.874 119.909L185.615 120.393L184.383 120.651L183.151 120.748L181.952 120.587L179.326 120.78L180.687 119.651L180.007 119.102L178.84 118.973L178.289 118.36L178.029 117.199L176.992 117.263L175.371 116.715L174.885 116.263L172.583 115.94L172 115.553L172.745 115.037L170.995 114.94L169.569 116.005L168.823 116.037L168.499 116.553L167.591 116.779L166.846 116.553L167.883 115.94L168.369 115.166L169.244 114.714L170.217 114.327L171.611 114.133L172.065 113.875L173.588 114.036L175.015 114.069L176.603 114.778Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M343.513 56.5323L344.324 57.1776L345.523 57.339L345.458 57.8875L346.366 58.307L346.56 57.7907L347.663 58.0166L347.889 58.6619L349.089 58.7587L349.932 59.759H349.445L349.219 60.114L348.862 60.2108L348.797 60.6625L348.505 60.7593L348.473 60.9529L347.954 61.1465L347.241 61.1143L347.047 61.566L346.269 61.1788L345.523 61.2756L344.226 60.6625L343.675 60.8238L342.833 61.6628L341.601 60.9852L340.628 60.1462L339.785 59.6622L339.559 58.791L339.234 58.2102L340.337 57.7907L340.888 57.2744L342.022 56.8872L342.379 56.5L342.8 56.7259L343.513 56.5323Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M341.633 51.2745L342.086 52.2748L341.697 52.8234L342.313 53.501L342.799 54.5658L342.735 55.2757L343.513 56.5341L342.799 56.7277L342.378 56.5019L342.021 56.8891L340.887 57.2763L340.336 57.7926L339.234 58.212L339.558 58.7928L339.785 59.6641L340.628 60.1481L341.6 60.987L341.081 61.9228L340.53 62.1809L340.855 63.5039L340.725 63.8589L340.174 63.4394L339.396 63.3748L338.261 63.7298L336.835 63.633L336.64 64.1815L335.765 63.633L335.311 63.7298L333.529 63.1167L333.204 63.5362H331.843L331.973 62.0841L332.751 60.7289L330.417 60.3417L329.639 59.8254L329.703 58.9542L329.379 58.5024L329.509 57.1472L329.152 55.0498H330.092L330.481 54.3077L330.773 52.5007L330.481 51.8231L330.741 51.4036L332.037 51.3068L332.362 51.7263L333.366 50.7582L332.945 50.0161L332.815 48.919L334.015 49.1771L334.955 48.8867L335.052 49.6289L336.64 50.0806L336.673 50.7905L338.196 50.4033L339.039 49.887L340.855 50.6614L341.633 51.2745Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M398.557 138.17L397.941 139.3L397.52 138.912L397.098 139.074L396.061 139.041L395.996 138.396L395.834 137.815L396.417 136.847L397.033 135.944L397.811 136.137L398.362 135.621L398.816 136.266L398.784 137.105L397.779 137.622L398.557 138.17Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M339.107 47.6604L338.329 49.2416L336.643 48.1122L336.352 47.3055L338.556 46.6602L339.107 47.6604Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M334.958 48.8877L334.018 49.1781L332.818 48.9199L332.137 47.8228L332.008 45.8545L332.202 45.306L332.624 44.7252L333.92 44.6283L334.439 44.0798L335.606 43.5312V44.5315L335.217 45.1769L335.444 45.6932L336.287 45.9836L335.963 46.7257L335.509 46.5321L334.504 47.9196L334.958 48.8877Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M189.865 124.55L189.962 123.969L189.541 123.356L190.027 123.001L190.254 122.194L190.222 121.097L190.481 120.742H191.875L192.912 121.258L193.399 121.226L193.625 121.968L194.63 121.904L194.501 122.517L195.311 122.614L196.121 123.356L195.376 124.195L194.533 123.743L193.69 123.84L193.107 123.743L192.75 124.13L192.037 124.259L191.81 123.743L191.194 124.033L190.319 125.453L189.898 125.131L189.865 124.55Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M334.211 85.3823L333.887 86.4471L334.211 88.4154L333.854 90.1256L332.817 91.2872L333.012 92.8361L334.47 94.0945L334.503 94.5785L335.605 95.4175L336.448 99.1283L337.064 100.968L337.193 101.936L336.934 103.613L337.064 104.581L336.869 105.711L337.064 107.002L336.35 107.873L337.453 109.389L337.517 110.261L338.198 111.422L339.009 111.035L340.467 112.003L341.278 113.294L335.184 117.263L329.997 121.328L327.468 122.232L325.459 122.458L325.426 121.135L324.583 120.78L323.449 120.199L323.027 119.231L316.966 114.713L310.936 110.196L304.291 105.162L304.323 104.775L304.356 104.646L304.388 102.194L307.273 100.645L309.024 100.322L310.482 99.7736L311.163 98.741L313.238 97.9344L313.335 96.3855L314.34 96.1919L315.15 95.4498L317.452 95.0948L317.776 94.2881L317.322 93.8364L316.706 91.6422L316.609 90.3838L315.993 89.0608L317.646 87.9314L319.527 87.5765L320.596 86.7375L322.249 86.0922L325.167 85.7372L328.02 85.5759L328.895 85.8663L330.483 85.0596L332.331 85.0273L333.044 85.5114L334.211 85.3823Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M181.206 162.244L181.466 163.825L180.915 165.148L178.937 167.343L176.765 168.149L175.663 169.956L175.371 171.344L174.367 172.215L173.556 171.15L172.811 170.924L172.065 171.086L171.968 170.343L172.486 169.859L172.26 168.988L173.2 167.439L172.778 166.536L172.097 167.504L170.963 166.568L171.319 165.987L170.995 164.116L171.644 163.793L171.968 162.502L172.649 161.179L172.551 160.34L173.556 159.889L174.82 159.082L176.636 160.244L176.992 160.211L177.446 161.115L179.002 161.405L179.521 161.083L180.428 161.76L181.206 162.244Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M379.95 97.251L381.214 100.284L381.441 100.8L381.019 101.639L380.793 103.188L380.404 104.285L380.015 104.64L379.366 103.963L378.491 103.059L376.967 100.091L376.805 100.284L377.713 102.446L378.977 104.543L380.566 107.77L381.311 108.9L381.96 110.061L383.71 112.352L383.386 112.707L383.515 114.062L385.72 115.934L386.076 116.353H378.912H371.943H364.714L364.39 108.706L363.969 101.349L363.32 99.671L363.677 98.4126L363.353 97.5091L363.904 96.5088L366.238 96.4766L367.988 97.0251L369.771 97.6382L370.614 97.9609L371.911 97.3155L372.591 96.7347L374.115 96.5411L375.379 96.7992L375.963 97.8318L376.319 97.1542L377.745 97.6382L379.139 97.7673L379.95 97.251Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M398.362 135.619L397.811 136.136L397.033 135.942L396.385 135.264L395.574 134.071L394.732 133.393L394.245 132.683L392.625 131.844L391.36 131.812L390.907 131.392L389.869 131.876L388.702 130.941L388.216 132.489L386.077 132.038L385.85 131.231L386.498 128.166L386.595 126.81L387.146 126.165L388.443 125.81L389.318 124.648L390.485 127.036L391.101 128.94L392.138 129.94L394.732 131.909L395.801 133.07L396.839 134.296L397.422 135.006L398.362 135.619Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M361.017 40.2035L361.309 40.5261L360.466 41.6232L361.244 43.4302L360.725 44.0433L359.494 44.011L358.067 43.3011L357.387 43.0753L356.155 43.3979L356.122 42.2686L355.636 42.5267L354.566 41.8491L354.242 40.752L356.025 40.2035L357.84 39.9453L359.494 40.2357L361.017 40.2035Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M391.358 131.817L392.622 131.849L394.243 132.688L394.729 133.398L395.572 134.075L396.382 135.269L397.031 135.947L396.415 136.85L395.831 137.818L395.993 138.399L396.058 139.044L397.095 139.077L397.517 138.915L397.938 139.303L397.549 140.012L398.262 141.174L398.976 142.174L399.689 142.917L405.75 145.369L407.306 145.337L402.25 151.564L399.883 151.661L398.262 153.113L397.095 153.145L396.609 153.823H395.345L394.599 153.113L392.914 153.984L392.395 154.856L391.163 154.662L390.742 154.436L390.32 154.501L389.737 154.468L387.403 152.726H386.106L385.49 152.048L385.458 150.887L384.518 150.532L383.383 148.273L382.541 147.789L382.216 146.95L381.244 145.95L380.109 145.788L380.725 144.627L381.698 144.562L381.957 143.949L381.892 142.336V142.078L382.378 139.916L383.221 139.335L383.383 138.496L384.129 136.883L385.199 135.882L385.847 133.817L386.074 132.042L388.213 132.494L388.7 130.945L389.867 131.881L390.904 131.397L391.358 131.817Z",
      "fill": "#EBECED",
      "stroke": "#FCFCFD",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M357.907 22.6225L358.036 23.8487L360.403 25.0426L359.463 26.3978L361.57 28.4307L361.019 29.9795L362.607 31.3348L362.315 32.5609L364.714 33.8194L364.422 34.7551L363.32 35.8522L360.727 38.24L358.134 38.4014L355.67 39.079L353.368 39.4985L352.331 38.4659L350.808 37.8528L350.84 35.9813L349.868 34.3034L350.386 33.2063L351.456 32.0769L354.308 30.0763L355.151 29.6891L354.86 28.9147L352.753 28.0757L352.169 27.3659L351.586 24.6231L349.252 23.4292L347.307 22.558L348.02 22.1063L349.673 23.0097L351.391 22.9452L352.915 23.3647L354.017 22.5903L354.373 21.2996L356.286 20.7188L358.166 21.3964L357.907 22.6225Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M343.774 157.238L343.644 158.142L344.163 159.207L345.524 159.045L345.978 159.433L345.168 161.853L346.043 163.079L346.237 164.692L346.01 166.08L345.459 167.048L343.838 166.951L342.834 165.951L342.704 166.886L341.472 167.145L340.824 167.661L341.504 169.016L340.111 170.178L338.23 168.08L337.031 166.37L335.896 164.241L335.961 163.531L336.383 162.885L336.804 161.369L337.193 159.82L337.809 159.723H340.467V157.238L341.342 157.109L342.445 157.368L343.547 157.109L343.774 157.238Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.125 51.0491L308.99 50.6619L308.018 50.6942L308.407 49.6294L308.115 48.5968L309.411 48.5L311 49.7262L310.125 51.0491Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M315.281 41.7891L313.628 43.8865L315.151 43.6283H316.805L316.383 45.2094L314.989 46.9519L316.578 47.0487L316.675 47.2745L318.037 49.5655L319.074 49.8882L320.014 52.1469L320.468 52.9214L322.38 53.2763L322.186 54.567L321.408 55.1478L322.024 56.1804L320.597 57.2129L318.49 57.1807L315.767 57.7615L315.054 57.342L313.985 58.2778L312.526 58.0519L311.359 58.8263L310.548 58.4391L312.915 56.3417L314.341 55.89L311.877 55.5673L311.456 54.7606L313.109 54.1475L312.299 53.0827L312.623 51.792L314.925 51.9856L315.184 50.824L314.179 49.6301L314.147 49.5978L312.299 49.2429L311.942 48.7266L312.526 47.8554L312.04 47.3068L311.197 48.2426L311.164 46.3388L310.451 45.3708L311.067 43.3702L312.299 41.8213L313.466 41.9504L315.281 41.7891Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M394.085 73.5393L395.739 73.9588L396.419 74.7978L397.586 75.2818L397.197 75.5399L398.267 76.6693L398.072 76.8951L397.132 76.7983L395.771 76.1853L395.414 76.5402L393.145 76.8629L391.33 75.8303L389.547 75.9271L389.644 75.0559L388.964 73.6684L387.861 72.894L386.889 72.6681L386.176 72.055L386.305 71.7969L387.797 72.1518L390.293 72.4745L392.756 73.4748L393.145 73.862L394.085 73.5393Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M319.784 139.107L319.654 139.752L320.4 140.817V142.333L320.594 143.947L321.048 144.721L320.627 146.56L320.789 147.593L321.275 148.916L321.697 149.658L318.812 150.852L317.774 151.562L316.121 152.175L314.5 151.594L314.565 150.755L313.787 148.981L314.273 146.625L315.051 144.915L314.565 141.946L314.306 140.397L314.371 139.203L317.547 139.107L318.358 139.268L318.941 138.945L319.784 139.107Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M298.718 136.138L298.815 136.912H299.107L299.593 136.622L299.885 136.687L300.403 137.235L301.181 137.396L301.667 136.945L302.283 136.654L302.705 136.364L303.061 136.428L303.483 136.88L303.677 137.461L304.423 138.332L304.066 138.849L303.969 139.526L304.358 139.333L304.585 139.558L304.488 140.172L305.039 140.785L304.682 140.946L304.52 141.656L304.941 142.495L305.395 144.173L304.715 144.399L304.552 144.689L304.682 145.108L304.552 146.012H304.261L303.742 145.947L303.385 146.786H302.867L302.51 146.335L302.64 145.496L301.862 144.237L301.408 144.463L300.987 144.528L300.5 144.624L300.533 143.882L300.241 143.334L300.306 142.721L299.917 141.849L299.398 141.107H297.94L297.518 141.494L297 141.559L296.675 142.011L296.481 142.559L295.476 143.495L294.698 142.269L293.985 141.462L293.531 141.172L293.077 140.752L292.883 139.849L292.623 139.397L292.072 139.042L292.915 138.042L293.466 138.074L293.952 137.751L294.341 137.719L294.633 137.461L294.503 136.783L294.698 136.558L294.73 135.848L295.606 135.88L296.935 136.364L297.324 136.332L297.453 136.106L298.458 136.267L298.718 136.138Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M289.023 134.685L289.283 133.749L291.26 133.717L291.682 133.2L292.265 133.168L292.978 133.684H293.529L294.145 133.362L294.502 133.942L293.691 134.426L292.913 134.362L292.135 133.942L291.455 134.426H291.13L290.677 134.717L289.023 134.685Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M294.727 135.847L294.695 136.557L294.5 136.783L294.63 137.46L294.338 137.718L293.949 137.751L293.463 138.073L292.912 138.041L292.069 139.041L291.129 138.202L290.351 138.041L289.93 137.46L289.962 137.137L289.411 136.718L289.281 136.266L290.254 135.944L290.87 136.008L291.356 135.75L294.727 135.847Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M340.469 157.243V159.728H337.81L337.194 159.825L336.838 159.534L337.454 157.211L340.469 157.243Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M360.693 87.9648L361.698 88.6747L363.027 88.5457L364.324 88.6747V89.0619L365.231 88.8038L365.069 89.4169L362.605 89.5782L362.573 89.2555L360.434 88.8361L360.693 87.9648Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M363.675 77.4128L362.638 77.3482L361.763 77.1546L359.753 77.6709L361.049 78.8326L360.239 79.1875H359.299L358.294 78.1227L358.002 78.5744L358.521 79.8006L359.461 80.7686L358.845 81.2203L359.882 82.1561L360.79 82.7692L360.92 83.9308L359.299 83.3823L359.882 84.4471L358.813 84.6407L359.623 86.48L358.489 86.5122L356.997 85.6087L356.22 83.9631L355.798 82.5756L355.053 81.6398L354.08 80.4459L353.918 79.8651L354.631 78.8648L354.664 78.1872L355.215 77.8968L355.182 77.3482L356.284 77.1869L356.868 76.7352L357.775 76.7674L358.035 76.4125L358.359 76.348L359.591 76.4125L360.887 75.8317L362.152 76.5738L363.643 76.3802L363.546 75.3477L364.421 75.8962L364.064 77.1869L363.675 77.4128Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M290.549 0.453289L296.999 1.42131L294.828 1.87306L290.614 1.9376L284.617 2.06667L285.07 2.29254L289.058 2.1312L292.202 2.58295L294.471 2.19574L295.249 2.64748L293.79 3.4219L296.773 2.90562L302.316 2.42161L305.557 2.67975L306.108 3.2283L301.311 4.16406L300.598 4.48673L296.902 4.74487L299.528 4.80941L297.94 5.84197L296.773 6.77773L296.384 8.45564L297.583 9.4882L295.67 9.52047L293.563 10.0367L295.606 10.8757L295.573 12.2309L294.212 12.3923L295.541 13.7798L292.721 13.9089L294.017 14.5542L293.499 15.135L291.651 15.3932L289.868 15.4254L291.229 16.5225L291.067 17.2969L288.701 16.5871L287.923 17.0388L289.544 17.4583L291.035 18.4908L291.229 19.8783L288.831 20.201L287.955 19.5234L286.594 18.5554L286.756 19.717L285.006 20.6205L288.474 20.685L290.257 20.7818L286.399 22.2984L282.445 23.6859L278.328 24.2667L276.837 24.299L275.248 24.9766L272.817 26.8481L269.511 28.1066L268.538 28.2034L266.561 28.6228L264.421 29.0746L262.865 30.1717L262.412 31.4624L261.309 32.6886L258.522 34.1729L258.619 35.6249L257.452 37.1737L256.123 39.013L254.016 39.1421L252.395 37.5932L249.478 37.561L248.44 36.5284L248.181 34.7214L246.625 32.3981L246.398 31.2042L246.884 29.5586L245.685 27.913L246.755 26.59L246.139 25.9446L248.408 23.8795L250.742 23.2019L251.585 22.492L252.492 21.1368L250.709 21.7499L249.867 22.008L248.538 22.2339L247.176 21.6853L247.662 20.4914L248.635 19.5879L249.867 19.5557L252.33 20.0397L250.612 18.9426L249.737 18.3618L248.311 18.5876L247.468 18.1682L249.737 16.6193L249.315 15.974L248.959 14.8446L248.505 13.1022L247.338 12.4891L247.792 11.8115L245.166 10.8757L242.67 10.7466L239.396 10.8112L236.317 10.9402L235.312 10.424L234.08 9.42366L237.646 8.93965L240.109 8.87512L235.377 8.45564L233.27 7.84255L233.983 7.26174L239.072 6.55185L243.934 5.84197L244.842 5.32569L242.216 4.80941L243.708 4.26086L248.473 3.3251L250.223 3.19603L250.288 2.61521L253.205 2.26027L256.771 2.06667H260.142L261.05 2.45388L264.486 1.74399L266.788 2.228L268.279 2.32481L270.289 2.74428L268.117 2.06667L268.635 1.51812L272.752 0.808232L276.513 0.872767L278.166 0.421021L282.023 0.324219L290.549 0.453289Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M158.225 125.04L157.998 126.686L157.577 129.009H158.128L158.679 129.396L158.873 129.074L159.36 129.332L158.452 130.138L157.512 130.719L157.35 131.106L157.447 131.526L157.026 132.042L156.572 132.171L156.669 132.429L156.28 132.655L155.632 133.172L155.534 133.462L154.627 133.107L153.492 133.075L152.714 132.655L151.807 131.816L151.936 131.203L152.196 130.719L151.969 130.332L153.038 128.654H155.372L155.502 127.944L155.243 127.815L155.081 127.363L154.465 126.879L153.881 126.202L154.692 126.169L154.854 125.008H156.539L158.225 125.04Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M214.888 149.559L214.564 151.431L213.43 151.947L213.527 152.431L213.17 153.528L213.948 155.012H214.532L214.759 156.174L215.829 157.981L215.407 158.078L214.37 157.884L213.786 158.433L212.943 158.788L212.36 158.884L212.165 159.304L211.258 159.207L210.123 158.239L210.026 157.271L209.572 156.206L209.896 154.464L210.415 153.722L210.026 152.754L209.378 152.463L209.637 151.527L209.248 151.076L208.276 151.14L207.076 149.591L207.595 149.01V148.042L208.729 147.72L209.183 147.333L208.6 146.558L208.762 145.816L210.285 144.59L211.452 145.364L212.522 146.687L212.554 147.784L213.235 147.817L214.208 148.817L214.888 149.559Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.438 130.846L167.822 130.814L167.53 131.105L166.882 131.363H166.428L166.007 131.621L165.65 131.556L165.358 131.234L165.164 131.298L164.872 131.782L164.71 131.75L164.645 132.202L163.964 132.75L163.575 133.008L163.381 133.266L162.895 132.847L162.441 133.396H162.052L161.63 133.428L161.566 134.46H161.306L161.047 134.944L160.463 135.041L160.204 134.396L159.653 134.202L159.88 133.363L159.653 133.137L159.264 133.008L158.454 133.234L158.421 132.976L157.903 132.621L157.546 132.234L157.027 132.04L157.449 131.524L157.352 131.105L157.514 130.717L158.454 130.136L159.361 129.33L159.556 129.427L159.977 129.072L160.496 129.039L160.658 129.201L160.95 129.104L161.793 129.298L162.635 129.233L163.219 129.007L163.478 128.781L164.029 128.878L164.451 129.007L164.937 128.975L165.326 128.781L166.136 129.072L166.396 129.136L166.914 129.523L167.4 129.975L168.016 130.298L168.438 130.846Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M350.582 66.9869L351.068 67.7936L351.619 68.3744L351.068 69.1488L350.29 68.697L349.156 68.7293L347.697 68.3744L346.952 68.4066L346.627 68.8584L345.979 68.3744L345.72 69.2133L346.595 70.1814L347.016 70.7944L347.827 71.5689L348.507 72.0206L349.188 72.8918L350.744 73.6662L350.582 73.9889L348.961 73.2468L347.924 72.5046L346.368 71.8915L344.844 70.4072L345.169 70.2459L344.358 69.3747L344.261 68.697L343.191 68.3744L342.737 69.2456L342.219 68.568V67.8581L342.251 67.8258L343.418 67.8904L343.677 67.5677L344.261 67.8904L344.909 67.9226L344.877 67.3741L345.428 67.1482L345.525 66.3415L346.789 65.793L347.308 66.0511L348.605 66.9223L349.999 67.3095L350.582 66.9869Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.217 121.099L190.25 122.196L190.023 123.003L189.537 123.358L189.958 123.971L189.861 124.552L188.694 124.197L187.819 124.326L186.716 124.197L185.841 124.584L184.934 123.939L185.161 123.261L186.814 123.551L188.143 123.713L188.856 123.261L188.11 122.358L188.24 121.551L187.105 121.228L187.592 120.68L188.694 120.744L190.217 121.099Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M355.343 61.9195L356.315 62.468L356.477 63.0166L355.537 63.4361L354.921 64.7913L354.079 66.1788L352.814 66.566L351.777 66.4692L350.578 66.9855L349.994 67.3082L348.6 66.9209L347.304 66.0497L346.785 65.7916L346.396 65.114L346.137 65.0817L346.558 63.791L346.202 63.3392H347.109L347.174 62.5003L348.049 63.0488L348.665 63.2424L349.994 63.0166L350.091 62.5971L350.707 62.5326L351.453 62.2421L351.647 62.3712L352.393 62.1131L352.717 61.6291L353.236 61.5L355.019 62.1131L355.343 61.9195Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M540.539 183.152L539.761 183.184L537.459 181.732L539.209 181.312L540.117 181.958L540.701 182.571L540.539 183.152Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M548.579 180.344L548.741 180.763L548.709 181.376L547.38 182.925L545.759 183.377L545.564 183.151L545.791 182.441L546.699 181.183L548.579 180.344Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M535.744 178.703L536.36 179.252L537.527 179.09L537.916 179.962L535.744 180.381L534.48 180.671L533.475 180.639L534.188 179.445H535.225L535.744 178.703Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M544.915 178.703L544.559 179.865L541.771 180.446L539.34 180.187L539.405 179.413L540.896 178.994L541.998 179.607L543.23 179.445L544.915 178.703Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M518.918 175.955L522.419 176.181L522.872 175.31L526.211 176.31L526.795 177.666L529.518 178.053L531.69 179.279L529.55 180.053L527.573 179.214L525.92 179.279L524.039 179.118L522.354 178.763L520.279 177.956L518.95 177.762L518.172 178.021L514.866 177.149L514.606 176.278L512.953 176.117L514.315 174.148L516.519 174.277L517.945 175.084L518.723 175.246L518.918 175.955Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M566.864 174.792L565.827 176.212L565.762 174.663L566.118 173.921L566.54 173.211L566.929 173.824L566.864 174.792Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M553.441 169.084L552.728 169.794L551.496 169.407L551.172 168.503L553.02 168.406L553.441 169.084Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M559.408 168.34L559.991 169.921L558.5 169.05L556.977 168.888L555.907 169.017L554.643 168.953L555.129 167.823L557.398 167.727L559.408 168.34Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M578.789 167.31L578.465 174.053L577.946 180.83L576.455 179.119L574.639 178.7L574.153 179.281L571.819 179.345L572.727 177.667L573.926 177.087L573.602 174.828L572.857 173.118L569.388 171.343L567.897 171.182L565.206 169.246L564.623 170.278L563.91 170.44L563.553 169.697L563.586 168.794L562.224 167.761L564.234 167.019L565.531 167.051L565.401 166.503H562.71L561.997 165.277L560.376 164.89L559.631 163.857L562.094 163.373L563.035 162.695L565.984 163.534L566.276 164.309L566.698 167.665L568.545 168.891L570.166 166.696L572.306 165.47H573.926L575.482 166.18L576.811 166.922L578.789 167.31Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M549.912 158.987L548.453 161.052L547.059 161.439L545.309 161.052L542.229 161.149L540.641 161.439L540.382 163.02L542.002 164.86L543.007 163.924L546.443 163.214L546.281 164.15L545.471 163.859L544.66 165.085L543.007 165.892L544.66 168.538L544.304 169.248L545.86 171.636L545.763 172.991L544.758 173.604L544.077 172.862L545.049 171.184L543.202 171.991L542.78 171.41L543.04 170.603L541.775 169.377L542.002 167.376L540.738 167.99L540.803 170.41L540.738 173.378L539.539 173.669L538.793 173.088L539.409 171.184L539.215 169.183L538.437 169.151L537.918 167.731L538.728 166.376L539.02 164.731L539.993 161.601L540.349 160.762L541.905 159.213L543.364 159.826L545.665 160.116L547.772 160.019L549.588 158.535L549.912 158.987Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M556.261 159.599L556.164 161.406L555.224 161.181L554.932 162.439L555.677 163.536L555.159 163.794L554.446 162.471L553.895 159.825L554.219 158.18L554.802 157.438L554.964 158.567L556.066 158.728L556.261 159.599Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M521.254 157.755L521.579 159.143L522.843 160.336L524.042 159.917L525.209 160.046L526.279 159.013L527.154 158.82L528.905 159.401L530.396 158.949L531.239 156.077L531.919 155.367L532.47 153.012H534.577L536.198 153.367L535.226 155.238L536.652 157.174L536.36 158.142L538.435 160.046L536.263 160.304L535.68 161.724L535.744 163.595L533.962 165.015L533.832 167.08L533.022 170.243L532.795 169.5L530.655 170.436L529.974 169.178L528.678 169.049L527.77 168.371L525.566 169.145L524.95 168.113L523.718 168.242L522.227 168.016L522.032 165.241L521.125 164.66L520.25 162.886L519.99 161.079L520.185 159.143L521.254 157.755Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M513.863 174.049L511.853 174.082L510.394 172.371L508.092 170.661L507.347 169.403L506.018 167.725L505.143 166.176L503.781 163.272L502.193 161.53L501.642 159.755L500.929 158.141L499.243 156.851L498.238 155.076L496.812 153.914L494.802 151.623L494.607 150.559L495.774 150.655L498.659 151.043L500.345 153.075L501.836 154.495L502.874 155.334L504.656 157.561L506.537 157.593L508.092 159.013L509.195 160.755L510.589 161.723L509.843 163.401L510.913 164.111L511.561 164.175L511.853 165.628L512.469 166.757L513.798 166.951L514.641 168.273L514.089 170.855L513.863 174.049Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M462.771 99.386L461.863 100.354L461.571 102.29L463.452 103.065L465.332 104.065L467.86 105.226L470.356 105.517L471.588 106.549L472.982 106.743L475.219 107.227L476.71 107.195L476.742 106.388L476.256 105.065L476.191 104.194L477.196 103.742L477.682 105.388L477.812 105.775L479.595 106.582L480.632 106.259L482.156 106.388L483.614 106.324L483.452 105.065L482.61 104.388L483.971 104.129L485.235 102.581L486.986 101.29L488.574 101.774L489.611 100.903L490.778 102.193L490.389 103.065L492.367 103.387L492.691 104.162L492.14 104.549L492.594 105.807L491.232 105.452L489.222 106.872L489.514 108.066L488.866 109.808L488.963 110.809L488.444 112.519L486.953 112.035L487.245 114.197L486.921 114.907L487.245 115.778L486.435 116.262L485.008 112.971H484.522L484.425 114.326L483.258 113.229L483.647 112.067L484.425 111.938L484.943 110.196L483.841 109.841L482.188 109.873L480.438 109.583L480.049 108.131L479.173 108.034L477.585 107.13L477.196 108.55L478.687 109.647L477.715 110.422L477.423 111.164L478.622 111.712L478.525 112.971L479.368 114.52L479.887 116.23L479.724 117.004L478.493 116.972L476.353 117.391L476.645 118.94L475.867 120.166L473.436 121.586L471.718 124.006L470.486 125.329L468.865 126.684L468.962 127.62L468.12 128.136L466.564 128.879L465.721 128.975L465.332 130.556L465.948 133.267L466.175 134.977L465.559 136.945L465.786 140.463L464.845 140.559L464.1 142.141L464.716 142.85L463.063 143.431L462.512 144.819L461.798 145.432L459.983 143.496L458.978 140.592L458.168 138.494L457.455 137.526L456.353 135.526L455.704 132.944L455.25 131.654L453.338 128.814L452.203 124.781L451.36 122.135L451.101 119.618L450.55 117.682L448.054 118.94L446.757 118.682L444.132 116.165L444.91 115.423L444.294 114.616L441.992 112.842L443.029 111.454H446.952L446.368 109.679L445.234 108.647L444.78 107.033L443.483 106.13L445.072 103.936L447.179 104.097L448.637 101.935L449.351 99.8378L450.615 97.7404L450.291 96.2561L451.523 95.0622L449.869 94.0619L448.929 92.6421L447.859 90.8351L448.508 89.9317L451.263 90.4479L453.111 90.1253L454.343 88.3828L456.839 90.8351L457.098 92.5131L458.071 93.5779L458.265 94.6427L456.936 94.3523L457.973 96.6433L459.983 97.934L462.771 99.386Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.122 51.0461L310.348 52.4659L309.084 54.2406L306.232 55.4022L304.027 55.1118L305.421 53.0467L304.74 51.0461L306.912 49.4972L308.112 48.5938L308.404 49.6263L308.015 50.6911L308.987 50.6589L310.122 51.0461Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M398.394 81.7047L398.977 81.6402L400.695 80.1236L401.311 79.9623L401.927 80.5754L401.538 81.5757L402.802 82.6728L403.224 82.5437L404.034 84.0925L405.752 84.512L407.146 85.5446L409.642 85.8995L412.235 85.351L412.3 84.867L413.727 84.4797L414.699 83.2858L415.866 83.3504L416.514 82.9632L417.779 83.1568L419.918 84.2216L421.312 84.4475L423.678 86.2545L424.975 86.3513L425.526 88.0614L425.332 90.6428L425.17 92.1594L425.98 92.4821L425.461 93.6115L426.336 95.2571L426.725 96.5801L428.119 96.935L428.476 98.258L427.212 100.129L428.249 101.227L429.157 102.485L431.004 103.389L431.329 105.195L432.204 105.55L432.496 106.486L430.064 107.583L429.708 109.971L426.272 109.358L424.262 108.874L422.22 108.616L421.15 106.067L420.242 105.712L418.913 106.067L417.26 107.067L414.991 106.389L413.013 104.776L411.231 104.195L409.804 102.227L408.119 99.4841L407.211 99.8068L406.012 99.1292L405.461 99.9359L404.326 98.8388L404.164 97.7417H403.613L403.678 96.2251L402.543 94.6763L400.242 93.5146L398.75 91.5463L398.913 89.933L399.658 89.2231L399.366 88.0292L398.135 87.3838L396.611 84.9315L395.379 83.2858L395.606 82.6405L394.666 80.285L395.736 79.6719L396.125 80.4786L397.162 81.4143L398.394 81.7047Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M396.608 84.9322L398.131 87.3845L399.363 88.0299L399.655 89.2238L398.909 89.9337L398.747 91.5471L400.238 93.5154L402.54 94.677L403.674 96.2259L403.61 97.7424H404.161L404.323 98.8395L405.457 99.9366L404.388 99.8398L403.188 99.6462L402.118 101.647L398.812 101.485L393.366 97.323L390.578 95.8709L388.374 95.2901L387.369 92.7732L390.935 90.6113L391.259 88.1267L390.87 86.6101L391.745 86.0938L392.426 84.8031L393.107 84.4805L395.149 84.7709L395.83 85.2872L396.608 84.9322Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M299.78 27.2697L299.326 28.4313L300.752 29.6575L298.775 31.045L294.529 32.3034L293.264 32.6584L291.449 32.368L287.592 31.7872L289.147 30.9805L286.23 30.1092L288.791 29.7543L288.823 29.2057L285.971 28.7863L287.138 27.5924L289.277 27.3342L291.222 28.5604L293.491 27.5924L295.144 28.0764L297.511 27.1406L299.78 27.2697Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M382.218 92.9922L382.348 93.8311L382.154 94.1538H382.186L381.959 94.7992L381.278 94.541L381.051 95.8963L381.538 96.1221L381.116 96.4125L381.084 96.9611L381.894 96.703L382.024 97.5096L381.44 100.801L381.213 100.285L379.949 97.2515L380.403 96.5739L380.273 96.4448L380.63 95.4768L380.824 93.9279L381.019 93.3794H381.051H381.635L381.765 93.0244L382.218 92.9922Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.266 82.7344L345.715 84.38L346.007 84.9931L345.715 86.0579L344.353 85.2835L343.478 85.0576L341.047 84.0251L341.209 82.9603L343.219 83.1539L344.969 82.928L346.266 82.7344Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M335.247 76.6055L336.316 78.0575L336.187 80.8002L335.409 80.6712L334.728 81.3488L334.08 80.8002L333.917 78.3156L333.496 77.154L334.436 77.2508L335.247 76.6055Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M342.285 65.7926L342.155 66.7929L342.609 67.6641L341.28 67.3414L340.016 68.0836L340.145 69.0839L339.983 69.6647L340.599 70.6972L342.22 71.7298L343.16 73.44L345.137 75.0856L346.434 75.0534L346.888 75.5051L346.434 75.9246L347.99 76.6667L349.287 77.2798L350.81 78.3769L351.005 78.7319L350.745 79.474L349.74 78.506L348.249 78.1833L347.633 79.5063L348.898 80.2807L348.768 81.3455L348.087 81.4746L347.277 83.2493L346.564 83.4106L346.531 82.7653L346.823 81.6682L347.179 81.2165L346.434 80.0226L345.85 78.99L345.137 78.7319L344.554 77.8606L343.452 77.4734L342.674 76.6345L341.442 76.5054L340.048 75.6019L338.46 74.2467L337.26 73.085L336.644 71.0522L335.801 70.8263L334.44 70.1487L333.694 70.4068L332.754 71.3749L332.074 71.5039L332.236 70.6327L331.328 70.3746L330.842 68.7935L331.393 68.1804L330.907 67.4059L330.939 66.8251L331.652 67.2769L332.463 67.1801L333.338 66.4702L333.63 66.7929L334.408 66.7283L334.732 65.9216L335.964 66.1798L336.644 65.8248L336.742 65.0181L337.746 65.3086L337.909 64.9213L339.497 64.5664L339.918 65.244L342.285 65.7926Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.396 124.91L179.813 125.265L178.84 124.91L177.9 124.168L178.16 123.684L178.938 123.555L179.359 123.619L180.559 123.813L181.434 124.297L181.693 124.878L180.396 124.91Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M388.376 95.2903L388.085 95.613L384.714 96.6455L386.658 98.7429L386.14 99.0656L385.913 99.7755L384.584 100.066L384.227 100.808L383.546 101.453L381.537 101.098L381.439 100.808L382.023 97.5168L381.893 96.7101L382.088 96.097L381.958 94.8063L382.185 94.1609L384.227 94.9999L387.372 92.7734L388.376 95.2903Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M553.825 91.19L554.344 91.8999L553.922 93.1583L552.918 92.4807L552.237 92.9647L552.269 94.1586L550.875 93.5778L550.486 92.6098L550.908 91.3514L552.01 91.6095L552.334 90.7383L553.825 91.19Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M561.806 84.9906L562.001 86.6362L562.811 87.6688L562.617 89.1208L560.866 90.0889L557.884 90.2179L556.458 92.6057L554.934 91.799L554.156 90.2502L551.368 90.702L549.715 91.67L547.705 91.7345L550.104 93.2511L550.364 96.7682L549.553 97.6395L548.386 96.8328L548.094 94.9613L546.765 94.3804L545.469 92.9607L546.863 92.3153L547.219 90.9924L548.483 89.9275L549.132 88.5078L552.276 87.8947L554.318 88.3142V84.6356L555.972 85.6359L557.43 83.5708L557.981 82.7641L557.657 80.2473L556.004 77.924L555.939 76.6333L557.495 76.2461L560.153 79.1179L561.061 80.7635L560.639 82.8609L561.806 84.9906Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M557.946 70.5417L559.405 70.9611L559.988 70.1222L561.933 72.4132L559.858 72.9617L559.729 74.9946L556.195 73.6071L556.714 75.8335L554.866 75.8658L553.343 73.8329L553.148 72.2518L554.834 72.155L553.408 69.3155L552.824 67.7344L556.228 69.864L557.946 70.5417Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M433.824 51.7928L435.25 51.696L438.232 49.8245L437.973 50.4698L440.696 51.9864L446.628 57.0201L446.985 55.9876L449.708 57.1169L451.717 56.6007L452.787 56.9556L454.116 58.1172L455.413 58.5044L456.483 59.3757L458.428 59.0853L459.854 60.3114L459.238 61.6667L458.006 61.8603L458.817 63.8609L458.298 64.7966L454.797 64.119L455.121 67.7652L454.473 68.217L451.523 69.0237L454.376 72.5731L453.436 73.0894L453.987 74.2833L452.852 73.9606L451.75 73.2184L449.189 73.0248L446.401 72.9603L445.883 73.1862L443.224 72.315L442.414 72.7667L442.576 73.9606L439.594 73.2507L438.589 73.5411L438.492 74.4446L437.649 74.8318L435.898 76.2516L435.607 77.7359H434.958L434.213 76.7679L432.041 76.7033L431.231 75.0254L430.388 74.9932L429.901 72.928L427.438 71.4437L424.65 71.6051L422.802 71.8955L420.663 70.0562L419.107 69.2818L416.125 67.8298L415.768 67.6684L411.878 68.8623L413.888 76.4129L413.045 76.5097L411.489 74.8964L410.225 74.3155L408.41 74.735L407.826 75.4449L407.632 74.9286L407.826 74.0897L407.34 73.3798L405.233 72.6699L404.033 70.8306L402.996 70.3144L402.802 69.6367L404.455 69.8303L404.131 68.346L405.46 68.0234L406.983 68.3138L406.756 66.3455L406.141 65.087L404.52 65.1838L402.996 64.6998L401.343 65.571L399.917 66.0228L399.009 65.6678L398.944 64.6353L397.55 63.28L396.383 63.3446L394.665 61.9893L395.216 60.4405L394.633 60.0533L395.346 57.8268L397.291 58.9885L397.096 57.5364L399.722 55.3745L402.186 55.31L406.076 56.6975L408.215 57.5042L409.641 56.6652L412.137 56.6329L414.504 57.6655L414.763 57.0524L417.032 57.1492L417.097 56.2134L414.05 54.8259L415.185 53.8579L414.698 53.3416L415.995 52.8254L414.342 51.4701L414.796 50.7925L420.306 50.1149L420.857 49.6309L424.391 48.8887L425.396 48.082L428.345 48.5015L429.772 50.5344L431.166 50.0504L433.467 50.728L433.824 51.7928Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M396.613 153.823L395.024 156.146L395.089 163.696L396.159 165.407L394.862 166.246L394.408 167.117L393.695 167.246L393.436 168.73L392.82 169.569L392.463 170.924L391.718 171.602L389.092 169.537L388.995 168.343L382.35 164.116L382.479 162.599L382.025 161.793V161.696L382.544 160.857L383.452 159.502L384.132 157.985L383.29 155.597L383.063 154.565L382.187 153.113L383.29 151.886L384.521 150.531L385.461 150.886L385.494 152.048L386.11 152.725H387.406L389.74 154.468L390.324 154.5L390.745 154.436L391.167 154.661L392.399 154.855L392.917 153.984L394.603 153.113L395.348 153.823H396.613Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M453.99 74.2808L453.925 74.7326L451.688 75.8297L451.364 76.6686L449.29 76.8945L449.095 78.2175L447.215 77.927L446.178 78.3465L444.849 79.3146L445.238 79.7986L444.881 80.2503L441.769 80.573L439.468 79.8954L437.685 80.0567L437.49 78.8951L439.435 79.2178L439.889 78.6047L441.218 78.7983L442.936 77.314L440.602 76.2169L439.565 76.7332L438.074 75.9587L439.046 74.6358L438.495 74.4422L438.592 73.5387L439.597 73.2483L442.58 73.9581L442.417 72.7642L443.228 72.3125L445.886 73.1837L446.405 72.9579L449.192 73.0224L451.753 73.216L452.855 73.9581L453.99 74.2808Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M515.352 132.488L515.935 133.876L515.967 136.36L513.05 137.974L513.958 139.2L512.045 139.361L510.554 140.2L508.998 139.91L508.155 138.813L507.021 136.683L506.34 134.166L507.345 132.456L509.646 132.069L511.364 132.359L512.985 133.166L513.633 131.746L515.352 132.488Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M535.807 83.7357V83.542L536.617 83.6066L536.812 82.7031L537.978 82.574L538.627 82.445V81.9609L541.317 84.381L542.387 85.7362L543.489 88.124L543.327 89.2534L541.933 89.6406L540.928 90.5118L539.437 90.6732L538.756 89.5438L538.4 87.995L536.682 85.8653L537.784 85.5104L535.807 83.7357Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M404.392 99.8381L404.878 100.742L404.781 101.226L405.559 102.774L404.295 102.839L403.744 101.839L402.123 101.645L403.193 99.6445L404.392 99.8381Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M515.35 132.492L513.632 131.75L512.984 133.17L511.363 132.363L511.849 131.428L511.72 129.685L510.002 127.878L509.58 125.813L507.96 124.135L506.566 124.006L506.306 124.716L505.269 124.78L504.653 124.426L502.935 125.652L502.611 123.78L502.741 121.618L501.509 121.521L501.217 120.263L500.342 119.618L500.601 118.876L501.93 117.52L502.189 118.004L503.162 118.069L502.514 115.681L503.389 115.391L504.686 117.036L505.82 118.908H508.024L508.997 120.715L507.927 121.263L507.538 122.005L509.905 123.264L511.752 125.716L513.179 127.523L514.767 128.975L515.415 130.427L515.35 132.492Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M382.218 92.9958L381.764 93.0281L381.634 93.383H381.051L381.472 91.6728L382.185 90.2208V90.1562L382.996 90.2531L383.385 91.0597L382.51 91.8664L382.218 92.9958Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.261 146.013L304.196 146.594L304.358 147.594L303.969 148.53L304.488 149.111L305.071 149.24L305.849 150.111L305.914 150.918L305.719 151.176L305.59 152.886L305.104 152.918L303.223 151.918L301.538 150.337L299.982 149.207L298.75 147.885L299.204 147.207L299.301 146.594L300.144 145.497L300.987 144.529L301.408 144.464L301.862 144.238L302.64 145.497L302.51 146.336L302.867 146.787H303.386L303.742 145.948L304.261 146.013Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M363.905 96.5119L363.354 97.5122L363.678 98.4157L363.322 99.6741L363.97 101.352L364.391 108.709L364.716 116.356L364.878 120.487H362.803V121.358L355.477 117.389L348.183 113.42L346.401 114.549L345.169 115.324L344.131 114.195L341.279 113.291L340.468 112L339.01 111.032L338.199 111.42L337.519 110.258L337.454 109.387L336.352 107.87L337.065 106.999L336.87 105.708L337.065 104.579L336.935 103.611L337.194 101.933L337.065 100.965L336.449 99.1256L337.292 98.6738L337.421 97.7703L337.227 96.9314L338.394 96.1247L338.912 95.4471L339.755 94.8663L339.788 93.2852L341.862 93.995L342.608 93.8014L344.067 94.1564L346.433 95.0921L347.341 96.9314L348.929 97.3186L351.457 98.1898L353.402 99.2224L354.213 98.6738L355.023 97.7381L354.505 96.157L354.991 95.1244L356.19 94.1564L357.39 93.8982L359.788 94.3177L360.437 95.2212L361.085 95.2535L361.668 95.6084L363.419 95.8343L363.905 96.5119Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M468.702 149.08L467.146 149.564L466.206 147.918L465.752 144.95L466.4 141.594L467.729 142.723L468.637 144.175L469.642 146.337L469.447 148.499L468.702 149.08Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M369.254 225.198L368.606 225.424L367.406 223.811L368.444 222.52L369.448 221.713L370.324 221.262L371.037 221.907L371.588 222.552L370.972 223.553L370.615 224.23L369.611 224.553L369.254 225.198Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M360.175 47.6317L360.499 48.5029L359.332 49.1483L359.17 50.2454L357.614 50.9875H356.091L355.637 50.3745L354.826 50.1486L354.632 49.6646L354.697 49.116L353.984 48.8256L352.33 48.4707L351.779 46.825L353.433 46.2442L355.993 46.3733L357.452 46.1797L357.744 46.5669L358.554 46.696L360.175 47.6317Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M329.64 59.823L329.187 59.8552L328.83 59.6939L328.96 58.5645L329.381 58.5L329.705 58.9517L329.64 59.823Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M360.726 44.0462L361.537 44.4656L361.861 45.4014L362.541 46.563L361.05 47.3052L360.175 47.6278L358.554 46.6921L357.744 46.563L357.452 46.1758L355.993 46.3694L353.433 46.2403L351.779 46.8212L351.617 45.3691L352.168 44.143L353.497 43.4976L354.924 44.9496L356.123 44.8851L356.155 43.4008L357.387 43.0781L358.068 43.304L359.494 44.0139L360.726 44.0462Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M315.991 89.0582L316.607 90.3812L316.704 91.6396L317.32 93.8338L317.774 94.2855L317.45 95.0922L315.148 95.4472L314.338 96.1893L313.333 96.3829L313.236 97.9318L311.161 98.7385L310.481 99.771L309.022 100.32L307.271 100.642L304.386 102.191L304.354 104.643H304.062L304.095 105.741L302.992 105.805L302.409 106.289H301.599L300.95 105.999L299.459 106.225L298.843 107.838L298.26 107.999L297.384 110.613L294.824 112.839L294.175 115.711L293.397 116.647L293.17 117.389L289.118 117.55H289.086L289.183 116.582L289.896 116.034L290.512 114.937L290.415 114.227L291.063 112.775L292.101 111.452L292.717 111.129L293.235 109.935L293.3 108.806L293.981 107.547L295.213 106.773L296.38 104.676L296.412 104.643L297.352 103.837L299.005 103.611L300.432 102.191L301.339 101.643L302.863 99.9001L302.474 97.351L303.187 95.544L303.479 94.4469L304.646 93.0594L306.396 92.1236L307.725 91.2524L308.925 89.1227L309.508 87.832L310.772 87.8643L311.777 88.7355L313.43 88.6065L315.213 89.0582H315.991Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M366.107 67.8622L365.685 66.9264L365.75 66.0552L365.556 65.1839L364.454 63.9578L363.805 63.1188L363.222 62.538L362.703 62.3121L363.06 62.0217L364.097 61.8281L365.394 62.4412L366.042 62.538L366.885 63.0866L366.852 63.7642L367.501 64.0869L367.857 64.9258L368.506 65.4421L368.441 65.7648L368.765 65.9584L368.344 66.1197L367.371 66.0552L367.177 65.7648L366.852 65.9261L367.047 66.281L366.69 66.9587L366.496 67.6363L366.107 67.8622Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M411.005 190.026L411.135 192.51L411.556 193.478L411.33 194.478L410.941 195.059L410.422 193.865L410.033 194.478L410.292 195.995L410.065 196.898L409.514 197.35L409.287 199.125L408.412 201.545L407.31 204.385L405.916 208.321L404.976 211.193L403.971 213.613L402.48 214.097L400.827 214.968L399.854 214.452L398.493 213.71L398.104 212.613V210.774L397.618 209.128L397.553 207.611L397.974 206.127L398.817 205.772L398.882 205.094L399.822 203.513L400.081 202.19L399.725 201.222L399.465 199.899L399.433 197.996L400.146 196.834L400.47 195.511L401.378 195.446L402.415 195.027L403.128 194.64L403.906 194.607L405.008 193.446L406.597 192.155L407.18 191.123L406.986 190.219L407.764 190.477L408.833 189.057L408.931 187.799L409.579 186.863L410.163 187.767L410.616 188.638L411.005 190.026Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M145.647 108.391L146.36 108.327L145.323 110.166L144.739 111.65L144.156 114.425L143.799 115.425L143.929 116.555L144.35 117.587L144.48 119.169L145.452 120.717L145.712 121.911L146.263 122.912L148.11 123.46L148.726 124.331L150.412 123.75L151.806 123.557L153.232 123.17L154.399 122.815L155.663 121.976L156.247 120.782L156.636 119.039L157.025 118.426L158.321 117.878L160.299 117.394L161.887 117.491L162.989 117.297L163.378 117.749L163.184 118.749L162.049 119.975L161.466 121.234L161.758 121.589L161.369 122.492L160.688 124.105L160.299 123.557L159.942 123.589L159.586 123.621L158.775 124.88L158.484 124.622L158.257 124.719L158.224 125.041L156.539 125.009H154.853L154.691 126.171L153.88 126.203L154.464 126.88L155.08 127.364L155.242 127.816L155.501 127.945L155.372 128.655H153.038L151.968 130.333L152.195 130.72L151.936 131.204L151.806 131.817L149.991 129.591L149.148 128.913L147.721 128.365L146.684 128.526L145.128 129.301L144.188 129.494L142.989 128.946L141.66 128.558L140.104 127.623L138.775 127.332L136.862 126.364L135.468 125.364L135.112 124.815L134.107 124.686L132.356 124.041L131.74 123.105L129.99 121.911L129.277 120.621L129.017 119.588L129.633 119.394L129.536 118.814L130.055 118.265L130.184 117.555L129.698 116.619V115.813L129.277 114.748L128.045 112.683L126.554 111.069L125.938 109.779L124.609 108.94L124.382 108.423L124.933 107.165L124.155 106.681L123.345 105.648L123.28 104.229L122.372 104.035L121.627 102.97L121.075 101.938L121.173 101.292L120.686 99.7435L120.589 98.1623L120.849 97.3557L119.844 96.5167L119.228 96.6135L118.45 96.065L117.866 96.9039L117.834 97.8719L117.51 99.453L117.834 100.292L118.741 101.712L118.871 102.228L119.098 102.357L119.13 103.067L119.455 103.035V104.39L119.876 104.906L120.038 105.648L120.913 106.681L121.043 108.617L121.367 109.521L121.659 110.489L121.562 111.586L122.405 111.65L122.923 112.586L123.409 113.522L123.312 113.909L122.405 114.651H122.08L121.853 113.393L120.913 112.199L119.811 111.198L119.001 110.682L119.39 109.166L119.357 108.036L118.677 107.391L117.672 106.487L117.38 106.746L117.056 106.197L116.083 105.713L115.37 104.487L115.532 104.358L116.213 104.455L117.088 103.68L117.412 102.744L116.472 101.26L115.63 100.711L115.37 99.4208L115.176 98.0333L114.916 96.3876L114.852 94.5161L116.894 94.3548L119.195 94.1289L118.904 94.5484L121.173 95.5487L124.706 97.0007H128.207H129.601L129.86 96.1295H132.907L133.329 96.8716L134.009 97.5493L134.787 98.4528L135.047 99.5176L135.176 100.679L135.922 101.292L137.219 101.905L138.775 100.292L140.233 100.227L141.271 101.066L141.789 102.486L142.081 103.712L142.859 104.874L142.924 106.326L143.216 107.294L144.48 107.939L145.647 108.391Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M358.36 76.3493L358.036 76.4138L357.776 76.7687L356.869 76.7365L356.285 77.1882L355.183 77.3496L354.437 76.8655L354.113 75.9943L354.275 75.2844L354.502 75.3167L354.535 74.8972L355.475 74.5745L355.864 74.4777L356.415 74.3809L357.193 74.3164L358.1 74.994L358.36 76.3493Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M327.468 122.231L327.5 127.007L326.495 128.394L326.366 129.685L324.745 130.008L322.249 130.169L321.6 130.911L320.433 131.008H319.266L318.813 130.621L317.808 130.911L316.09 131.782L315.733 132.428L314.339 133.331L314.08 133.88L313.302 134.299L312.427 134.009L311.94 134.525L311.649 135.945L310.19 137.655L310.255 138.365L309.736 139.236L309.866 140.43L309.088 140.753L308.666 141.011L308.375 140.14L307.856 140.365L307.532 140.333L307.208 140.914H305.781L305.295 140.591L305.036 140.785L304.485 140.172L304.582 139.559L304.355 139.333L303.966 139.526L304.063 138.849L304.42 138.333L303.674 137.461L303.48 136.881L303.058 136.429L302.702 136.364L302.28 136.655L301.664 136.945L301.178 137.397L300.4 137.236L299.882 136.687L299.59 136.622L299.104 136.913H298.812L298.715 136.138L298.812 135.493L298.65 134.719L298.001 134.138L297.645 132.944L297.58 131.653L298.196 131.266L298.52 130.04L299.104 130.008L300.368 130.588L301.405 130.169L302.086 130.298L302.378 129.846L309.671 129.814L310.093 128.362L309.769 128.104L308.958 119.166L308.18 110.228L310.935 110.195L316.965 114.713L323.027 119.23L323.448 120.198L324.583 120.779L325.425 121.134L325.458 122.457L327.468 122.231Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M501.93 117.517L500.601 118.872L500.342 119.615L499.369 120.099L498.462 121.002L497.198 121.099L496.711 123.325L495.998 123.713L497.133 125.52L498.462 127.036L499.402 128.424L498.948 130.198L498.365 130.586L498.948 131.618L500.342 133.264L500.666 134.425L500.731 135.393L501.606 137.297L500.763 139.233L500.05 141.363L499.758 139.814L500.18 138.233L499.467 137.007L499.402 134.748L498.559 133.651L497.684 131.199L497.036 128.585L496.031 126.842L494.993 127.907L493.113 129.359L492.043 129.198L490.876 128.714L491.168 126.133L490.52 124.197L488.802 121.809L488.899 121.067L487.797 120.776L486.306 119.098L485.949 117.42L486.63 117.743L486.435 116.259L487.246 115.775L486.922 114.904L487.246 114.194L486.954 112.032L488.445 112.516L488.964 110.806L488.867 109.805L489.515 108.063L489.223 106.869L491.233 105.449L492.595 105.804L492.141 104.546L492.692 104.158L492.368 103.384L493.373 103.223L494.248 104.449L495.123 104.933L495.544 106.514L495.836 108.224L494.475 109.967L494.702 112.419L496.517 112.064L497.295 113.968L498.494 114.387L498.235 116.097L499.694 116.872L500.536 117.259L501.768 116.646L501.93 117.517Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M353.532 73.3114L353.273 73.7632L352.819 73.9568L352.689 73.5696L352.073 74.5699L352.235 75.2475L351.879 75.0861L351.328 74.4085L350.582 73.989L350.744 73.6664L350.874 72.537L351.392 72.053L351.684 71.8594L352.138 72.2143L352.43 72.5047L352.981 72.7306L353.662 73.1501L353.532 73.3114Z",
      "fill": "#B0B5B7",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M485.01 58.5684L486.307 58.1812L488.154 57.9231L489.905 58.2135L492.044 59.1493L493.633 60.1818H495.124L497.328 60.5045L498.495 59.9882L500.408 59.6655L501.834 58.2458L502.936 58.4716L504.2 59.1493L506.016 58.9556L506.21 60.4722L506.307 62.5051L507.215 63.3118L507.961 63.0536L509.743 63.3763L510.554 62.6341L512.239 63.2795L514.573 64.6993L514.833 65.4092L513.406 65.1833L511.202 65.4414L510.392 66.0222L509.97 67.3775L507.896 68.1519L506.858 69.249L504.946 68.8295L503.909 68.6359L503.746 69.9589L504.687 70.7333L505.302 71.4109L504.524 72.1208L503.876 73.2179L502.288 73.9278L499.824 73.9923L497.49 74.7022L496.064 75.7993L494.994 75.1862H492.984L489.937 73.9278L488.122 73.6374L486.047 73.9278L482.384 73.4438L480.569 73.5083L479.045 72.2821L477.425 70.4106L476.323 70.1848L473.729 68.894L471.395 68.6359L469.288 68.281L468.316 67.3775L467.862 65.0219L465.982 63.3763L463.324 62.6341L461.476 61.5693L460.406 60.1495L461.93 59.7946L464.102 58.0844L466.014 57.1487L467.732 57.7617L469.418 57.794L470.974 58.7298L472.595 58.7943L475.188 59.3106L475.966 57.8908L474.669 56.7292L475.091 54.6641L477.36 55.4708L478.916 55.7289L481.088 56.2452L482.255 57.7295L485.01 58.5684Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M378.197 217.322H376.868L376.771 216.387L376.577 215.451L376.447 214.709L376.901 212.418L376.544 210.934L375.831 208.029L377.841 205.674L378.392 204.19L378.651 203.996L378.943 202.77L378.684 202.157L378.813 200.608L379.235 199.188L379.364 196.542L378.457 195.897L377.582 195.736L377.225 195.219L376.382 194.8L374.859 194.832L374.794 194.058L374.664 192.573L380.24 190.863L381.277 191.863L381.763 191.67L382.476 192.186L382.541 193.025L382.12 193.993L382.185 195.445L383.319 196.736L383.935 195.284L384.745 194.864L384.713 192.186L384 190.702L383.384 190.024H383.254L383.06 187.669L383.546 185.7L384.259 185.636L386.431 186.217L386.917 185.958L388.182 185.894L388.862 185.281L389.964 185.313L391.974 184.506L393.465 183.312L393.757 184.216L393.595 186.281L393.757 188.12L393.692 191.347L393.952 192.347L393.336 193.832L392.558 195.284L391.358 196.574L389.64 197.349L387.533 198.349L385.394 200.576L384.681 200.963L383.319 202.447L382.574 202.899L382.314 204.383L383.092 205.964L383.384 207.158V207.804L383.708 207.674L383.546 209.707L383.189 210.675L383.578 211.03L383.254 211.902L382.476 212.644L380.953 213.321L378.716 214.451L377.906 215.225L378.003 216.096L378.424 216.225L378.197 217.322Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.934 110.198L308.179 110.23L308.957 119.168L309.767 128.106L310.091 128.364L309.67 129.816L302.376 129.849L302.084 130.3L301.404 130.171L300.366 130.591L299.102 130.01L298.519 130.042L298.194 131.268L297.579 131.656L296.412 130.236L295.309 128.687L294.142 128.139L293.267 127.558H292.262L291.355 128.009L290.479 127.848L289.831 128.493L289.701 127.396L290.22 126.364L290.479 124.428L290.35 122.363L290.155 121.33L290.35 120.298L289.896 119.33L288.988 118.426L289.41 117.748H296.444L296.152 114.748L296.638 113.683L298.324 113.521L298.389 108.197L304.224 108.326L304.289 105.164L310.934 110.198Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M383.258 190.025H383.387L384.003 190.703L384.716 192.187L384.749 194.865L383.938 195.285L383.322 196.737L382.188 195.446L382.123 193.994L382.544 193.026L382.48 192.187L381.766 191.671L381.28 191.864L380.243 190.864L379.303 190.348L379.951 188.412L380.535 187.702L380.243 185.959L380.664 184.281L380.988 183.733L380.567 181.99L379.724 181.055L381.507 181.442L381.831 181.99L381.799 182.249L382.382 183.572L382.447 186.056L381.864 187.218L382.382 188.734L382.317 189.638L382.706 190.251L382.674 191.025L382.966 191.477L383.29 190.961L383.906 191.768L383.971 191.509L383.646 190.412L383.29 190.315L383.258 190.025Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M507.088 149.043L507.541 149.237L508.676 150.495L509.486 151.883L509.681 153.27L509.519 154.206L509.713 154.916L509.875 156.142L510.556 156.723L511.302 158.562V159.24L510.005 159.401L508.222 157.852L506.018 156.206L505.759 155.142L504.656 153.754L504.332 152.044L503.619 150.915L503.749 149.398L503.295 148.527L503.587 148.172L505.143 149.075L505.337 150.14L506.537 149.882L507.088 149.043Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M536.194 153.371L534.573 153.016H532.466L531.915 155.371L531.234 156.081L530.391 158.953L528.9 159.405L527.15 158.824L526.274 159.017L525.205 160.05L524.038 159.921L522.838 160.34L521.574 159.147L521.25 157.759L522.611 158.469L524.005 158.082L524.33 156.339L525.108 155.952L527.312 155.5L528.544 153.855L529.386 152.564L530.294 153.629L530.651 152.919L531.526 152.983L531.558 151.66L531.591 150.628L532.92 149.208L533.763 147.595L534.508 147.562L535.513 148.627L535.643 149.531L536.875 150.112L538.431 150.725L538.366 151.531L537.134 151.628L537.49 152.661L536.194 153.371Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M361.827 198.221L363.318 197.77L364.485 197.866L365.198 198.35V198.512L364.161 198.996H363.61L362.41 199.802L361.762 198.931L358.942 199.673L357.58 199.738L357.321 207.127L355.538 207.192L355.344 213.226L354.987 220.873L353.366 221.938L352.426 222.099L351.324 221.712L350.514 221.551L350.254 220.679L349.606 220.099L348.698 221.131L347.434 219.55L346.786 218.066L346.462 216.033L346.073 214.549L345.554 211.354L345.586 208.87L345.392 207.74L344.711 206.869L343.803 205.159L342.896 202.674L342.539 201.383L341.113 199.351L341.016 197.77L341.891 197.382L342.993 197.027L344.16 197.092L345.23 198.028L345.489 197.866L352.847 197.802L354.079 198.77L358.455 199.06L361.827 198.221Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.397 114.551L346.916 117.778L347.629 118.327L347.661 118.972L348.439 119.682L348.05 120.585L347.467 124.78L347.402 127.491L345.133 129.427L344.387 132.169L345.165 132.944V134.267L346.364 134.299L346.17 135.299L345.684 135.396L345.619 136.074L345.295 136.106L344.031 133.847L343.577 133.751L342.183 134.912L340.756 134.299L339.784 134.202L339.265 134.493L338.196 134.428L337.126 135.299L336.186 135.364L333.982 134.299L333.106 134.783L332.166 134.751L331.485 133.976L329.67 133.202L327.693 133.46L327.239 133.88L326.98 135.074L326.461 135.913L326.331 137.784L324.937 136.59H324.289L323.673 137.203L323.706 135.783L321.599 135.299L321.534 134.299L320.529 132.944L320.27 132.008L320.432 131.008L321.599 130.911L322.247 130.169L324.743 130.008L326.364 129.685L326.493 128.394L327.498 127.007L327.466 122.231L329.994 121.328L335.181 117.262L341.275 113.293L344.128 114.196L345.165 115.326L346.397 114.551Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M345.622 136.071L346.368 136.878L346.173 137.265L346.076 137.943L344.553 139.556L344.099 140.879L343.84 141.944L343.451 142.428L343.094 143.88L342.121 144.719L341.862 145.751L341.441 146.59L341.279 147.461L340.014 148.171L338.977 147.3L338.296 147.332L337.194 148.559H336.676L335.8 150.559L335.347 152.043L333.434 152.786L332.753 152.689L332.04 153.141L330.581 153.108L329.576 151.785L328.961 150.301L327.664 148.946H326.302H324.682L324.779 145.622L324.714 144.299L325.071 143.009L325.622 142.363L326.529 141.073L326.335 140.524L326.691 139.685L326.27 138.459L326.335 137.781L326.465 135.91L326.983 135.071L327.243 133.877L327.696 133.457L329.674 133.199L331.489 133.974L332.17 134.748L333.11 134.78L333.985 134.296L336.189 135.361L337.129 135.297L338.199 134.425L339.269 134.49L339.788 134.2L340.76 134.296L342.186 134.909L343.58 133.748L344.034 133.845L345.298 136.103L345.622 136.071Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M168.435 130.845L168.273 131.071L168.111 131.522L168.241 132.265L167.754 132.974L167.495 133.813L167.333 134.717L167.398 135.265L167.365 136.201L167.074 136.395L166.847 137.298L166.912 137.847L166.523 138.363L166.555 138.912L166.814 139.267L166.361 139.718L165.809 139.557L165.55 139.138L164.967 138.976L164.545 139.234L163.378 138.686L163.087 138.944L162.503 138.299L161.693 137.46L161.336 136.782L160.623 136.104L159.812 135.169L160.039 134.846L160.299 135.169L160.461 135.04L161.044 134.943L161.304 134.459H161.563L161.628 133.426L162.049 133.394H162.438L162.892 132.845L163.378 133.265L163.573 133.007L163.962 132.749L164.642 132.2L164.707 131.748L164.869 131.781L165.161 131.297L165.356 131.232L165.647 131.555L166.004 131.619L166.425 131.361H166.879L167.528 131.103L167.819 130.812L168.435 130.845Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M361.018 21.7877L358.943 22.4654L357.906 22.6267L358.165 21.4005L356.285 20.7229L354.372 21.3037L354.016 22.5944L352.914 23.3689L351.39 22.9494L349.672 23.0139L348.019 22.1104L347.306 22.5622L346.463 22.6267L346.495 23.7883L343.902 23.4979L343.708 24.4982H342.411L341.665 25.7567L340.563 27.725L338.715 30.2741L339.299 30.9195L338.878 31.6293L337.484 31.5971L336.706 33.3395L337.03 35.8241L338.035 36.7599L337.775 38.9863L336.673 40.277L336.09 41.3741L335.02 40.2125L332.232 42.4067L330.255 42.8584L328.148 41.8904L327.564 39.8576L326.916 35.5014L328.213 34.3075L331.876 32.7264L334.501 30.8227L336.835 28.3058L339.72 24.8532L341.795 23.5302L345.134 21.336L347.889 20.5616L350.061 20.6584L351.747 19.2386L354.145 19.3031L356.415 18.9805L360.856 20.2389L359.267 20.6906L361.018 21.7877Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M348.995 8.13396L346.531 8.74704L344.327 8.3921L345.04 8.00489L344.197 7.52088L346.564 7.23047L347.18 7.77902L348.995 8.13396Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M340.695 5.39026L344.779 6.48736L341.992 7.06817L341.603 8.16527L340.63 8.45568L340.338 9.74638L338.912 9.81091L336.157 8.87516L337.129 8.32661L335.281 7.87486L332.785 6.61643L331.748 5.48707L334.763 4.97079L335.508 5.4548H337.129L337.453 4.97079L339.139 4.90625L340.695 5.39026Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M348.602 4.42135L351.001 4.90536L349.575 5.67978L346.301 5.84112L342.832 5.58298L342.508 5.19577H340.855L339.461 4.55042L342.865 4.16321L344.615 4.48588L345.62 4.06641L348.602 4.42135Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M476.192 104.194L476.257 105.065L476.743 106.388L476.711 107.195L475.219 107.227L472.983 106.743L471.589 106.55L470.357 105.517L467.861 105.227L465.333 104.065L463.452 103.065L461.572 102.29L461.864 100.354L462.772 99.3864L463.388 98.9023L464.944 99.5477L467.018 100.903L468.088 101.193L468.898 102.194L470.357 102.581L471.978 103.517L474.085 103.968L476.192 104.194Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M416.159 127.427L415.445 125.975L413.76 122.555L419.044 120.49L419.886 116.359L418.914 114.875V114.036L419.335 113.197L419.27 112.358L420.048 111.939L419.692 111.648V110.293H420.6L421.572 111.713L422.642 112.455L423.971 112.745L425.073 113.1L426.013 114.294L426.564 114.972L427.212 115.262L427.277 115.714L426.726 116.94L426.499 117.521L425.786 118.199L425.235 119.618L424.425 119.489L424.1 120.005L423.874 121.038L424.23 122.426L424.068 122.684H423.258L422.188 123.458L422.091 124.458L421.702 124.91L420.567 124.878L419.919 125.394L419.984 126.233L419.141 126.814L418.136 126.62L416.969 127.33L416.159 127.427Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M420.179 108.645L419.758 107.935L420.212 107.258L420.439 107.419L420.374 108.29L420.179 108.645Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M454.345 88.3803L453.113 90.1227L451.266 90.4454L448.51 89.9291L447.862 90.8326L448.932 92.6396L449.872 94.0594L451.525 95.0597L450.293 96.2536L450.617 97.7379L449.353 99.8353L448.64 101.933L447.181 104.095L445.074 103.933L443.486 106.127L444.782 107.031L445.236 108.644L446.371 109.677L446.954 111.452H443.032L441.995 112.839L440.633 112.323L439.92 110.838L438.332 109.257L435.09 109.645L432.173 109.677L429.709 109.967L430.065 107.579L432.497 106.482L432.205 105.547L431.33 105.192L431.006 103.385L429.158 102.481L428.25 101.223L427.213 100.126L430.325 101.19L432.043 100.868L433.145 101.126L433.437 100.674L434.701 100.868L436.84 99.9966L436.581 98.2541L437.327 97.0602H438.656L438.721 96.5117L440.017 96.2213L440.698 96.4149L441.281 95.8341L440.925 94.5756L441.379 93.3495L442.384 92.8009L441.379 91.4457L443.064 91.5102L443.356 90.7681L443.097 89.9614L443.745 89.0902L443.291 88.0576L442.675 87.1864L443.453 86.2829L445.171 85.8634L447.084 85.6053L447.862 85.2503L448.802 84.9922L450.326 85.9602L451.266 87.5736L454.345 88.3803Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M178.062 143.984L177.835 144.274L178.192 145.501L177.835 146.114L177.252 145.952L176.96 146.953L176.377 146.372L176.052 145.242L176.506 144.694L176.052 144.565L175.761 143.887L174.853 143.306L174.075 143.435L173.654 144.145L172.876 144.662L172.487 144.726L172.292 145.178L173.103 146.307L172.584 146.565L172.325 146.856L171.449 146.985L171.19 145.726L170.931 146.081L170.347 145.952L170.023 145.146L169.277 144.984L168.791 144.758H168.013L167.948 145.21L167.754 144.887L167.851 144.468L168.046 144.048L167.981 143.694L168.273 143.435L167.916 143.145L167.948 142.306L168.662 142.112L169.277 142.855L169.213 143.306L169.926 143.403L170.12 143.21L170.607 143.726L171.514 143.564L172.325 143.048L173.459 142.629L174.107 142.016L175.112 142.145L175.048 142.338L176.052 142.403L176.83 142.79L177.414 143.403L178.062 143.984Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M191.417 170.824L189.763 170.727L189.504 171.05L188.013 171.437L185.971 172.856L185.873 173.825L185.42 174.534L185.646 175.664L184.544 176.245L184.609 177.148L184.123 177.503L184.966 179.375L186.035 180.633L185.711 181.536L186.943 181.633L187.689 182.763L189.309 182.795L190.736 181.601L190.768 184.731L191.611 184.957L192.648 184.602L194.431 187.958L194.075 188.635V190.12L194.172 191.862L193.556 192.895L193.945 193.669L193.588 194.379L194.528 196.121L193.588 198.348L193.232 199.413L192.324 199.929L190.412 198.735L190.152 197.896L186.36 195.831L182.891 193.54L181.368 192.282L180.46 190.571L180.719 189.958L178.969 187.248L176.894 183.44L174.949 179.31L174.171 178.342L173.523 176.825L172.032 175.47L170.703 174.631L171.254 173.728L170.281 171.727L170.832 170.275L172.259 168.984L172.486 169.856L171.967 170.34L172.064 171.082L172.81 170.92L173.555 171.146L174.366 172.211L175.371 171.34L175.662 169.952L176.764 168.145L178.936 167.339L180.914 165.145L181.465 163.822L181.205 162.24L181.692 162.047L182.924 163.015L183.507 164.015L184.35 164.531L185.484 166.693L186.846 166.984L187.851 166.435L188.531 166.79L189.634 166.597L191.06 167.565L189.925 169.694L190.476 169.727L191.417 170.824Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M551.238 144.498L551.53 145.885L551.724 147.047L551.206 148.918L550.395 146.821L549.617 147.886L550.298 149.402L549.844 150.37L547.607 149.176L546.992 147.66L547.478 146.692L546.246 145.692L545.727 146.563L544.884 146.466L543.588 147.628L543.264 147.015L543.847 145.272L544.949 144.691L545.889 143.917L546.603 144.853L547.964 144.304L548.191 143.368L549.488 143.304L549.228 141.723L550.817 142.691L551.044 143.723L551.238 144.498Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M546.502 140.625L545.918 141.302L545.465 142.625L544.946 143.238L543.682 141.818L544.006 141.238L544.427 140.657L544.492 139.398L545.497 139.269L545.335 140.657L546.502 138.656V140.625Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M536.682 142.627L534.381 144.595L535.159 143.143L536.391 141.852L537.363 140.432L538.109 138.367L538.627 140.077L537.493 141.207L536.682 142.627Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M542.355 137.297L543.522 137.942H544.657L544.722 138.781L543.976 139.685L542.874 140.298L542.712 139.33L542.744 138.265L542.355 137.297Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M548.871 136.721L549.649 139.044L548.19 138.495L548.288 139.205L548.871 140.464L548.028 140.948L547.834 139.463L547.25 139.367L546.861 138.108L547.931 138.27L547.834 137.495L546.537 135.914L548.288 135.946L548.871 136.721Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M541.411 134.846L541.119 136.653L540.244 135.62L539.109 134.039L540.665 134.104L541.411 134.846Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M539.307 123.586L540.539 124.199L540.992 123.65L541.252 124.167L541.122 125.038L541.965 126.522L541.77 128.232L540.83 128.91L540.798 130.588L541.446 132.234L542.419 132.46L543.197 132.234L545.628 133.363L545.595 134.492L546.276 135.009L546.179 135.944L544.655 134.944L543.845 133.847L543.456 134.621L542.159 133.363L540.539 133.686L539.566 133.234L539.534 132.363L540.052 131.846L539.436 131.362L539.307 132.105L538.237 130.911L537.816 130.007L537.459 128.039L538.302 128.716L537.945 125.457L538.205 123.586H539.307Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M605.567 176.053L605.048 176.279L604.303 175.473L603.589 174.15L603.33 172.569L603.589 172.375L603.752 172.988L604.27 173.472L605.048 174.763L605.859 175.473L605.567 176.053Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M598.628 173.278L597.656 173.439L597.332 174.02L596.294 174.536L595.322 175.02H594.317L592.858 174.407L591.854 173.826L592.048 173.181L593.669 173.504L594.706 173.342L595.03 172.342L595.322 172.278L595.419 173.375L596.457 173.246L597.04 172.536L598.11 171.794L597.98 170.567L599.082 170.535L599.439 170.858L599.309 172.019L598.628 173.278Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M577.949 180.825L578.468 174.049L578.792 167.305L581.904 168.724L585.243 169.918L586.442 170.983L587.415 172.016L587.609 173.242L590.591 174.533L590.948 175.63L589.262 175.856L589.554 177.243L591.078 178.598L592.05 180.793L593.12 180.728L592.925 181.631L594.319 181.986L593.736 182.374L595.584 183.245L595.292 183.858L594.06 183.987L593.671 183.471L592.147 183.213L590.332 182.922L589.035 181.599L588.128 180.438L587.317 178.631L585.016 177.727L583.428 178.308L582.228 179.018L582.325 180.534L580.834 181.244L579.829 180.889L577.949 180.825Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M600.869 171.247L600.286 171.796L599.994 170.57L599.637 169.795L598.827 169.118L597.822 168.214L596.525 167.601L597.044 167.117L598.017 167.698L598.632 168.15L599.378 168.634L600.059 169.505L600.739 170.183L600.869 171.247Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M350.061 49.9551L351.974 50.181L354.826 50.1487L355.637 50.3746L356.09 50.9877L356.285 51.8589L356.836 52.6011L356.966 53.3755L356.058 53.795L356.674 54.6985L356.836 55.6019L357.873 57.3444L357.776 57.8929L357.03 58.1188L355.799 59.7967L356.317 60.7002L355.961 60.5711L354.34 59.7967L353.205 60.0871L352.427 59.8935L351.52 60.313L350.644 59.6031L350.029 59.8935L349.931 59.7645L349.089 58.7642L347.889 58.6674L347.662 58.022L346.56 57.7961L346.366 58.3124L345.458 57.8929L345.523 57.3444L344.323 57.1831L343.513 56.5377L342.735 55.2793L342.8 54.5694L342.314 53.5046L341.698 52.8269L342.087 52.2784L341.633 51.2781L342.638 50.6973L344.939 49.7938L346.819 49.1484L348.375 49.4711L348.57 49.9551H350.061Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M538.208 74.1832L538.662 74.5381L537.949 74.4091L537.625 75.119L537.528 75.7966L538.435 77.2809L537.819 77.7326L537.722 78.0876L537.43 78.7006L536.49 79.0556L536.036 79.6041L536.458 80.4754L536.361 80.7012L537.203 81.0562L538.63 81.9597V82.4437L537.981 82.5728L536.814 82.7018L536.62 83.6053L535.81 83.5408V83.7344L534.772 83.3472L534.74 83.7344L534.318 83.8957L534.091 83.5085L533.54 83.3149L532.925 82.9922L532.957 82.0887L533.249 81.8306L532.925 81.4757L532.795 80.3463L532.503 80.0236L531.401 79.7977L530.299 79.2492L530.98 77.9262L532.244 76.8291L532.6 75.3448L533.767 75.9902L535.258 76.087L534.351 74.9899L536.425 74.1187V72.957L538.208 74.1832Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M214.755 203.739L215.404 204.868L215.533 207.675L217.446 208.095L218.159 207.675L219.423 208.256L219.812 208.869L220.169 210.773L220.428 211.547L221.109 211.644L221.757 211.321L222.438 211.676L222.535 212.838L222.438 214.064L222.211 215.258L222.114 217.065L220.72 218.678L219.358 219.001L217.316 218.678L215.436 218.13L216.797 214.968L216.441 214.064L214.528 213.257L212.162 211.709L210.671 211.386L207.008 208.03L207.494 205.546L207.429 204.416L208.11 202.609L211.222 201.996L212.908 202.028L214.658 203.093L214.755 203.739Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M381.958 94.805L382.088 96.0957L381.894 96.7088L381.083 96.9669L381.116 96.4184L381.537 96.128L381.051 95.9021L381.278 94.5469L381.958 94.805Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M411.718 110.901L411.231 111.063L410.648 110.643L410.389 109.127L410.745 108.062L411.231 107.836L411.815 108.481L411.977 109.675L411.718 110.901Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M362.705 62.3086L363.224 62.5345L363.807 63.1153L364.456 63.9542L365.558 65.1804L365.752 66.0516L365.688 66.9228L366.109 67.8586L366.887 68.2458L367.632 67.8909L368.41 68.2458L368.54 68.7944L367.795 69.2138L367.276 69.0202L367.146 71.5048L366.141 71.279L364.845 70.5368L362.932 71.0208L362.187 71.5371L359.723 71.408L358.426 71.1176L357.81 71.2467L357.227 70.4077L356.903 70.0528L357.227 69.6979L356.806 69.472L356.319 69.9237L355.314 69.3106L355.087 68.4717L354.05 68.0199L353.791 67.3423L352.818 66.5679L354.083 66.1807L354.925 64.7932L355.541 63.438L356.481 63.0185L357.13 62.5667L358.167 62.7926H359.204L360.015 63.3089L360.533 62.9862L361.7 62.7926L362.025 62.3086H362.705Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M375.636 164.273L376.349 165.435L376.252 166.661L375.733 166.919L374.729 166.79L374.178 167.984L373.043 167.823L373.237 166.661L373.497 166.5L373.562 165.274L374.08 164.693L374.534 164.919L375.636 164.273Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M304.353 104.648L304.321 104.778L304.289 105.165L304.224 108.327L298.389 108.198L298.324 113.522L296.638 113.683L296.152 114.748L296.444 117.749H289.41L288.988 118.427L289.086 117.555H289.118L293.17 117.394L293.397 116.652L294.175 115.716L294.823 112.844L297.384 110.618L298.259 108.004L298.843 107.843L299.459 106.23L300.95 106.004L301.598 106.294H302.409L302.992 105.81L304.094 105.746L304.062 104.648H304.353Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M402.125 101.646L403.746 101.839L404.297 102.84L405.561 102.775L406.436 104.582L407.377 105.034L407.766 105.776L409.062 106.647L409.289 107.486L409.159 108.196L409.451 108.874L410.035 109.455L410.326 110.132L410.651 110.648L411.234 111.068L411.72 110.907L412.142 111.713L412.239 112.165L413.114 114.295L418.593 115.327L418.917 114.875L419.889 116.36L419.046 120.49L413.763 122.555L408.608 123.362L406.988 124.298L405.853 126.459L405.01 126.814L404.524 126.137L403.843 126.234L402.06 126.008L401.704 125.814L399.629 125.846L399.143 126.04L398.365 125.524L397.943 126.524L398.203 127.395L397.425 128.073L397.133 127.169L396.55 126.556L396.388 125.717L395.383 124.975L394.313 123.233L393.697 121.555L392.368 120.135L391.558 119.78L390.228 117.812L389.937 116.392V115.166L388.77 112.843L387.862 112.036L386.89 111.616L386.209 110.423L386.274 109.971L385.69 108.874L385.139 108.422L384.329 106.873L383.097 105.227L382.092 103.808H381.217L381.379 102.678L381.411 101.936L381.541 101.097L383.551 101.452L384.232 100.807L384.588 100.065L385.917 99.7743L386.144 99.0644L386.663 98.7417L384.718 96.6443L388.089 95.6117L388.381 95.2891L390.585 95.8699L393.373 97.3219L398.819 101.484L402.125 101.646Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M386.075 132.037L385.848 133.812L385.199 135.877L384.13 136.878L383.384 138.491L383.222 139.33L382.379 139.911L381.893 142.073V142.331L381.634 142.266L381.666 141.234L381.407 140.524L380.467 139.717L380.175 138.233L380.369 136.684L379.527 136.555L379.397 137.007L378.295 137.136L378.781 137.717L378.943 138.975L377.971 140.104L377.095 141.589L376.155 141.815L374.599 140.621L373.919 141.04L373.756 141.621L372.816 142.04L372.752 142.46H370.936L370.677 142.04L369.348 141.944L368.7 142.299L368.181 142.137L367.241 140.911L366.917 140.363L365.588 140.653L365.101 141.589L364.68 143.46L364.032 143.847L363.481 144.073L363.319 143.976L362.703 143.363L362.573 142.718L362.832 141.879V141.008L361.763 139.717L361.536 138.846V138.33L360.855 137.717L360.822 136.523L360.401 135.716L359.785 135.845L359.947 135.071L360.401 134.232L360.174 133.36L360.758 132.715L360.369 132.231L360.79 130.973L361.6 129.424L363.156 129.585L362.8 121.357V120.486H364.874L364.712 116.355H371.941H378.911H386.075L386.755 118.388L386.366 118.743L386.755 120.905L387.566 123.358L388.279 123.874L389.316 124.648L388.441 125.81L387.144 126.165L386.593 126.81L386.496 128.165L385.848 131.231L386.075 132.037Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M381.893 142.331L381.958 143.944L381.698 144.557L380.726 144.622L380.11 145.783L381.244 145.945L382.217 146.945L382.541 147.784L383.384 148.268L384.518 150.527L383.287 151.882L382.185 153.108L381.05 154.076H379.753L378.295 154.56L377.128 154.076L376.382 154.657L374.729 153.269L374.275 152.398L373.27 152.818L372.427 152.688L371.941 153.043L371.098 152.785L369.964 151.075L369.672 150.43L368.278 149.591L367.824 148.365L367.046 147.461L365.782 146.396L365.75 145.719L364.745 144.88L363.48 144.073L364.032 143.847L364.68 143.46L365.101 141.588L365.588 140.653L366.917 140.362L367.241 140.911L368.181 142.137L368.699 142.298L369.348 141.943L370.677 142.04L370.936 142.46H372.751L372.816 142.04L373.756 141.621L373.918 141.04L374.599 140.62L376.155 141.814L377.095 141.588L377.97 140.104L378.943 138.975L378.781 137.716L378.295 137.135L379.397 137.006L379.526 136.555L380.369 136.684L380.175 138.233L380.466 139.717L381.407 140.524L381.666 141.233L381.633 142.266L381.893 142.331Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M297.581 131.653L297.646 132.943L298.003 134.137L298.651 134.718L298.813 135.493L298.716 136.138L298.457 136.267L297.452 136.106L297.322 136.331L296.933 136.364L295.604 135.88L294.729 135.847L291.358 135.751L290.871 136.009L290.255 135.944L289.283 136.267L289.024 134.686L290.677 134.718L291.131 134.428H291.455L292.136 133.944L292.913 134.363L293.691 134.428L294.502 133.944L294.145 133.363L293.529 133.686H292.978L292.265 133.169L291.682 133.202L291.26 133.718L289.283 133.75L288.537 132.137L287.662 131.427L288.473 131.007L289.38 129.555L289.834 128.49L290.482 127.845L291.358 128.006L292.265 127.555H293.27L294.145 128.136L295.312 128.684L296.414 130.233L297.581 131.653Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M300.985 144.526L300.143 145.494L299.3 146.591L299.202 147.204L298.749 147.882L298.262 147.72L296.966 146.881L295.993 145.784L295.702 145.01L295.475 143.493L296.479 142.558L296.674 142.009L296.998 141.557L297.517 141.493L297.938 141.105H299.397L299.916 141.848L300.305 142.719L300.24 143.332L300.532 143.88L300.499 144.623L300.985 144.526Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M159.646 134.201L159.419 134.685L158.349 134.653L157.701 134.459L156.988 134.04L156.016 133.911L155.529 133.459L155.627 133.168L156.275 132.652L156.664 132.426L156.567 132.168L157.02 132.039L157.539 132.233L157.896 132.62L158.414 132.975L158.447 133.233L159.257 133.007L159.646 133.136L159.873 133.362L159.646 134.201Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M357.227 70.4093L356.871 70.861L357.098 71.6355L358.005 72.5067L357.422 73.152L357.227 73.7974L357.422 74.0555L357.195 74.3137L356.417 74.3782L355.866 74.475L355.769 74.3137L355.963 74.0878L356.093 73.5715L355.866 73.6038L355.509 73.2166L355.218 73.1198L354.958 72.7971L354.634 72.668L354.375 72.3776L354.083 72.5067L353.921 73.1843L353.532 73.3134L353.662 73.152L352.981 72.7326L352.43 72.5067L352.138 72.2163L351.684 71.8613L352.041 71.7645L352.203 70.8288L351.328 70.0221L351.684 69.1186L351.068 69.1509L351.619 68.3764L351.068 67.7956L350.582 66.9889L351.781 66.4727L352.819 66.5695L353.791 67.3439L354.051 68.0215L355.088 68.4732L355.315 69.3122L356.32 69.9253L356.806 69.4735L357.227 69.6994L356.903 70.0544L357.227 70.4093Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M220.753 150.014L219.748 151.789L219.846 153.209L220.559 154.435L220.202 155.306L220.04 156.274L219.554 157.146L218.517 156.694L217.641 156.92L216.896 156.726L216.701 157.339L217.025 157.726L216.831 158.178L215.826 157.984L214.756 156.178L214.529 155.016H213.946L213.168 153.532L213.525 152.434L213.427 151.95L214.562 151.434L214.886 149.563L217.09 149.982L217.285 149.595L218.776 149.434L220.753 150.014Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M355.961 60.5657L355.572 61.1142L355.345 61.9209L355.021 62.1145L353.238 61.5014L352.719 61.6305L352.395 62.1145L351.65 62.3727L351.455 62.2436L350.709 62.534L350.094 62.5985L349.996 63.018L348.667 63.2439L348.051 63.0503L347.176 62.5017L346.949 61.8241L347.046 61.566L347.241 61.1142L347.954 61.1465L348.473 60.9529L348.505 60.7593L348.797 60.6625L348.862 60.2107L349.218 60.1139L349.445 59.759H349.931L350.029 59.8881L350.645 59.5977L351.52 60.3075L352.427 59.8881L353.205 60.0817L354.34 59.7913L355.961 60.5657Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M346.786 65.7958L345.522 66.3444L345.424 67.1511L344.873 67.3769L344.906 67.9255L344.257 67.8932L343.674 67.5705L343.415 67.8932L342.248 67.8287L342.604 67.6673L342.15 66.7961L342.28 65.7958L343.642 65.9572L344.42 65.4731L345.846 65.4409L346.138 65.0859L346.397 65.1182L346.786 65.7958Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M352.752 28.0724L350.483 28.5887L349.348 29.8471L349.769 30.9765L347.76 32.4286L345.231 34.0419L344.55 36.6556L345.75 37.9786L347.306 39.0434L346.236 41.1731L344.745 41.6248L344.55 44.8516L343.87 46.6908L342.022 46.4972L341.309 48.046L339.526 48.1428L338.91 46.3036L337.451 44.0771L336.09 41.3667L336.673 40.2696L337.775 38.9789L338.035 36.7524L337.03 35.8166L336.706 33.332L337.484 31.5896L338.878 31.6219L339.299 30.912L338.716 30.2666L340.563 27.7175L341.665 25.7492L342.411 24.4907H343.708L343.902 23.4904L346.495 23.7809L346.463 22.6192L347.306 22.5547L349.251 23.4259L351.585 24.6198L352.168 27.3626L352.752 28.0724Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M376.577 215.453L376.772 216.388L376.869 217.324L376.415 218.228L375.378 218.453L374.373 217.324L374.405 216.614L374.957 215.84L375.151 215.227L375.702 215.098L376.577 215.453Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M387.375 92.7709L384.231 94.9973L382.189 94.1584H382.156L382.351 93.8357L382.221 92.9967L382.513 91.8674L383.388 91.0607L382.999 90.254L382.189 90.1572L381.832 88.5761L382.156 87.7049L382.578 87.2531L382.967 86.8014L382.902 85.672L383.518 86.0592L385.333 85.4784L386.305 85.8656H387.732L389.579 85.0912L390.52 85.1235L392.432 84.8008L391.751 86.0915L390.876 86.6078L391.265 88.1243L390.941 90.6089L387.375 92.7709Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M362.801 121.356L363.158 129.584L361.602 129.423L360.791 130.972L360.37 132.23L360.759 132.714L360.175 133.359L360.402 134.231L359.948 135.069L359.786 135.844L360.402 135.715L360.824 136.522L360.856 137.715L361.537 138.329V138.845L360.37 139.2L359.462 140.039L358.165 142.297L356.48 143.265L354.697 143.136L354.178 143.33L354.373 144.04L353.433 144.782L352.655 145.589L350.353 146.363L349.899 145.911L349.575 145.847L349.251 146.395L347.76 146.557L348.019 145.976L347.436 144.556L347.176 143.717L346.366 143.362L345.264 142.136L345.653 141.168L346.496 141.362L347.014 141.233H348.052L347.014 139.361L347.079 137.974L346.917 136.618L346.172 135.295L346.366 134.295L345.167 134.263V132.94L344.389 132.165L345.134 129.423L347.403 127.487L347.468 124.776L348.052 120.581L348.441 119.678L347.663 118.968L347.63 118.323L346.917 117.774L346.398 114.547L348.181 113.418L355.475 117.387L362.801 121.356Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M321.374 139.138L321.147 140.235L321.698 140.848L322.347 141.558L322.412 142.59L322.801 143.01L322.703 147.785L323.157 149.205L321.698 149.657L321.277 148.915L320.791 147.592L320.629 146.559L321.05 144.72L320.596 143.946L320.402 142.332V140.816L319.656 139.751L319.786 139.105L321.374 139.138Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M511.365 132.359L509.647 132.069L507.346 132.456L506.341 134.166L507.021 136.683L505.303 135.715L503.747 135.779L503.845 134.134H502.256L502.321 136.425L501.608 139.458L501.154 141.297L501.381 142.781L502.58 142.846L503.456 144.75L503.877 146.524L504.979 147.718L506.081 147.944L507.086 149.041L506.535 149.88L505.336 150.138L505.141 149.074L503.585 148.17L503.294 148.525L502.548 147.751L502.159 146.718L501.122 145.556L500.182 144.556L499.955 145.782L499.533 144.621L499.663 143.33L500.052 141.362L500.765 139.232L501.608 137.296L500.733 135.392L500.668 134.424L500.344 133.262L498.95 131.617L498.366 130.584L498.95 130.197L499.404 128.422L498.464 127.035L497.135 125.518L496 123.711L496.713 123.324L497.199 121.098L498.464 121.001L499.371 120.097L500.344 119.613L501.219 120.259L501.511 121.517L502.743 121.614L502.613 123.776L502.937 125.647L504.655 124.421L505.271 124.776L506.308 124.712L506.568 124.002L507.962 124.131L509.582 125.809L510.004 127.874L511.722 129.681L511.851 131.423L511.365 132.359Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M439.888 78.6054L439.434 79.2185L437.489 78.8958L437.684 80.0574L439.467 79.8961L441.768 80.5737L444.88 80.251L445.885 82.1871L446.371 81.9612L447.571 82.4452L447.733 83.2519L448.316 84.4136H446.566L445.334 84.2522L444.524 85.188L443.81 85.3816L443.324 85.8333L442.449 85.1557L442.157 83.4133L441.606 83.3165L441.639 82.6711L440.569 82.2194L440.018 82.9292L440.083 83.7682L439.888 84.0586L438.851 84.0263L438.559 84.9621L437.878 84.5749L436.776 85.2202L436.193 84.9944L436.614 82.897L435.836 81.3481L434.475 80.8641L434.669 79.9606L436.095 80.0574L436.582 78.9281L436.744 77.6051L438.851 77.1211L438.786 78.0891L439.207 78.6377L439.888 78.6054Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M433.828 84.5414L433.309 84.4769L432.369 83.9284L432.272 84.6382L430.91 85.0577L430.975 86.7034L430.132 87.3487L428.836 87.6391L428.706 88.5749L427.442 88.8653L425.529 88.0586L424.978 86.3484L423.682 86.2516L421.315 84.4446L419.921 84.2188L417.782 83.1539L416.518 82.9603L415.869 83.3475L414.702 83.283L413.73 84.4769L412.304 84.8641L411.688 83.4121L411.493 81.2501L410.002 80.5403L410.132 79.1528L408.997 79.0237L408.965 77.2812L410.683 77.7975L412.012 77.1522L410.488 75.8937L409.71 74.7321L408.478 75.2484L408.673 76.765L407.83 75.442L408.414 74.7321L410.229 74.3126L411.493 74.8934L413.049 76.5068L413.892 76.41L415.804 76.3777L415.253 75.3452L416.485 74.6353L417.587 73.4414L420.148 74.5385L420.764 76.1519L421.51 76.5714L423.293 76.4746L423.973 76.8618L425.367 78.9914L427.669 80.4112L429.03 81.3792L431.072 82.3795L433.568 83.283L433.828 84.5414Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M548.706 181.378L548.738 180.765L548.576 180.345L548.835 179.861L550.424 179.41L551.721 179.313L552.304 179.055L552.985 179.313L552.272 179.894L550.294 180.797L548.706 181.378Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M339.784 93.2865L339.751 94.8676L338.909 95.4484L338.39 96.126L337.223 96.9327L337.418 97.7716L337.288 98.6751L336.445 99.1269L335.602 95.4161L334.5 94.5772L334.468 94.0931L333.009 92.8347L332.814 91.2859L333.852 90.1242L334.208 88.4141L333.884 86.4457L334.208 85.3809L336.056 84.5742L337.255 84.8001V85.8649L338.682 85.0905L338.811 85.4777L338.001 86.5103L338.033 87.446L338.649 87.9623L338.487 89.7693L337.353 90.8018L337.742 91.9312L338.649 91.9635L339.103 92.9638L339.784 93.2865Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M389.549 75.9271L391.331 75.8303L393.147 76.8628L393.568 77.5727L393.601 78.573L394.962 79.0893L395.74 79.6701L394.67 80.2832L395.61 82.6387L395.383 83.2841L396.615 84.9297L395.837 85.2847L395.157 84.7684L393.114 84.478L392.434 84.8007L390.521 85.1233L389.581 85.0911L387.733 85.8655H386.307L385.334 85.4783L383.519 86.0591L382.903 85.6719L382.968 86.8012L382.579 87.253L382.158 87.7047L381.412 86.769L381.963 85.9946L380.926 86.1882L379.435 85.7042L378.397 86.898L375.804 87.1239L374.281 86.0268L372.433 85.9623L372.109 86.8012L370.942 87.0594L369.191 85.9623L367.311 85.9946L366.079 83.9294L364.718 82.8001L365.366 81.1867L364.199 80.1864L365.852 78.2181L368.446 78.1535L368.964 76.5724L372.206 76.8628L374.021 75.5399L375.901 74.9591L378.657 74.8945L381.834 76.3466L384.394 77.1533L386.275 76.8306L387.766 77.0242L389.549 75.9271Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M363.675 77.4097L364.064 77.1838L364.42 75.8931L363.545 75.3446L365.166 74.6992L366.657 74.9574L366.949 75.764L368.505 76.4094L368.278 76.9257L366.268 77.0225L365.62 77.6678L364.355 78.7649L363.707 77.8292L363.675 77.4097Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M537.428 114.715L536.974 116.425L535.678 114.65L535.191 113.133L535.807 111.101L536.877 109.52L537.85 110.133L537.817 111.391L537.428 114.715Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M378.294 164.048L378.229 165.306L377.873 166.758L378.391 167.565L379.202 167.081L380.272 166.952L380.498 167.21L381.568 166.694L380.823 165.984L381.439 165.048L382.346 164.112L388.991 168.339L389.089 169.533L391.714 171.598L390.807 174.18L390.904 175.342L392.039 176.084L392.103 176.632L391.552 177.891L391.65 178.504L391.52 179.504L392.103 180.795L392.817 182.86L393.465 183.312L391.974 184.506L389.964 185.312L388.862 185.28L388.181 185.893L386.917 185.958L386.431 186.216L384.259 185.635L383.546 185.699L383.578 185.667L382.994 184.893L382.897 182.699L381.957 181.601L381.828 181.989L381.503 181.44L379.72 181.053L378.683 180.44L377.516 180.085L376.803 179.73L376.706 179.665L375.831 177.536L375.701 176.277L374.242 174.858L374.696 174.083L374.339 173.244L374.404 172.373L374.08 172.083L374.177 171.179L374.372 171.147L375.02 170.405L375.766 169.308L376.22 168.888V168.21L375.831 167.726L375.733 166.92L376.252 166.662L376.349 165.435L375.636 164.274L376.284 164.016L378.294 164.048Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M382.184 153.113L383.059 154.565L383.286 155.598L384.129 157.986L383.448 159.502L382.541 160.857L382.022 161.696V161.793L381.957 161.664L380.985 161.245L380.207 161.761L379.04 162.051L378.197 163.245L378.294 164.052L376.284 164.02L375.636 164.278L374.534 164.923L374.08 164.697L374.112 163.148L374.534 162.342L374.631 160.696L375.02 159.728L375.733 158.663L376.414 158.082L377.03 157.373L376.284 157.082L376.382 154.662L377.127 154.081L378.294 154.565L379.753 154.081H381.05L382.184 153.113Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M375.121 56.3447L375.867 57.2159L375.899 57.6031L378.071 58.313L379.238 57.9903L380.405 58.9261L381.345 58.8938L383.841 59.5391L383.971 60.1522L383.55 61.1848L384.133 62.3142L384.036 62.9918L382.48 63.1208L381.767 63.7017L381.896 64.5729L380.632 64.7342L379.66 65.4118L378.169 65.5086L376.872 66.2831L377.196 67.5415L378.104 68.0255L379.757 67.8964L379.562 68.6386L377.812 68.9935L375.77 70.1552L374.765 69.7357L374.992 68.7999L373.079 68.1869L373.306 67.7996L374.797 67.122L374.246 66.6703L371.621 66.154L371.361 65.3796L369.902 65.6377L369.481 66.7671L368.411 68.2514L367.633 67.8964L366.888 68.2514L366.11 67.8642L366.499 67.6383L366.693 66.9607L367.05 66.2831L366.855 65.9281L367.18 65.7668L367.374 66.0572L368.347 66.1217L368.768 65.9604L368.444 65.7668L368.509 65.4441L367.86 64.9278L367.504 64.0889L366.855 63.7662L366.888 63.0886L366.045 62.54L365.397 62.4432L364.1 61.8301L363.063 62.0237L362.706 62.3142H362.025L361.701 62.7982L360.534 62.9918L360.016 63.3145L359.205 62.7982H358.168L357.131 62.5723L356.482 63.024L356.32 62.4755L355.348 61.9269L355.575 61.1203L355.964 60.5717L356.32 60.7008L355.801 59.7973L357.033 58.1194L357.779 57.8935L357.876 57.345L356.839 55.6025L357.584 55.5057L358.362 54.9894L359.594 54.9249L361.183 55.0862L363.03 55.5702L364.295 55.6025L364.91 55.8929L365.461 55.538L365.948 56.022L367.342 55.9252L368.022 56.1188L367.925 55.1185L368.347 54.6667L369.676 54.57L370.259 54.6345L370.583 54.1827L371.069 54.2795L372.658 54.0859L373.89 55.2153L373.598 55.6348L373.857 56.2479L375.121 56.3447Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M226.815 231.88L226.297 233.203L224.546 234.332L223.185 233.913L222.277 234.138L220.494 233.267L219.327 233.332L218.063 232.17L217.933 230.847L218.225 230.395L217.836 228.33L217.966 226.201L218.128 224.523L219.23 224.297L221.272 225.91L221.888 225.846L223.93 227.169L225.486 228.33L226.718 229.718L226.134 230.718L226.815 231.88Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M438.496 74.4402L439.047 74.6339L438.075 75.9568L439.566 76.7312L440.603 76.215L442.937 77.3121L441.219 78.7964L439.89 78.6028L439.21 78.635L438.788 78.0865L438.853 77.1185L436.746 77.6025L436.584 78.9254L436.098 80.0548L434.671 79.958L434.477 80.8615L435.838 81.3455L436.616 82.8943L436.195 84.9917L434.801 84.54H433.829L433.569 83.2816L431.073 82.3781L429.031 81.3778L427.669 80.4097L425.368 78.99L423.974 76.8603L423.293 76.4731L421.51 76.5699L420.765 76.1504L420.149 74.537L417.588 73.44L416.486 74.6339L415.254 75.3437L415.805 76.3763L413.893 76.4086L411.883 68.858L415.773 67.6641L416.129 67.8254L419.112 69.2774L420.668 70.0519L422.807 71.8911L424.655 71.6007L427.443 71.4394L429.906 72.9237L430.392 74.9888L431.235 75.0211L432.046 76.699L434.217 76.7635L434.963 77.7315H435.611L435.903 76.2472L437.654 74.8275L438.496 74.4402Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M210.283 144.592L208.76 145.818L208.598 146.56L209.181 147.335L208.727 147.722L207.593 148.045V149.013L207.074 149.593L208.274 151.142L208.501 151.723L207.82 152.53L205.745 153.304L204.416 153.627L203.865 154.111L202.406 153.595L201.077 153.337L200.721 153.53L201.531 154.046L201.434 155.434L201.661 156.757L203.217 156.918L203.314 157.37L201.985 157.951L201.758 158.822L200.98 159.177L199.619 159.661L199.262 160.306L197.836 160.435L196.831 159.338L196.312 157.273L195.826 156.531L195.178 156.079L196.118 155.047L196.053 154.595L195.567 153.982L195.21 152.594L195.404 151.11L195.826 150.4L196.215 149.303L195.567 148.948L194.529 149.174L193.2 149.077L192.455 149.303L191.223 147.496L190.153 147.238L187.787 147.432L187.398 146.722L186.944 146.56L186.911 146.109L187.138 145.334L187.041 144.527L186.652 144.043L186.458 143.108L185.518 142.979L186.101 141.752L186.393 140.268L186.976 139.494L187.722 138.913L188.241 137.88L189.44 137.525L189.375 138.009L188.273 138.268L188.824 139.203L188.727 140.3L187.852 141.494L188.467 143.14L189.278 143.011L189.764 141.494L189.213 140.784V139.203L191.547 138.364L191.352 137.396L192.033 136.719L192.584 138.203L193.881 138.235L194.983 139.365L195.048 140.075H196.669L198.646 139.881L199.651 140.784L201.012 141.043L202.082 140.397L202.115 139.881L204.416 139.752L206.588 139.72L205 140.333L205.583 141.333L207.042 141.462L208.403 142.495L208.63 144.14L209.57 144.108L210.283 144.592Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M514.28 117.294L512.173 119.036L510.974 121.005L510.78 122.457L512.498 124.619L514.605 127.329L516.452 128.62L517.781 130.265L519.078 134.105L519.208 137.751L517.814 139.107L515.836 140.462L514.475 142.172L512.335 144.108L511.59 142.785L511.979 141.365L510.553 140.204L512.044 139.365L513.956 139.203L513.049 137.977L515.966 136.364L515.934 133.879L515.35 132.492L515.415 130.427L514.767 128.975L513.178 127.523L511.752 125.716L509.904 123.263L507.538 122.005L507.927 121.263L508.997 120.714L508.024 118.907H505.82L504.685 117.036L503.389 115.39L504.264 114.874L505.69 114.906L507.408 114.648L508.737 113.551L509.742 114.325L511.46 114.712L511.363 115.906L512.368 116.745L514.28 117.294Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M416.156 127.427L414.859 127.976L414.567 128.911V129.621L412.817 130.493L409.964 131.461L408.441 132.913L407.63 133.042L407.079 132.913L406.042 133.784L404.907 134.171L403.384 134.268L402.93 134.397L402.573 134.945L402.087 135.107L401.828 135.623L400.92 135.559L400.369 135.849L399.072 135.752L398.554 134.526V133.397L398.229 132.783L397.808 131.267L397.225 130.428L397.581 130.299L397.354 129.363L397.549 128.976L397.419 128.072L398.197 127.395L397.938 126.524L398.359 125.523L399.137 126.04L399.623 125.846L401.698 125.814L402.055 126.007L403.837 126.233L404.518 126.136L405.004 126.814L405.847 126.459L406.982 124.297L408.603 123.361L413.757 122.555L415.442 125.975L416.156 127.427Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M376.707 179.67L376.804 179.734L377.517 180.089L378.684 180.444L379.722 181.057L380.565 181.993L380.986 183.736L380.662 184.284L380.24 185.962L380.532 187.704L379.949 188.414L379.3 190.35L380.24 190.867L374.665 192.577L374.794 194.061L373.401 194.352L372.331 195.158L372.072 195.868L371.423 196.062L369.77 197.74L368.733 199.095L368.117 199.127L367.533 198.901L365.524 198.675L365.199 198.514V198.353L364.486 197.869L363.319 197.772L361.828 198.224L360.661 196.933L359.494 195.255L359.753 188.64L363.546 188.672L363.416 187.963L363.708 187.188L363.416 186.22L363.643 185.22L363.449 184.574L364.065 184.607L364.162 185.252L365.037 185.22L366.172 185.413L366.788 186.349L368.214 186.64L369.349 185.994L369.738 187.059L371.132 187.349L371.78 188.253L372.493 189.382H373.887L373.822 187.156L373.303 187.543L372.039 186.736L371.553 186.349L371.845 184.284L372.201 181.832L371.812 180.928L372.363 179.605L372.85 179.347L375.346 178.992L375.637 179.089L375.54 179.541L376.156 179.702L376.545 180.122L376.869 180.025L376.707 179.67Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M375.834 208.03L374.894 207.805L374.278 208.063L373.403 207.708H372.689L371.587 206.772L370.193 206.449L369.707 205.126L369.739 204.384L368.994 204.158L367.017 201.9L366.498 200.706L366.141 200.318L365.525 198.673L367.535 198.899L368.119 199.125L368.735 199.092L369.772 197.737L371.425 196.059L372.073 195.866L372.333 195.156L373.403 194.349L374.796 194.059L374.861 194.833L376.385 194.801L377.228 195.22L377.584 195.736L378.459 195.898L379.367 196.543L379.237 199.189L378.816 200.609L378.686 202.158L378.946 202.771L378.654 203.997L378.395 204.191L377.843 205.675L375.834 208.03Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M396.16 165.403L395.09 163.693L395.025 156.142L396.614 153.819L397.1 153.142L398.267 153.109L399.888 151.657L402.254 151.56L407.311 145.333L405.755 145.365L399.693 142.913L398.98 142.171L398.267 141.17L397.554 140.009L397.943 139.299L398.559 138.169L399.175 138.557L399.564 139.428L400.439 140.299H401.347L403.032 139.751L405.01 139.525L406.598 138.879L407.506 138.75L408.154 138.363L409.191 138.299L409.775 138.234L410.585 137.944L411.558 137.718L412.368 137.008H413.081L413.146 137.589L413.016 138.783L413.081 139.88L412.725 140.622L412.271 142.88L411.493 145.171L410.423 147.817L408.932 150.851L407.408 153.174L405.269 156.013L403.454 157.691L400.731 159.756L399.013 161.305L397.003 163.822L396.581 164.919L396.16 165.403Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M355.863 74.4763L355.474 74.5731L354.534 74.8958L354.501 75.3152L354.274 75.283L354.08 74.5408L353.659 74.315L353.27 73.7664L353.529 73.3147L353.918 73.1856L354.08 72.508L354.372 72.3789L354.631 72.6693L354.955 72.7984L355.214 73.1211L355.506 73.2179L355.863 73.6051L356.09 73.5728L355.96 74.0891L355.766 74.315L355.863 74.4763Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M375.831 208.03L376.545 210.934L376.901 212.418L376.447 214.709L376.577 215.451L375.702 215.096L375.151 215.225L374.956 215.838L374.405 216.613L374.373 217.323L375.378 218.452L376.415 218.226L376.869 217.323H378.198L377.647 218.839L377.323 220.55L376.772 221.485L375.475 222.55L375.118 222.84L374.275 223.905L373.692 224.97L372.557 226.454L370.386 228.584L369.057 229.81L367.663 230.778L365.75 231.553L364.875 231.682L364.583 232.263L363.546 231.94L362.671 232.327L360.823 231.94L359.753 232.198L359.04 232.069L357.16 232.908L355.669 233.231L354.534 234.005L353.756 234.07L353.075 233.327L352.492 233.295L351.779 232.359L351.682 232.65L351.487 232.101L351.584 230.875L351.098 229.488L351.682 229.1L351.714 227.519L350.644 225.583L349.866 223.841V223.809L348.699 221.13L349.607 220.098L350.255 220.679L350.515 221.55L351.325 221.711L352.427 222.098L353.367 221.937L354.988 220.872L355.345 213.225L355.798 213.547L356.771 215.516L356.576 216.774L356.933 217.516L358.23 217.29L359.137 216.355L360.012 215.742L360.499 214.741L361.406 214.29L362.152 214.515L362.962 215.096L364.421 215.193L365.588 214.741L365.783 214.096L366.171 213.096L367.144 212.934L367.727 212.16L368.376 210.772L370.061 209.224L372.687 207.707H373.4L374.275 208.062L374.891 207.804L375.831 208.03ZM369.251 225.196L369.608 224.551L370.613 224.228L370.969 223.55L371.585 222.55L371.034 221.905L370.321 221.259L369.445 221.711L368.441 222.518L367.403 223.809L368.603 225.422L369.251 225.196Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M611.433 246.652L611.174 247.491L612.989 246.652L612.827 247.524L612.146 248.395L610.785 249.331L608.483 250.847L606.96 251.686L606.765 252.654L605.469 252.686L603.427 253.461L601.903 254.784L599.245 256.849L597.203 257.752L595.906 258.333L594.415 258.301L593.929 257.623L592.275 257.494L592.6 256.72L594.707 255.236L598.402 253.203L599.796 252.816L601.611 252.041L603.88 250.976L605.728 249.911L607.673 248.395L608.678 247.879L609.812 246.717L611.693 245.781L611.433 246.652Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M620.832 236.81L620.703 239.004L621.643 237.585L622.064 238.165L621.286 239.714L622.226 240.392L623.263 240.553L624.787 239.779L625.5 240.005L623.815 241.844L622.453 243.038L621.189 243.005L620.281 243.619L619.795 244.522L619.276 244.877L617.785 246.006L615.873 247.394L613.928 248.233L614.09 247.684L613.604 247.394L615.84 245.716L616.132 244.554L614.9 243.748L615.484 243.005L617.202 242.296L618.563 240.682L619.374 239.359L619.568 237.972L619.827 237.617L619.536 236.746L619.309 234.939L619.438 233.454L620.152 233.293L620.443 234.455L621.481 234.971L620.832 236.81Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M212.36 270.368L214.305 274.756H215.925L216.898 274.82L216.736 275.595L215.699 276.208L214.921 276.143L213.916 275.982L212.554 275.401L210.804 275.111L208.372 274.014L206.298 272.981L203.121 270.755L204.612 271.174L207.4 272.497L209.766 273.207L210.155 272.304L210.058 270.948L211.16 270.109L212.36 270.368Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M199.164 209.032L199.456 209.548L199.067 211.71L197.251 212.711L197.77 216.163L197.511 216.841L198.159 217.648L197.089 218.938L196.247 220.874L195.955 222.778L196.506 224.779L195.825 226.908L197.414 230.49L197.932 230.877L198.386 232.781L197.867 234.782L198.321 236.524L197.349 237.879L197.867 239.751L198.937 241.784L198.127 242.526L198.192 244.365L198.451 246.462L199.521 248.979L198.97 249.399L200.169 251.754L201.174 252.529L200.914 253.4L201.822 253.787L202.276 254.562L201.692 254.949L202.276 256.143L202.633 258.821L202.406 260.563L202.989 261.596L202.957 262.854L202.081 263.758L203.086 265.855L203.929 266.597L204.934 266.468L205.55 267.953L206.685 269.114L210.607 269.372L212.195 269.695H210.801L210.25 270.179L209.148 270.889L209.699 272.728L209.083 272.76L207.041 272.147L204.61 270.76L202.146 269.631L201.109 268.372L201.012 267.21L199.65 265.855L198.029 262.435L197.965 260.499L199.067 258.95L196.376 258.337L197.251 256.562L196.603 253.174L198.71 253.884L198.127 249.657L196.83 249.108L197.154 251.658L196.02 251.367L195.533 248.463L194.885 244.655L195.242 243.236L194.172 241.235L193.394 238.912L194.107 238.815L194.302 235.491L194.691 232.168L194.723 229.103L193.653 225.973L193.848 224.262L193.167 221.713L193.751 219.196L193.459 215.195V210.871L193.491 206.257L193.005 202.869L192.324 199.933L193.232 199.416L193.588 198.352L194.626 199.771L195.015 201.256L196.052 202.127L195.695 204.127L196.895 206.451L197.9 209.323L199.164 209.032Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M329.513 57.1465L328.605 56.6625L327.6 55.7913L326.142 56.2107L324.975 56.0494L325.785 55.5008L327.082 52.5968L329.189 51.7578L330.485 51.8224L330.777 52.5L330.485 54.307L330.096 55.0491H329.156L329.513 57.1465Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M306.946 85.0868L306.233 85.6031L305.325 85.3127L304.45 85.5385L304.742 83.9252L304.644 82.6667L303.866 82.4731L303.51 81.6987L303.672 80.3435L304.385 79.6013L304.547 78.7624L304.936 77.5362V76.665L304.644 75.9228L304.579 75.2129L305.195 74.6967L305.909 74.4062L306.298 75.4065H307.27L307.562 75.1484L308.567 75.2129L308.988 76.2455L308.21 76.794L308.113 78.4074L307.854 78.6978L307.756 79.6981L307.011 79.8595L307.659 81.0856L307.14 82.4409L307.724 83.0539L307.465 83.6025L306.816 84.3769L306.946 85.0868Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M547.668 57.2415L552.109 60.7909L549.224 60.1456L550.424 63.0497L553.536 65.1148L554.508 66.5346L552.401 65.3084L552.434 66.8895L550.91 65.1793L549.678 63.211L547.863 61.0491L547.085 59.5002L545.01 56.8543L542.417 54.886L540.213 52.1755L540.829 51.272L539.402 50.3685L539.824 50.0781L541.412 51.3688L543.649 53.2726L545.334 55.2409L547.668 57.2415Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M354.826 50.1467L351.973 50.1789L350.061 49.9531L350.287 49.1141L352.33 48.4688L353.983 48.8237L354.696 49.1141L354.631 49.6626L354.826 50.1467Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M501.928 15.557L500.016 15.5893L497.131 15.3957L496.807 15.2989L497.034 14.6535L498.395 14.4922L501.118 15.1375L501.928 15.557Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M506.018 12.4891L505.661 13.1345L503.424 13.0054L500.085 12.36L499.502 11.8438L502.192 12.0696L506.018 12.4891Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M497.745 11.716L498.75 12.9422L494.114 12.8776L492.623 13.2648L488.571 12.2L487.469 11.1029L488.603 10.8125L491.91 10.877L497.745 11.716Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M395.085 19.7835L394.372 19.9126L389.996 19.6867L389.25 18.9445L386.689 18.4928L386.041 17.557L387.176 17.2021L386.657 16.2986L388.407 14.8788L387.111 14.6852L389.283 13.2332L388.472 12.491L390.676 11.6521L394.015 10.6195L397.808 10.3291L399.429 9.74829L401.601 9.55469L402.962 10.1678L402.541 10.6518L398.845 11.4585L395.636 12.2006L392.816 13.7495L391.908 15.3628L390.839 16.9762L391.843 18.3637L395.085 19.7835Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M538.658 74.5401L538.204 74.1851L537.588 73.1203L538.399 73.0881L537.135 70.668L535.611 68.9255L536.551 68.2157L538.788 68.5706L538.593 66.57L537.686 64.3758L537.783 63.6337L537.361 61.7944L535.125 62.4075L534.282 63.1819H531.818L529.873 61.3104L526.956 59.8584L523.714 59.213L521.705 57.277L520.246 56.0508L519.014 55.1796L516.518 53.179L514.573 52.4691L511.785 51.856L509.775 51.9205L508.122 52.2755L507.571 53.2758L508.771 53.7275L509.581 54.8246L509.16 55.47L509.224 57.5674L509.84 58.4709L508.414 59.7293L506.015 58.9549L504.2 59.1485L502.936 58.4709L501.833 58.245L500.407 59.6648L498.495 59.9874L497.328 60.5037L495.123 60.181H493.632L492.044 59.1485L489.904 58.2127L488.154 57.9223L486.306 58.1805L485.01 58.5677L482.254 57.7287L481.087 56.2444L478.915 55.7281L477.359 55.47L475.09 54.6633L474.669 56.7284L475.966 57.89L475.188 59.3098L472.594 58.7935L470.973 58.729L469.417 57.7932L467.732 57.761L466.014 57.1479L464.101 58.0836L461.929 59.7938L460.406 60.1488L459.855 60.3101L458.428 59.0839L456.483 59.3743L455.414 58.5031L454.117 58.1159L452.788 56.9543L451.718 56.5993L449.709 57.1156L446.986 55.9863L446.629 57.0188L440.697 51.9851L437.974 50.4685L438.233 49.8232L435.251 51.6947L433.825 51.7915L433.468 50.7267L431.167 50.049L429.773 50.533L428.346 48.5002L425.396 48.0807L424.392 48.8874L420.858 49.6296L420.307 50.1136L414.796 50.7912L414.343 51.4688L415.996 52.824L414.699 53.3403L415.185 53.8566L414.051 54.8246L417.098 56.2121L417.033 57.1479L414.764 57.0511L414.505 57.6642L412.138 56.6316L409.642 56.6639L408.216 57.5028L406.076 56.6961L402.187 55.3086L399.723 55.3732L397.097 57.5351L397.292 58.9871L395.347 57.8255L394.634 60.052L395.217 60.4392L394.666 61.988L396.384 63.3433L397.551 63.2787L398.945 64.634L399.01 65.6665L399.917 66.0215L399.464 67.2154L397.972 67.538L396.806 69.6354L398.75 71.6037L398.88 72.959L401.247 75.3791L400.436 76.218L400.242 76.7343L399.464 76.5729L398.07 75.3468L397.583 75.2822L396.417 74.7982L395.736 73.9593L394.083 73.5398L393.143 73.8625L392.753 73.4753L390.29 72.475L387.794 72.1523L386.303 71.7974L386.173 72.0555L383.709 70.313L381.7 69.5386L380.046 68.3447L381.213 68.022L382.251 66.3441L381.181 65.5374L383.418 64.6985L383.288 64.2467L381.894 64.5694L381.764 63.6982L382.478 63.1174L384.034 62.9883L384.131 62.3107L383.547 61.1813L383.969 60.1488L383.839 59.5357L381.343 58.8903L380.403 58.9226L379.236 57.9868L378.069 58.3095L375.897 57.5996L375.865 57.2124L375.119 56.3412L373.855 56.2444L373.596 55.6313L373.887 55.2118L372.656 54.0825L371.067 54.2761L370.581 54.1793L370.257 54.631L369.673 54.5665L369.025 53.2758L368.539 52.6304L368.798 52.4368L370.062 52.5014L370.581 52.0819L370.03 51.5656L368.928 51.2107V50.8557L368.247 50.5008L367.015 49.2101L367.242 48.6938L366.886 47.758L365.33 47.3063L364.552 47.5322L364.26 47.0481L362.542 46.5641L361.861 45.4025L361.537 44.4667L360.726 44.0473L361.245 43.4342L360.467 41.6272L361.31 40.5301L361.018 40.2074L362.477 39.1426L360.726 38.2391L363.32 35.8513L364.422 34.7542L364.714 33.8185L362.315 32.56L362.607 31.3339L361.018 29.9786L361.569 28.4298L359.462 26.3969L360.402 25.0417L358.036 23.8478L357.906 22.6216L358.944 22.4603L361.018 21.7827L362.218 21.1696L364.714 22.2021L368.506 22.6216L374.244 24.6222L375.573 25.4612L376.059 26.6551L374.86 27.5908L372.753 28.0748L366.205 26.7196L365.265 26.9455L367.89 28.2684L368.215 29.1074L368.83 30.9789L370.808 31.5275L372.04 32.0115L371.975 31.108L370.873 30.3336L371.553 29.6237L375.314 30.7853L376.351 30.3336L374.957 28.9783L377.583 27.2359L378.912 27.3327L380.403 27.9458L380.76 26.7196L379.236 25.6548L379.495 24.5899L378.101 23.4928L382.089 24.0737L383.256 25.0417L381.602 25.2676L381.991 26.2679L383.32 26.8809L385.265 26.4937L385.136 25.3644L387.632 24.4931L391.651 23.0088L392.689 23.0734L391.878 24.1382L393.629 24.3318L394.309 23.7187L396.806 23.6865L398.426 22.9443L400.501 24.0091L401.409 22.8475L399.464 21.8472L399.853 21.2664L404.067 21.7827L406.206 22.3312L412.236 24.3318L412.592 23.4283L410.68 22.4926L410.42 22.1376L408.702 21.944L408.637 21.1373L407.114 19.7821L406.757 19.2335L408.151 17.717L407.957 16.1681L408.67 15.8454L412.365 16.2972L413.305 17.2329L413.014 18.5882L414.213 19.1367L415.445 20.3306L416.677 22.7184L418.848 23.7833L419.01 24.9772L417.876 27.494L419.594 27.7522L419.756 27.1068L420.988 26.6551L420.826 25.7838L421.442 24.9126L420.015 23.9123L419.886 22.7507L418.33 22.6216L417.39 21.6536L417.26 19.9112L414.602 18.5236L416.125 17.3943L414.926 16.2004L415.542 16.1681L416.903 17.0716L417.584 18.7173L419.205 19.0399L417.714 17.8138L419.367 17.1361L421.993 17.0393L425.105 18.0074L422.868 16.6199L421.28 14.8451L423.192 14.5225L426.272 14.587L428.8 14.3611L426.985 13.5222L427.406 12.4574L428.768 12.3928L430.356 11.6184L433.371 11.3925L433.306 10.9408L436.321 10.8117L437.715 11.1667L439.465 10.3277L441.734 10.36L441.248 9.65008L441.54 9.00473L443.549 8.35938L446.24 8.87566L445.105 9.26287L448.153 9.48874L449.482 10.2632L450.097 9.87595L453.631 9.90822L457.391 10.6826L459.174 11.2635L459.984 12.1024L459.206 12.5864L457.067 13.4899L456.71 13.9739L458.526 14.1998L460.86 14.6193L461.638 14.2966L463.518 15.3614L463.583 14.942L465.268 14.6838L469.677 14.942L470.909 15.7164L476.549 15.9745L474.993 14.7161L478.073 15.0065L480.05 14.9742L483.259 15.8454L485.204 16.9103L485.334 17.6202L488.608 18.9754L491.525 19.653L490.553 17.8783L493.6 18.6205L495.221 18.1687L498.397 18.685L498.722 18.2332L501.185 18.4591L498.138 16.878L498.819 16.1681L511.915 17.2652L514.476 18.2655L519.76 19.5562L524.557 19.2335L527.572 19.5239L529.711 20.2338L531.365 21.4923L533.731 21.9763L534.995 21.6213L537.264 21.5891L540.279 21.9117L542.516 21.7181L547.151 23.267L547.962 22.7184L545.206 21.6213L544.623 20.8469L549.582 21.3309L552.176 21.2341L557.297 22.0408L560.377 22.8152L571.139 29.9464L570.491 30.753L568.481 30.624L571.139 31.592L574.089 33.1086L575.45 33.5926L576.682 34.367L577.006 34.851L573.765 34.4638L571.625 35.8513L570.653 36.0772L570.134 37.4002L569.486 38.5618L570.037 39.433L566.309 38.11L564.332 39.5943L562.808 38.8845L562.354 39.7234L560.085 39.433L561.09 40.6914L561.447 42.563L562.387 43.3374L564.591 43.7569L567.541 46.5641L566.212 46.6609L567.314 48.2743L568.837 49.1133L567.217 50.1136L568.967 52.3723L567.119 52.8563L568.578 54.8569L568.027 56.7284L566.179 55.3409L562.776 52.4691L557.524 48.0807L555.417 45.4025L555.45 44.2409L554.542 43.3374L556.39 42.9179L556.325 40.4978L556.552 38.5618L557.362 37.0452L555.223 34.3993L553.699 34.5606L554.736 36.1095L553.569 38.1746L549.582 35.8513L546.632 36.4967V39.6589L549.129 40.8205L546.373 41.3368L544.299 41.5304L542.905 40.1429L540.311 39.8525L539.501 40.7882L534.606 40.4656L530.327 41.0141L529.193 44.7894L527.572 49.3714L530.23 49.6296L532.078 50.8557L533.958 51.2752L534.087 50.3072L535.903 50.4362L540.052 52.5982L541.576 54.2761L542.029 56.2767L543.812 58.6645L545.53 61.8589L545.206 64.7953L545.628 66.1828L544.979 68.5706L544.299 70.9261L544.007 72.12L542.516 73.3139L541.511 73.3462L539.825 72.3459L538.496 73.8625L538.658 74.5401Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M443.162 7.45509L437.294 8.03591L436.873 6.06759L437.586 5.90625L438.591 6.00305L442.676 6.84201L443.162 7.45509Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M377.583 4.22722L376.189 4.38856L375.249 4.51763V4.7435L374.082 4.96937L372.623 4.6467L372.98 4.19495L370.451 4.16268L372.493 3.90454H374.179L374.665 4.25949L375.087 3.93681L375.994 3.71094L377.874 4.00135L377.583 4.22722Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M436.03 6.58426L433.728 6.77786L429.936 6.35838L427.31 5.80984L425.17 4.77728L423.258 4.51914L425.008 3.58338L427.018 3.29297L430.13 3.93832L434.571 5.29356L436.03 6.58426Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M316.58 72.0878L317.228 72.8622L320.308 73.798L320.924 73.3462L322.804 74.282L324.716 74.0238L324.846 75.2177L323.258 76.573L321.118 77.0247L320.956 77.7023L319.919 78.8317L319.27 80.5096L319.919 81.7035L318.946 82.607L318.557 83.9622L317.261 84.3817L316.061 85.9628L313.857 85.9951L312.236 85.9628L311.134 86.6727L310.453 87.4471L309.61 87.2858L308.994 86.5759L308.541 85.4143L306.952 85.0916L306.823 84.3817L307.471 83.6073L307.73 83.0587L307.147 82.4457L307.665 81.0904L307.017 79.8642L307.763 79.7029L307.86 78.7026L308.119 78.4122L308.216 76.7988L308.994 76.2503L308.573 75.2177L307.568 75.1532L307.276 75.4113H306.304L305.915 74.411L305.202 74.7014L304.586 75.2177L304.748 73.7657L304.1 72.8945L306.498 71.4102L308.508 71.7651H310.745L312.495 72.12L313.889 71.991L316.58 72.0878Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M335.732 74.6721L335.246 76.2532L334.468 75.8338L334.047 74.4785L334.339 73.7041L335.376 72.9297L335.732 74.6721Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M328.828 59.6965L329.184 59.8579L329.638 59.8256L330.416 60.3419L332.75 60.7291L331.972 62.0843L331.843 63.5364L331.421 63.8913L330.676 63.6977L330.74 64.214L329.573 65.3433V66.2791L330.351 65.9564L330.935 66.8276L330.903 67.4085L331.389 68.1829L330.838 68.796L331.324 70.3771L332.232 70.6352L332.07 71.5064L330.611 72.6681L327.304 72.1195L324.906 72.7971L324.711 74.0233L322.799 74.2814L320.918 73.3457L320.302 73.7974L317.223 72.8617L316.575 72.0873L317.45 70.8611L317.774 66.7954L316.121 64.6657L314.921 63.6332L312.458 62.8587L312.328 61.3744L314.435 60.955L317.126 61.4712L316.639 59.1802L318.163 60.0515L321.858 58.5026L322.345 56.857L323.706 56.4375L323.965 57.1474L324.679 57.1797L325.457 57.9863L326.591 58.9221L327.402 58.7608L328.828 59.6965Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.5112 122.39L38.1546 122.745L37.7656 122.454L37.9601 121.874L37.8305 121.099L37.9925 120.873L38.3815 120.551L38.3491 120.131L38.4788 119.938L38.6084 119.97L39.2243 120.325L39.5161 120.518L39.743 120.776L40.0347 121.519L39.9699 121.615L39.1595 122.067L38.5112 122.39Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M38.2842 119.165L37.6359 119.294L37.4414 118.875L37.2793 118.713V118.584L37.5062 118.391L38.0897 118.584L38.4787 118.907L38.2842 119.165Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M37.3119 118.069L37.2147 118.295L36.2422 118.231L36.4367 117.973L37.3119 118.069Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M35.7912 117.748L35.6616 117.877L35.5319 117.845L34.916 117.78L34.8187 117.296L34.7539 117.232L35.305 116.941L35.4346 117.07L35.7912 117.748Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M33.0651 116.387L32.8058 116.581L32.2871 116.226L32.4168 116.065L32.7409 115.871L33.1623 115.903L33.0651 116.387Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M174.889 62.7633L172.911 63.4086L171.388 64.2153L169.896 65.0866L169.734 65.377L171.582 64.9575L172.263 65.6351L173.754 65.1511L175.342 64.4735L177.093 63.7959L176.088 64.8607L176.898 65.1188L177.709 65.8932L179.362 65.4415L181.015 65.2802L181.112 65.861L181.599 65.9255L181.988 65.99L182.474 66.7967L180.95 66.9903H180.918L179.719 66.7645L178.26 67.1517L177.06 67.3453L175.537 68.6683L174.564 69.4104L174.694 69.6363L176.477 68.3133H176.704L175.18 69.8944L174.24 71.3142L173.43 72.4758L173.235 73.4761L172.976 73.9601L172.782 74.5087L172.814 75.5735L172.911 75.7348L173.495 75.7026L174.013 75.4767L174.467 75.2186L175.537 74.2183L176.12 72.863L176.088 71.6046L176.542 70.7334L177.385 69.7331L178.065 69.0232L178.941 68.5392L178.811 69.2168L179.524 68.2165L179.945 68.0229L180.497 67.2485L181.728 67.668L182.636 68.4424L182.377 69.3781L181.858 70.3139L180.626 71.1206L180.497 71.6369H180.821L182.215 70.7656L182.733 70.9592L182.571 72.1531L182.344 72.9921L181.145 74.1215L180.497 74.8313L179.621 75.6058L180.497 76.0252L181.307 76.1543L182.604 75.8639L183.803 75.3154L184.775 75.025L186.267 74.4441L188.147 73.218L188.179 73.0244L188.276 72.4113L189.152 72.1531L190.416 72.2499L191.712 72.4113L193.204 71.7337L193.398 70.927L193.333 70.6366L195.538 69.2168L196.413 68.8619L198.941 68.8296H201.956L202.313 68.3456L202.864 68.2488L203.674 67.9261L204.582 66.9903L205.619 65.4092L207.402 63.8927L207.758 64.4089L208.958 64.0863L209.476 64.6671L208.536 67.4098L209.25 68.5714L209.314 69.2491L207.24 70.2171L205.295 70.927L203.35 71.5401L202.053 72.7662L201.632 73.218L201.243 74.3151L201.47 75.3799L202.15 75.4444L202.215 74.7023L202.572 75.154L202.248 75.7348L201.016 76.0575L200.205 76.0252L198.844 76.3802L198.098 76.477L197.094 76.5738L195.473 77.1869L198.098 76.7997L198.455 77.1869L195.894 77.8H194.824L194.954 77.5418L194.273 78.1226L194.727 78.2194L193.917 79.7037L192.199 81.2849L192.231 80.7363L191.875 80.6395L191.486 80.1232V81.2526L191.81 81.6075L191.615 82.382L190.837 83.1886L189.379 84.8343L189.249 84.7698L190.189 83.35L189.541 82.5756L189.865 80.8331L189.249 81.7366V83.0596L188.212 82.7369L189.184 83.3822L188.698 85.3506L189.152 85.5119V86.2218L188.827 88.2869L187.336 89.8035L185.359 90.4166L183.933 91.6427L183.025 91.7718L181.923 92.5462L181.501 93.2238L179.265 94.5791L178.033 95.5794L176.898 96.8055L176.282 98.2576V99.7096L176.477 101.484L176.963 102.936L176.801 103.84L177.223 106.228L176.898 107.647L176.704 108.454L176.056 109.713L175.472 109.971L174.629 109.713L174.5 108.809L173.916 108.325L173.268 106.55L172.749 104.969L172.619 104.163L173.268 102.775L173.008 101.646L172.004 99.9032L171.388 99.5805L169.41 100.549L169.119 100.42L168.47 99.4515L167.498 98.9352L165.423 99.2256L163.932 98.9675L162.538 99.1288L161.728 99.4515L161.922 100L161.695 100.839L161.955 101.258L161.566 101.517L160.982 101.226L160.236 101.613L158.972 101.549L157.903 100.452L156.314 100.71L155.147 100.226L154.013 100.387L152.392 100.871L150.414 102.388L148.437 103.291L147.238 104.259L146.622 105.195L146.298 106.647L146.168 107.615L146.362 108.325L145.649 108.39L144.482 107.938L143.218 107.292L142.926 106.324L142.862 104.872L142.084 103.711L141.792 102.485L141.273 101.065L140.236 100.226L138.777 100.29L137.221 101.904L135.924 101.291L135.179 100.678L135.049 99.516L134.79 98.4512L134.012 97.5477L133.331 96.8701L132.91 96.1279H129.863L129.603 96.9991H128.209H124.709L121.175 95.5471L118.906 94.5468L119.198 94.1273L116.896 94.3532L114.854 94.5145L114.951 93.482L114.271 92.2881L113.557 92.0299L113.59 91.4491L112.65 91.3201L112.261 90.7715L110.705 90.5779L110.413 90.223L110.672 89.0936L109.862 87.0285L109.7 84.1567L109.992 83.6726L109.57 82.995L109.084 81.2526L109.667 79.5747L109.376 78.4453L110.64 76.7351L111.548 74.9927L111.904 73.4116L113.687 71.4755L114.984 69.6363L116.28 67.797L117.674 65.0543L118.258 63.3441L118.387 62.4083L118.841 61.9889L120.721 62.6988L120.397 64.6025L121.11 64.054L121.921 62.4083L122.439 60.7627H127.01H131.775H133.331H138.226H142.991H147.789H152.619H158.065H163.575H166.882L167.303 59.9883H167.854L167.563 61.0854L167.887 61.4081L168.956 61.5371L170.448 61.8598L171.712 62.4729L173.138 62.2147L174.889 62.7633Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M89.1456 44.7238L86.8765 45.4659L86.6172 44.9496L87.3628 44.0462L89.4374 43.3685L90.5719 43.0781L91.4148 43.2072V43.8203L89.1456 44.7238Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.5004 39.3683L75.2362 39.6587L74.6851 39.3038L74.4258 38.7875L76.2735 38.4648L77.246 38.6585L76.5004 39.3683Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M76.8916 32.1367L77.2806 32.4594L78.4152 32.2981L78.9338 32.7821L80.0036 33.0079L79.6146 33.2338L78.0262 33.621L77.4751 33.2015L77.3779 32.8789L75.984 32.9757L75.8867 32.8143L76.8916 32.1367Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M132.906 21.4948L124.932 28.0774L113.392 38.6288L114.753 38.6934L115.661 39.2097L115.823 40.0486L115.92 41.2748L118.384 40.2099L120.491 39.5969L120.296 40.5972L120.556 41.3716L121.074 42.2428L120.718 43.598L120.264 45.8245L121.755 47.0507L120.718 48.2768L119.065 49.2126L118.87 48.5027L118.06 47.8573L119.129 46.1794L118.611 44.5983L119.486 42.7913L118.157 42.6623L115.855 42.63L114.624 42.0492L113.554 40.0809L112.484 39.7259L110.636 39.0483L108.432 39.2097L106.487 38.3384L105.612 37.5317L103.57 37.9189L102.435 39.2419L101.495 39.371L99.3556 39.7582L97.3458 40.4035L95.2712 40.823L96.3085 39.6937L99.0315 37.8221L101.236 37.2413L101.365 36.7896L98.3183 37.8221L95.9195 39.0806L92.2889 40.4358L92.3538 41.3716L89.4363 42.7268L86.9403 43.5335L84.8008 44.1466L83.5042 44.9855L80.0681 45.9858L78.6094 46.8893L75.9513 47.7283L75.076 47.5992L73.0662 48.1155L70.7971 48.7931L68.8197 49.4385L65.5781 50.0193L65.7078 49.6643L68.3659 48.7608L70.5054 48.1478L73.2931 47.0829L75.4002 46.8893L77.021 46.0826L80.3923 44.921L81.1378 44.5338L82.9855 43.8562L84.8657 42.4041L86.8755 41.2748L84.5091 41.8556L84.4118 41.5006L82.8235 42.2105L82.9531 41.2425L81.7861 41.9201L82.3048 40.9844L79.9384 41.7265H79.0308L80.2302 40.5972L81.2999 39.8873L81.1702 39.2097L78.8363 39.5969L78.6418 38.6934L78.2204 38.2416L79.517 37.1768L79.3874 36.3701L81.2999 35.3053L83.7959 34.2404L85.514 33.3047L86.843 33.1756L87.4265 33.466L89.7281 32.5625L90.5385 32.7239L92.3538 32.1431L93.1642 31.3041L92.8076 30.9814L94.7526 30.2715L93.8449 30.3038L91.8351 30.691L90.8951 31.1105L90.3116 30.691L88.0749 30.9169L86.5837 30.4651L86.9727 29.723L86.6486 28.6904L89.6308 27.916L93.9098 27.0448H95.0443L93.6504 27.9483L96.6327 27.8837L97.0217 26.7544L96.2761 26.0768L96.5354 25.1733L96.3085 24.4311L95.2388 23.8826L97.3458 22.9468L99.7771 22.8823L102.63 22.1079L104.186 21.2689L106.746 20.4299L108.302 20.2363L111.933 19.4619L112.938 19.591L116.309 18.6875L117.736 19.0424L117.573 19.8169L118.643 19.4942L120.685 19.591L120.069 19.9782L121.658 20.2686L123.246 20.1073L125.256 20.6236L127.59 20.8172L128.303 21.0108L130.443 20.7526L131.772 21.2689L132.906 21.4948Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M219.557 157.147L220.043 156.243L220.205 155.307L220.529 154.436L219.848 153.21L219.751 151.79L220.756 150.016L221.372 150.242L222.701 150.726L224.614 152.468L224.873 153.307L223.771 155.211L223.187 156.727L222.474 157.534L221.599 157.663L221.34 157.082L220.918 157.018L220.367 157.566L219.557 157.147Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M192.198 136.169L192.036 136.105L191.873 135.944L191.906 135.75L191.971 135.847L192.101 135.976L192.198 136.137V136.169Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.583 124.2H205.518L205.616 124.07H205.714L205.648 124.167L205.583 124.2Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.688 126.456L207.882 126.553L207.818 126.65H207.753L207.526 126.682L207.461 126.65V126.488L207.558 126.456L207.591 126.359H207.655L207.688 126.456Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.688 125.266H207.753L207.818 125.33L207.85 125.459L207.818 125.556L207.753 125.588L207.72 125.524L207.623 125.459V125.298L207.688 125.266Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M409.773 107.551L409.87 107.583L409.935 107.551L410.065 107.777L410.033 107.841L410.065 108.132V108.357L410 108.487L409.968 108.357L409.773 108.099L409.805 107.97L409.74 107.744V107.615L409.773 107.551Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.146 118.101L188.016 118.262L187.951 118.424L187.757 118.521H187.595L187.562 118.488L187.433 118.553L187.271 118.585L187.076 118.521L186.946 118.553L186.914 118.391L187.011 118.327L187.076 118.23L187.206 118.166L187.303 118.036H187.433L187.53 117.972L187.595 118.069L187.757 118.133L187.919 118.069L188.146 117.746H188.243V117.811L188.146 118.101Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.21 117.553L188.145 117.359L188.34 117.262L188.438 117.359V117.424L188.34 117.456L188.21 117.553Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M188.341 115.455L188.405 115.423L188.568 115.52H188.697L188.827 115.552L188.924 115.616V115.713L188.859 115.746L188.697 115.616H188.568L188.535 115.584L188.373 115.649L188.211 115.584V115.552L188.276 115.391L188.341 115.455Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M187.074 114.875L187.009 115.004V115.23L186.976 115.359L186.847 115.456L186.782 115.585L186.652 115.682L186.425 115.778L186.393 115.843L186.328 115.778L186.361 115.714L186.49 115.682L186.555 115.617V115.553L186.685 115.52L186.75 115.391L186.879 115.359L186.976 115.23L186.912 115.133H186.782L186.717 115.069L186.847 114.907L186.879 114.875H187.074Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.462 114.779L186.494 114.811H186.624L186.753 114.875L186.624 115.004L186.591 114.94H186.527L186.397 114.908L186.267 114.843L186.17 114.649L186.267 114.617L186.397 114.649L186.462 114.779Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M183.476 112.871L183.671 113.097L183.768 113.162L183.865 113.323L183.768 113.291L183.735 113.226L183.638 113.194L183.509 113.065L183.444 113.032L183.379 112.903L183.476 112.871Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.673 112.871L184.77 113.065L184.835 113.226V113.355L184.9 113.42L184.965 113.646V113.936L185.03 114.033L185.192 114.097L185.321 114.291V114.549L185.192 114.323V114.259L185.094 114.13L184.9 114.065L184.965 114L184.868 113.904V113.807L184.932 113.71L184.9 113.549L184.803 113.42L184.835 113.387L184.738 113.258L184.705 113.065L184.641 113.097L184.673 112.871Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M185.617 112.874L185.519 112.939L185.421 112.907L185.389 112.842L185.584 112.777L185.617 112.874Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.959 112.263L182.926 112.23L182.828 112.004H182.894L182.959 112.263Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M186.361 112.1L186.231 112.293H186.102L186.166 112.197L186.199 112.003L186.329 111.906L186.361 112.035V112.1Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.362 111.712L180.264 111.744L180.199 111.842L180.102 111.809L180.297 111.68L180.362 111.712Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.428 111.937L180.558 112.002L180.623 111.937L180.655 111.776L180.72 111.743L180.785 111.937V112.098L180.753 112.195L180.785 112.389V112.486L180.655 112.744L180.591 112.776L180.461 112.711L180.526 112.615L180.655 112.55L180.623 112.518L180.428 112.647L180.364 112.582L180.493 112.486H180.364L180.299 112.518L180.234 112.453V112.227L180.266 112.163L180.137 112.002V111.937L180.266 111.872L180.299 111.776L180.396 111.743L180.428 111.679L180.623 111.582L180.655 111.711L180.493 111.84L180.428 111.937Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M184.801 111.742L184.833 111.904L184.768 111.872L184.606 111.904L184.477 111.936L184.444 111.872L184.541 111.807L184.671 111.71V111.646L184.541 111.581L184.477 111.388L184.444 111.194L184.314 111.065V111L184.152 110.839L184.25 110.742L184.379 110.871V111.033L184.444 111.129L184.477 111.291L184.574 111.452L184.703 111.549L184.736 111.646L184.801 111.742Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M181.468 109.973L181.566 110.037L181.371 110.134L181.274 110.102L181.209 110.166L181.047 110.134L181.112 110.037L181.241 109.973H181.468Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M180.106 109.808L180.236 109.743L180.333 109.84L180.301 109.905L180.333 109.969L180.268 110.098L180.365 110.195L180.43 110.485L180.495 110.582L180.625 110.744L180.56 110.969L180.592 111.163L180.528 111.26L180.43 111.292L180.301 111.421L180.203 111.486H180.106L180.009 111.55H179.912V111.421L179.814 111.357L179.847 111.163L179.75 111.26L179.685 111.228L179.49 111.098L179.393 111.002L179.328 110.905L179.555 110.808L179.717 111.034L179.75 110.84L179.652 110.808L179.62 110.711L179.652 110.614L179.847 110.421L179.912 110.292L179.879 110.259L179.976 110.13V109.969L179.912 109.743L179.944 109.711H180.041L180.106 109.808Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M182.728 108.969L182.761 109.033L182.858 109.162L183.117 109.388L183.28 109.42L183.312 109.453L183.377 109.582L183.474 109.711L183.636 109.84V109.905L183.571 110.163L183.539 110.227V110.324L183.506 110.485L183.442 110.582L183.409 110.808L183.377 110.84L183.312 110.647L183.182 110.55L183.215 110.485L183.377 110.518L183.442 110.453L183.409 110.389L183.442 110.259L183.539 110.13L183.571 109.969V109.872L183.409 109.743L183.28 109.517L183.182 109.453L182.988 109.356L182.891 109.259L182.696 109.195L182.566 109.259L182.696 108.969H182.728Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M179.876 106.548L180.038 106.613H180.07L180.297 106.645L180.362 106.58L180.427 106.613H180.589L180.718 106.548H180.848L180.945 106.484L180.978 106.645L180.945 106.709H180.848H180.718L180.362 106.774H180.265L179.778 106.903L179.551 107.032H179.422L179.357 107L179.26 106.903L179.098 106.709L179.292 106.806L179.325 106.871H179.487L179.649 106.806L179.778 106.613L179.681 106.58L179.746 106.484L179.778 106.387L179.876 106.548Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M181.271 106.129L181.531 106.193L181.596 106.161L181.725 106.258L182.017 106.581L182.082 106.774L182.212 106.807L182.438 106.968V107.032L182.374 107.194L182.438 107.42H182.309L182.147 107.549L182.114 107.613L182.017 107.936L181.985 108.226L181.92 108.291L181.823 108.226L181.79 108.097L181.66 108.065L181.758 107.904H181.823L181.985 107.775L181.952 107.645L182.017 107.516V107.42L182.082 107.323V107.129L182.147 107.097L182.212 107L182.244 106.903L182.147 106.871L181.985 106.839L181.952 106.742V106.677L181.823 106.613V106.516L181.725 106.29L181.66 106.258L181.563 106.29L181.401 106.258H181.304L181.109 106.129H181.271Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.906 124.875L205.873 124.777L205.972 124.81L205.906 124.875Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.591 94.8683H206.493L206.46 94.9007L206.493 94.9654L206.363 95.0301L206.33 94.9978L206.395 94.9654H206.428L206.46 94.8683L206.558 94.8359L206.591 94.8683Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M211.19 134.883L210.995 134.818L210.963 134.657V134.399L211.028 134.27L211.093 134.334L211.157 134.528L211.319 134.624L211.352 134.754L211.19 134.883Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M399.755 187.575L399.463 187.542L399.398 187.413V187.316L399.561 187.349L399.787 187.51L399.755 187.575Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M400.957 186.962L401.022 187.285V187.51L400.989 187.575L400.925 187.478L400.795 187.381L400.762 187.317L400.665 187.285L400.471 187.156L400.503 187.123L400.665 187.188L400.762 187.156L400.827 187.026V186.962L400.925 186.93L400.957 186.962Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M399.105 186.634L398.943 186.505L398.846 186.473L398.748 186.408L398.684 186.215L398.716 186.118V186.053L398.781 185.666L398.748 185.634L398.813 185.505L398.975 185.473L399.04 185.569L398.975 185.957L399.008 186.053L399.073 186.183L399.105 186.344L399.17 186.537L399.105 186.634Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M274.826 131.171L274.761 131.268L274.695 131.204V131.107L274.793 131.074L274.826 131.171Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M275.439 131.205L275.375 131.237L275.245 131.205L275.148 131.108L275.115 131.011L275.18 130.882L275.342 130.785H275.472L275.537 131.011L275.504 131.14L275.439 131.205Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M276.573 130.203L276.638 130.235V130.3L276.703 130.364L276.832 130.526H276.897L276.962 130.623L277.027 130.784L277.092 130.848L276.994 131.01L276.897 131.042L276.735 131.01L276.638 130.978L276.541 130.881V130.816L276.476 130.784L276.443 130.655L276.476 130.59V130.494L276.541 130.364L276.476 130.203H276.573Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M277.58 130.203L277.678 130.235L277.71 130.429L277.678 130.558L277.548 130.623L277.418 130.494L277.483 130.364L277.45 130.3L277.58 130.203Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M278.23 128.361L278.327 128.297L278.489 128.361L278.521 128.426V128.652L278.392 128.749L278.294 128.813H278.197L278.035 128.749V128.587L278.1 128.523V128.329L278.132 128.297L278.23 128.361Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M275.633 127.46L275.763 127.428L275.86 127.492H275.99L276.087 127.557L276.119 127.621H275.957L275.73 127.525L275.666 127.557L275.568 127.75L275.471 127.557L275.439 127.525L275.406 127.396L275.504 127.363L275.633 127.46Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M278.165 127.298L278.198 127.33L278.165 127.524L278.1 127.556V127.395L278.035 127.298V127.201L278.002 127.105L278.132 127.008L278.198 127.072L278.165 127.266V127.298Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M274.499 126.875L274.564 126.972L274.596 127.069L274.369 127.165L274.272 127.101L274.207 127.036L274.337 126.907L274.499 126.875Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M274.242 126.297L274.339 126.329V126.394L274.437 126.49L274.372 126.62L274.177 126.716L274.048 126.845L273.821 126.878V126.845V126.684L273.756 126.62V126.555L273.821 126.49H273.886L273.95 126.426L274.177 126.297H274.242Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M194.172 136.976H194.075L193.945 136.879L193.848 136.846L193.751 136.75L193.718 136.685L193.621 136.653L193.556 136.524L193.459 136.427L193.491 136.266L193.653 136.362L193.686 136.524L193.816 136.653L194.042 136.717L194.107 136.814L194.205 136.943L194.172 136.976Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M172.68 121.909L172.777 121.942L172.842 121.812L172.972 121.845H173.134L173.166 121.909L173.101 121.974L173.037 121.942L172.907 121.974L172.842 122.006H172.615L172.68 121.909Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.312 121.102L175.084 121.199L175.149 121.102H175.312Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M175.503 121.129L175.471 121.097L175.731 121L175.666 121.097L175.503 121.129Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M378.685 89.2891L378.718 89.3536L378.815 89.4827L378.685 89.4504H378.588L378.459 89.5149L378.361 89.4181V89.3213L378.459 89.2891L378.523 89.3213L378.685 89.2891Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M378.135 89.4468V89.4791L378.07 89.5436L378.037 89.7372L378.005 89.8018H377.908L377.843 89.8663L377.681 89.9308L377.616 89.9631L377.422 90.0599L377.292 90.0276L377.13 90.0599L377.033 90.189L376.968 90.0922L376.87 90.1244H376.806L376.708 90.0276L376.579 90.1244H376.417L376.255 90.0599L376.092 90.0276L375.963 89.9308L375.866 89.7372L375.768 89.6404L375.703 89.4146L375.639 89.3177L375.671 89.221L375.833 89.3177L375.963 89.2855L376.028 89.1887L376.06 89.0919L376.157 89.0596L376.222 89.0919L376.287 89.0273H376.352L376.384 89.1564L376.546 89.221L376.579 89.2855H376.773L376.968 89.1242L377.097 89.1564L377.195 89.0919L377.292 89.1242L377.422 89.1887L377.486 89.0919H377.584L377.681 89.221V89.4146L377.778 89.35L377.875 89.4146L377.908 89.3823L378.135 89.4468Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.111 129.619L208.273 129.651L208.338 129.813V130.006L208.306 130.265L208.273 130.329L208.209 130.361L208.079 130.426L208.111 130.297L208.079 130.232L208.046 130.006L207.949 129.845V129.748L207.982 129.651V129.555H208.046L208.111 129.619Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M226.074 269.825L226.204 269.792V269.922L225.943 269.825L226.041 269.728L226.106 269.695L226.074 269.825Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M225.846 269.371L225.911 269.436L226.041 269.468L226.074 269.598L225.976 269.63L225.943 269.501L225.878 269.436L225.846 269.371Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M227.855 269.11L227.921 269.143L227.888 269.272L227.79 269.24L227.725 269.143L227.823 269.078L227.855 269.11Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M223.932 268.821V268.886L223.964 268.983L223.835 269.015L223.737 268.983L223.673 268.918L223.575 268.886L223.543 268.757H223.608L223.64 268.692L223.737 268.66L223.802 268.692L223.705 268.789L223.802 268.821L223.9 268.725L223.932 268.821Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.869 268.398L224.74 268.334L224.578 268.237L224.318 268.14L224.351 268.011L224.124 267.979L224.027 267.946L223.929 267.817L223.994 267.785L224.253 267.882L224.513 268.011L224.675 268.043L224.805 268.076L224.902 267.979L224.934 267.882L224.999 267.914L225.129 267.85L225.161 267.914H225.323V268.011H225.42L225.712 267.946L225.745 268.011H225.842L225.971 267.979L225.874 267.914L225.842 267.817H225.971L226.166 267.882L226.198 268.011L226.069 268.172L226.101 268.269L226.036 268.334H225.907L225.809 268.592L225.712 268.689L225.615 268.882L225.583 268.979L225.42 269.076L225.388 269.011H225.258V269.108L224.999 269.076L224.967 269.108L225.064 269.237L225.031 269.269L224.967 269.399H224.837L224.74 269.528L224.642 269.56H224.578L224.513 269.463L224.383 269.366V269.302H224.221L224.416 269.431H224.286L224.124 269.334L224.059 269.302L223.929 269.237L223.832 269.173V269.108L224.059 269.173L224.253 269.108L224.091 269.044L224.059 269.011H224.351L224.48 269.044L224.578 269.108V269.044L224.707 269.011L224.74 268.915L224.61 268.85L224.545 268.689L224.578 268.624H224.772L224.837 268.656L224.967 268.624L224.934 268.527H224.675V268.56L224.545 268.624H224.351L224.189 268.527V268.431L224.416 268.495L224.61 268.431H224.707L224.869 268.398L224.999 268.463V268.431L224.869 268.398Z",
      "fill": "#EBECED"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.869 268.398L224.74 268.334L224.578 268.237L224.318 268.14L224.351 268.011L224.124 267.979L224.027 267.946L223.929 267.817L223.994 267.785L224.253 267.882L224.513 268.011L224.675 268.043L224.805 268.076L224.902 267.979L224.934 267.882L224.999 267.914L225.129 267.85L225.161 267.914H225.323V268.011H225.42L225.712 267.946L225.745 268.011H225.842L225.971 267.979L225.874 267.914L225.842 267.817H225.971L226.166 267.882L226.198 268.011L226.069 268.172L226.101 268.269L226.036 268.334H225.907L225.809 268.592L225.712 268.689L225.615 268.882L225.583 268.979L225.42 269.076L225.388 269.011H225.258V269.108L224.999 269.076L224.967 269.108L225.064 269.237L225.031 269.269L224.967 269.399H224.837L224.74 269.528L224.642 269.56H224.578L224.513 269.463L224.383 269.366V269.302H224.221L224.416 269.431H224.286L224.124 269.334L224.059 269.302L223.929 269.237L223.832 269.173V269.108L224.059 269.173L224.253 269.108L224.091 269.044L224.059 269.011H224.351L224.48 269.044L224.578 269.108V269.044L224.707 269.011L224.74 268.915L224.61 268.85L224.545 268.689L224.578 268.624H224.772L224.837 268.656L224.967 268.624L224.934 268.527H224.675V268.56L224.545 268.624H224.351L224.189 268.527V268.431L224.416 268.495L224.61 268.431H224.707L224.869 268.398ZM224.869 268.398L224.999 268.463V268.431L224.869 268.398Z",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M225.393 267.785H225.491L225.589 267.882L225.491 267.915H225.393V267.785Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M225.069 267.789H224.97L224.938 267.691L225.069 267.724V267.789Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M224.613 267.724L224.807 267.691L224.872 267.788L224.775 267.917L224.71 267.885L224.613 267.917L224.516 267.853L224.613 267.788L224.71 267.853L224.743 267.788L224.58 267.756L224.613 267.724Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M226.946 267.756H227.14L227.173 267.724L227.335 267.691L227.465 267.756L227.594 267.853L227.627 267.95V267.982L227.465 268.014L227.4 267.917L227.335 267.885L227.303 267.982L227.367 268.014L227.4 268.111L227.497 268.046L227.562 268.079L227.594 268.208L227.691 268.24L227.724 268.208L227.886 268.304L227.918 268.175L227.659 268.111L227.691 267.95L227.789 267.885L228.275 267.853L228.502 268.046L228.567 268.079V268.208L228.372 268.175L228.21 268.111L228.016 268.175L228.113 268.24L228.243 268.272L228.534 268.304L228.632 268.337L228.664 268.401L228.599 268.563H228.437L228.405 268.595L228.178 268.627L228.016 268.692L228.113 268.756L227.821 268.885L227.691 268.853L227.529 268.885H227.303L227.108 268.821L226.914 268.692V268.789L227.011 268.853L227.205 268.918L227.303 269.014L227.367 268.982L227.497 269.014L227.627 269.111L227.562 269.143L227.627 269.305H227.562L227.465 269.208L227.335 269.176L227.173 269.305L227.108 269.208L227.011 269.143H226.914L226.751 269.079L226.687 269.111L226.751 269.24H226.849L226.914 269.305L226.849 269.337L227.076 269.531L227.011 269.563L226.881 269.498H226.784L226.687 269.402L226.589 269.369L226.492 269.337L226.46 269.531L226.622 269.563V269.66L226.589 269.724L226.46 269.692L226.427 269.627L226.265 269.563L226.233 269.498H226.168L226.038 269.337L226.136 269.208V269.143L226.006 268.982V268.918L226.168 268.853L226.136 268.789L226.298 268.756L226.265 268.659L226.46 268.53L226.654 268.466L226.784 268.595V268.724L226.881 268.692L226.719 268.498L226.751 268.401L226.557 268.337L226.427 268.24L226.46 268.175L226.589 268.24L226.622 268.079L226.395 268.014L226.427 267.917L226.492 267.95L226.589 267.885H226.687L226.751 267.788L226.654 267.691H226.784L226.946 267.756Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M225.324 267.626H225.551L225.616 267.691L225.68 267.626L225.745 267.658L225.81 267.755L225.745 267.787L225.616 267.755L225.486 267.691L225.227 267.658L225.259 267.594L225.324 267.626Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M223.117 267.273L222.953 267.241L222.986 267.176L223.117 267.273Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.771 36.1406L309.901 36.2052H309.998L310.03 36.2697V36.3988L310.095 36.4956L310.063 36.5601L309.868 36.431L309.804 36.302L309.739 36.2374L309.674 36.1406H309.771Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.869 35.626L310.128 35.6906L310.193 35.7551L310.16 35.8842L310.128 35.9164L309.998 35.7551L309.836 35.7228L309.771 35.5938L309.869 35.626Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.454 35.1832L309.48 35.2349H309.577V35.3317H309.448L309.383 35.3962L309.188 35.3317L309.123 35.2994L309.059 35.2026L309.221 35.1703L309.253 35.1381L309.434 35.168L309.35 35.1058L309.415 34.8477L309.577 34.8799L309.674 35.0413V35.0735L309.869 35.1381L309.966 35.2994L310.063 35.3639L310.031 35.5575L309.869 35.4285L309.804 35.3639L309.739 35.3317L309.707 35.2671L309.642 35.2026H309.48L309.454 35.1832Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.642 34.9778L310.576 34.9127L310.675 34.8477L310.642 34.9778Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M309.865 35.143L309.735 35.0785L309.638 34.9817L309.605 34.8848L309.638 34.8526L309.768 34.8203H309.865L310.059 34.9494L310.027 35.0139L310.059 35.0785L310.254 35.143V35.2075L310.124 35.3043L309.865 35.143Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.579 34.9475L310.482 35.0766L310.385 35.012H310.287L310.352 34.9152L310.32 34.7862L310.352 34.7539L310.417 34.883L310.579 34.9475Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M310.289 34.9453H310.224L310.158 34.8159L310.191 34.7188L310.256 34.8482L310.289 34.9453Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M618.955 150.915L618.889 151.012L618.727 150.979V150.915L618.889 150.785L618.955 150.915Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M609.813 147.496H609.943L610.04 147.561L610.073 147.69L610.008 147.722L610.04 147.786L610.008 147.851H609.813L609.748 147.786V147.722L609.684 147.625V147.528L609.813 147.496Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M572.63 142.143L572.663 142.239H572.565L572.468 142.401L572.436 142.369L572.533 142.11L572.663 142.078L572.63 142.143Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.206 136.973L207.076 137.07L207.011 137.038L206.979 136.876L207.043 136.715L207.141 136.586H207.238L207.271 136.683L207.238 136.909L207.206 136.973Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M583.752 134.072L583.719 134.201V134.394L583.687 134.491H583.589L583.525 134.394L583.492 134.233V134.072L583.687 133.91L583.719 133.846L583.752 133.685L583.816 133.652L583.849 133.717L583.978 133.749L583.914 133.91L583.752 134.072Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.264 126.491H206.166L206.133 126.426L206.198 126.297H206.264L206.296 126.362L206.264 126.491Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.037 126.006L206.005 126.103H205.94L205.809 126.038L205.744 125.973L205.842 125.844L206.005 125.973L206.037 126.006Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.662 133.525L208.598 133.461L208.468 133.396L208.436 133.332V133.138L208.468 133.074L208.695 132.719L208.792 132.783V133.009L208.76 133.267L208.727 133.396L208.662 133.525Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.588 124.556L205.457 124.524L205.522 124.427L205.621 124.395L205.588 124.556Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M454.766 153.208V153.273L454.701 153.241L454.766 153.176V153.208Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M633.348 147.145L633.673 147.274H633.608L633.348 147.145Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M344.877 87.6722L344.812 87.769L344.65 87.7045L344.487 87.6077V87.4463L344.455 87.4141H344.65L344.779 87.5109L344.844 87.5754L344.877 87.6722Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M344.36 87.3209L344.197 87.2885V87.2238L344.328 87.1914L344.458 87.2885L344.36 87.3209Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M584.3 132.657L584.268 132.689L584.202 132.657L584.17 132.592L584.333 132.527L584.398 132.592L584.3 132.657Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M584.791 131.01H584.725L584.627 130.816L584.66 130.719H584.758V130.816L584.823 130.881L584.791 131.01Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M584.952 130.49L584.887 130.555L584.92 130.652H584.789V130.426L584.822 130.361L584.952 130.297L584.92 130.458L584.952 130.49Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M584.333 128.073H584.234L584.201 128.008H584.333V128.073Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M583.714 124.525L583.682 124.46V124.298L583.78 124.266L583.845 124.363L583.714 124.525Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M583.328 123.134L583.197 123.102V123.005L583.263 122.973L583.328 123.037V123.134Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M206.883 127.102L206.949 127.231V127.328L206.883 127.393L206.818 127.361L206.785 127.263L206.883 127.102Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M423.905 203.546L424.035 203.837L423.97 204.03L423.84 204.159L423.872 204.256L423.775 204.353L423.613 204.417H423.451L423.257 204.385L423.224 204.417L423.127 204.321L423.192 204.256L423.224 204.127L423.257 203.901L423.321 203.772L423.484 203.643L423.516 203.578L423.581 203.417L423.71 203.32L423.84 203.353L423.905 203.546Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M434.215 202.866L434.117 202.769L434.247 202.704L434.345 202.672L434.41 202.704L434.378 202.769L434.215 202.866Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M620.835 208.743L620.77 208.775L620.704 208.905L620.574 208.84L620.639 208.678L620.672 208.613L620.77 208.646L620.835 208.743Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M622.261 206.227L622.228 206.259L622.293 206.388H622.39L622.52 206.323L622.487 206.517L622.423 206.582L622.39 206.711L622.228 206.807L622.098 206.743V206.711L622.001 206.614L622.034 206.549L621.969 206.485L622.001 206.356L621.969 206.227H622.001L622.131 206.259L622.261 206.227Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M621.382 204.835L621.317 204.996V205.125L621.253 205.222L621.35 205.287L621.415 205.319L621.447 205.384L621.415 205.448L621.512 205.577H621.447L621.382 205.739L621.317 205.803L621.22 205.771L621.155 205.674L621.123 205.61L620.929 205.577L620.831 205.416V205.351L620.799 205.255H620.896L620.993 205.19L621.123 205.093L621.155 204.996L621.026 204.932L620.896 204.964L620.961 204.835L621.058 204.803L621.123 204.835L621.253 204.738L621.382 204.835Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M620.28 204.32L620.183 204.514L620.151 204.611H620.248L620.086 204.772L620.021 204.837L619.988 204.772L620.086 204.643L620.151 204.482L620.28 204.32Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M620.284 204.317L620.219 204.188H620.35L620.382 204.317H620.284Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M615.774 203.543L615.839 203.575L616.001 203.866L616.098 203.962L616.196 203.93L616.26 203.833L616.552 203.995L616.649 204.156L616.876 204.35L616.974 204.479L617.006 204.576L617.136 204.705L617.168 204.769H617.233L617.33 204.866L617.622 204.93L617.654 205.027V205.156L617.752 205.285L617.881 205.318L617.784 205.479L617.816 205.544L617.946 205.705H617.979L618.108 205.866L618.076 205.995L618.303 206.06L618.432 206.221H618.53L618.627 206.286L618.789 206.415L618.757 206.512H618.854L618.983 206.673L619.178 206.802V206.867L619.275 206.899L619.372 206.996V207.06L619.47 207.254L619.599 207.383L619.632 207.351L619.761 207.544L619.923 207.576L620.021 207.673V207.802L620.053 207.931L620.086 207.964L620.021 208.157L619.794 208.286L619.761 208.19L619.664 208.222L619.567 208.319L619.372 208.06H619.243L619.21 207.996H619.145L619.081 208.093L618.789 207.802H618.724L618.594 207.641L618.627 207.383H618.53H618.4L618.303 207.318L618.27 207.254L618.205 207.221H618.108V207.125L618.043 206.963L617.914 206.996L617.654 206.834L617.622 206.77V206.673L617.525 206.737L617.33 206.641L617.298 206.512L617.168 206.415L617.103 206.253L616.941 206.221L617.006 206.157L616.909 206.06L616.812 206.028L616.714 205.802V205.673L616.649 205.576H616.552L616.487 205.382L616.52 205.318L616.293 205.189L616.196 205.124L616.066 204.93L616.163 204.866L616.098 204.801L616.034 204.705V204.543L615.871 204.446V204.253L615.807 204.156H615.904L615.936 204.059L615.904 203.995H615.709L615.645 203.898L615.807 203.672L615.709 203.575L615.774 203.543Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M616.135 203.642L616.037 203.61L616.07 203.48L616.135 203.642Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M615.387 202.868L615.322 202.932L615.289 202.803L615.355 202.738L615.387 202.868Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M626.605 163.047H626.539L626.506 162.949H626.605V163.047Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M566.536 146.206L566.471 146.335L566.504 146.368L566.439 146.561L566.471 146.626L566.309 146.69L566.244 146.464L566.342 146.4L566.277 146.335L566.374 146.142L566.471 146.109L566.536 146.206Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M196.801 124.524L196.703 124.459L196.736 124.395H196.834L196.867 124.427L196.801 124.524Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M201.532 124.361H201.467L201.175 124.458H200.98L201.045 124.394L201.175 124.329L201.305 124.297L201.499 124.329L201.532 124.361Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M198.451 123.587L198.646 123.619H198.84L198.937 123.651L199.132 123.619L199.229 123.651L199.359 123.619L199.424 123.651L199.586 123.619L199.715 123.651H199.813L200.072 123.716V123.651L200.266 123.716L200.299 123.684L200.558 123.716L200.623 123.781H200.688L200.882 123.877L200.947 123.845L200.915 124.071L200.98 124.168L200.688 124.265L200.591 124.394L200.493 124.587L200.396 124.652L200.299 124.684H200.169L199.975 124.716L199.877 124.781L199.65 124.749L199.586 124.684L199.424 124.749L199.326 124.652L199.099 124.716L198.808 124.684L198.71 124.716L198.516 124.749L198.451 124.781L198.386 124.716L198.257 124.684L198.159 124.749L197.965 124.716L198.062 124.49V124.361L198.127 124.232L198.062 124.039L197.997 124.006L197.965 123.877L198.094 123.813L198.159 123.781V123.619L198.289 123.555L198.451 123.587Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.3091 219.194L63.2764 219.162L63.2109 219.065L63.2437 219L63.3418 219.065L63.3091 219.194Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.653 206.902L66.6202 206.935L66.5215 206.87L66.5873 206.805L66.653 206.902Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.6412 198.929L64.5762 198.897L64.6412 198.703L64.8038 198.574H64.9013V198.639L64.8363 198.768L64.6412 198.929Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M49.1768 198.607L49.4037 198.672L49.501 198.801V198.897L49.4362 198.93L49.2741 198.897L49.1444 198.704L49.112 198.639L48.9175 198.704H48.8527L48.6582 198.672L48.5933 198.542L48.4961 198.381V198.284L48.5285 198.22L48.6906 198.188H48.8527L49.0147 198.252L49.0796 198.381L49.112 198.575L49.1768 198.607Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M48.2026 198.126L48.1374 198.32L47.9746 198.256L48.0072 198.158L48.17 198.094L48.2026 198.126Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.7429 196.738L45.6771 196.771L45.6113 196.673L45.71 196.641L45.7429 196.738Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M45.0586 196.868L44.9612 196.932H44.8638L44.7988 196.674L44.8638 196.609L45.091 196.868H45.0586Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M44.7329 196.285L44.7984 196.318V196.479L44.6675 196.415L44.6348 196.318L44.7329 196.285Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M53.9092 195.35L53.8105 195.383L53.8434 195.285L53.9092 195.35Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M66.23 183.77H66.1318V183.64L66.0664 183.543L66.1973 183.575L66.23 183.705V183.77Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.2236 182.633H65.1582V182.503L65.2236 182.406L65.3218 182.471L65.2564 182.536L65.2236 182.633Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M65.6116 182.12V182.217L65.482 182.249H65.2875V182.346L65.1578 182.314L65.093 182.249L65.0605 182.153L65.2875 182.023H65.3847L65.4495 182.088L65.6116 182.12Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M63.376 181.278V181.408V181.473H63.2778L63.1797 181.343L63.2778 181.246L63.376 181.278Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M64.1543 180.312L64.252 180.345L64.2846 180.377L64.0892 180.442L64.0566 180.345L64.1543 180.312Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M62.9535 180.117L63.2453 180.149L63.3425 180.246V180.311L63.2128 180.408H62.9535L62.9211 180.246L62.8887 180.117H62.9535Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M624.593 185.926L624.69 185.99L624.658 186.119H624.755V186.184H624.496L624.398 186.023L624.463 185.926H624.593Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M612.179 185.732H612.244L612.568 185.991L612.73 186.087L613.022 186.313L612.989 186.41H612.924L612.86 186.475L612.795 186.378H612.762L612.698 186.313L612.665 186.184L612.535 186.152V186.055L612.438 186.023L612.406 186.055H612.341L612.049 185.926L611.984 185.797L612.082 185.668L612.179 185.732Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M624.144 185.249L624.079 185.347L623.98 185.282V185.217L624.079 185.152L624.144 185.249Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.397 183.988L623.43 184.021H623.527L623.494 184.15L623.332 184.214H623.235L623.105 184.246L622.976 184.44L622.943 184.343L622.846 184.375L622.781 184.311V184.214L622.943 184.182V184.117L623.041 183.988L623.267 184.021L623.397 183.988Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M614.868 183.087L614.965 183.055L615.16 183.151L615.322 183.313L615.419 183.41H615.484L615.549 183.474H615.613L615.711 183.571L615.808 183.539L615.938 183.571L616.003 183.635H616.132L616.229 183.603L616.294 183.7L616.359 183.958L616.456 184.055V184.216L616.391 184.281L616.424 184.378L616.294 184.313L616.197 184.378L616.1 184.345L615.938 184.249H615.873L615.678 184.184L615.549 184.152L615.484 184.055L615.387 183.99L615.289 183.958L615.225 183.861L615.095 183.797L615.16 183.668L615.127 183.539V183.41L615.062 183.377L614.868 183.313L614.771 183.345L614.738 183.281L614.771 183.184L614.803 183.087H614.868Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M616.167 181.988L616.134 182.053V182.28L616.068 182.215V182.053L616.167 181.988Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M615.228 181.41L615.325 181.701L615.39 181.83V181.959L615.423 182.12L615.358 182.217L615.228 181.991L615.195 182.088L615.098 181.926L615.13 181.604L615.163 181.539V181.442L615.228 181.41Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M612.502 181.477H612.599L612.696 181.445L612.826 181.477L612.858 181.445H613.02H613.28L613.345 181.542L613.442 181.574L613.507 181.671H613.572L613.636 181.703L613.766 181.832V182.026H613.831L613.961 182.09L613.993 182.187V182.381L613.961 182.413L613.734 182.477L613.669 182.51L613.539 182.477L613.41 182.413H613.28L613.247 182.348L613.085 182.251H612.891L612.729 182.284H612.567L612.405 182.251L612.307 182.187L612.21 182.219L612.113 182.09L612.016 182.026L611.918 181.767L611.854 181.638L611.918 181.574L611.886 181.509V181.283L611.918 181.187L612.113 181.09L612.242 181.154L612.372 181.316L612.405 181.413L612.502 181.477Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M613.251 180.699L613.415 180.861L613.317 180.958L613.219 180.893V180.861L613.251 180.699Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M613.248 180.703L613.183 180.832H613.15L613.021 180.736L612.923 180.768L612.859 180.736L612.826 180.671L612.923 180.639L612.988 180.574L613.15 180.606L613.248 180.703Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M611.109 180.539L611.142 180.604L611.207 180.636L611.142 180.766L611.012 180.83L610.914 180.701L611.109 180.539Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M608.351 179.958L608.416 180.055L608.384 180.152L608.123 180.023L608.286 179.926L608.351 179.958Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M609.452 180.216L609.354 180.151L609.386 180.054L609.484 179.957V180.119L609.517 180.184L609.452 180.216Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M609.163 179.636L609.228 179.604H609.357V179.668L609.228 179.765L609.292 179.829V179.926L609.163 180.055L609.098 180.088L609.001 180.055L608.871 179.926L608.904 179.733L609.001 179.7L609.066 179.571L609.163 179.539V179.636Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M607.998 179.666L607.933 179.699L607.868 179.86L607.998 180.021L607.836 179.957V179.892L607.804 179.796L607.674 179.666V179.602L607.804 179.537L607.836 179.441L607.966 179.344L608.063 179.408V179.537L607.998 179.666Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M612.18 179.507L612.245 179.572L612.213 179.636L612.148 179.604L611.953 179.443L612.018 179.314L612.115 179.281L612.18 179.346L612.148 179.443L612.18 179.507Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M614.287 179.245L614.417 179.503L614.612 179.762V179.858L614.482 179.923V180.084V180.181L614.514 180.246H614.579L614.644 180.342L614.806 180.471L614.838 180.633L614.871 180.73L614.936 180.794L614.871 180.859L614.968 180.955L614.936 180.988L614.968 181.149L614.903 181.214L615.001 181.31L615.033 181.472L615.098 181.633V181.827L615.065 181.859L614.968 181.762L614.871 181.601V181.504L614.774 181.375L614.644 181.278L614.547 181.181L614.385 180.988L614.255 180.891L614.158 180.6L614.093 180.278L614.028 180.052V179.891L613.996 179.762L614.125 179.632L614.093 179.536L613.931 179.31L613.898 179.213L613.931 179.181L614.061 179.213L614.125 179.245L614.223 179.148L614.287 179.245Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M607.576 179.156L607.51 179.027L607.412 178.93H607.543L607.576 179.156Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M607.543 178.828L607.674 178.86L607.707 178.893L607.739 179.055H607.674L607.608 178.925L607.543 178.828Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M608.546 178.894L608.513 178.991H608.578H608.74L608.87 179.217V179.281L608.935 179.378L608.967 179.54L608.902 179.604V179.701L608.708 179.636L608.643 179.572H608.546L608.416 179.475L608.383 179.41L608.351 179.314L608.481 179.346L608.383 179.088L608.351 179.023L608.189 179.056L608.124 179.088H607.994L607.897 179.217L607.768 179.152V178.959L607.832 178.894H607.962V178.765L608.092 178.571L608.221 178.475L608.319 178.41L608.448 178.507L608.513 178.636L608.481 178.862L608.546 178.894Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M606.633 178.894H606.6L606.535 178.636L606.568 178.539V178.41L606.633 178.442L606.666 178.571V178.797L606.633 178.894Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M607.736 178.728L607.639 178.793L607.606 178.76H607.477L607.379 178.664L607.347 178.567L607.314 178.47L607.347 178.373L607.444 178.244L607.606 178.18L607.671 178.244L607.768 178.406V178.599L607.736 178.728Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M606.762 177.605L606.892 177.767V177.799L607.119 177.928L607.086 178.025L606.892 178.251V178.348L606.795 178.38V178.251H606.73V178.122L606.665 177.993L606.568 177.928L606.535 177.831L606.568 177.735L606.632 177.67L606.697 177.605H606.762Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M610.102 177.638L610.2 177.703L610.135 177.735L609.972 177.767L609.939 177.67L610.005 177.605L610.102 177.638Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M610.395 177.636L610.46 177.604L610.622 177.7L610.719 177.733L610.784 177.797L610.881 177.959L610.978 177.991L611.076 178.088V178.184L611.238 178.217V178.313L611.335 178.346L611.432 178.313L611.465 178.346L611.594 178.41L611.627 178.475L611.724 178.443L611.821 178.475L611.854 178.572L611.983 178.668L612.08 178.765L612.21 178.862L612.534 179.185L612.437 179.314L612.534 179.475L612.567 179.669L612.469 179.636L612.372 179.507L612.145 179.249L612.016 179.217L611.854 179.088L611.659 179.056L611.627 178.959L611.432 178.894L611.27 178.733H611.205L610.946 178.539L610.784 178.443V178.378L610.654 178.313L610.589 178.249L610.525 178.12L610.395 178.023L610.362 177.959V177.829L610.233 177.668L610.168 177.636V177.539L610.395 177.636Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M609.906 177.441L609.971 177.506L610.037 177.474L610.134 177.539L610.102 177.603L610.004 177.571L609.906 177.441Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M608.453 177.246H608.617L608.551 177.311L608.453 177.278V177.246Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M609.846 177.246L609.781 177.408L609.748 177.343L609.846 177.246Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M608.968 177.373L608.805 177.405L608.74 177.34L608.838 177.211L608.936 177.243L608.968 177.373Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M604.918 177.086L604.983 177.183L604.918 177.248L604.82 177.215L604.787 177.183L604.918 177.086Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M605.402 176.476L605.499 176.54L605.467 176.637L605.24 176.702L605.143 176.605L605.24 176.411L605.305 176.379L605.402 176.476Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M605.955 176.184V176.345L605.891 176.281V176.216L605.955 176.184Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M606.896 175.694L606.993 175.727L607.123 175.888L607.22 175.953L607.317 175.985L607.415 176.082L607.674 176.211L607.804 176.372V176.501L607.836 176.695L607.901 176.759L607.998 176.856H608.063L608.095 176.985L608.322 177.082L608.452 177.05L608.484 177.082V177.179L608.387 177.211L608.322 177.308L608.16 177.243L607.901 177.114H607.739L607.642 176.985L607.415 176.856L607.22 176.533L607.026 176.211L606.864 176.114L606.637 175.888V175.727V175.662L606.734 175.598L606.831 175.63L606.896 175.694Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M331.907 161.76H331.842L331.777 161.856H331.712L331.68 161.727L331.615 161.469V161.372L331.745 161.211L331.842 161.179L331.939 161.082L332.069 161.114L332.134 161.243L332.166 161.34L332.134 161.469L332.069 161.566L331.972 161.695L331.907 161.76Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M333.4 158.596L333.367 158.693L333.302 158.725L333.205 158.693V158.596L333.27 158.564V158.467L333.335 158.402L333.432 158.435L333.4 158.596Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.589 124.556V124.589L205.457 124.556V124.523L205.589 124.556Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M404.876 181.377L404.779 181.442H404.617L404.487 181.506H404.357V181.442H404.52L404.649 181.409L404.779 181.312H404.844L404.876 181.377Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M404.718 181.278L404.652 181.311H404.521V181.246L404.718 181.278Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M421.537 171.503L421.667 171.632L421.602 171.729L421.537 171.632L421.439 171.568L421.504 171.406L421.537 171.503Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.508 116.684H190.735L190.832 116.813H190.735L190.638 116.78L190.476 116.813L190.443 116.716L190.508 116.684Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M189.638 116.648L189.736 116.778L189.93 116.745L189.865 116.81H189.671L189.541 116.745L189.638 116.648Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M190.351 116.454V116.616L190.187 116.551L190.154 116.454L190.187 116.422L190.351 116.454Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.373 139.461L208.309 139.622L208.211 139.751L208.147 139.784L208.114 139.913L208.179 140.106L208.114 140.139V140.364L208.179 140.461L208.244 140.526L208.179 140.59L208.147 140.687V140.913L208.082 140.945L207.952 141.01L207.79 141.042H207.693L207.531 141.074L207.369 141.042L207.239 141.074L207.142 141.042L206.98 141.107L206.85 141.042H206.655L206.558 141.107L206.461 141.074L206.623 141.01L206.72 140.913L206.85 140.881L206.98 140.784L207.044 140.687L207.239 140.719L207.336 140.59L207.271 140.332L207.336 140.203V140.042V139.977L207.239 139.848L207.142 139.816L207.012 139.784L206.98 139.751L207.109 139.655L207.466 139.622L207.531 139.558H207.887L207.92 139.525L208.309 139.461H208.373Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M209.151 138.43L209.119 138.591L209.021 138.623L208.892 138.72H208.827L208.6 138.849L208.535 138.785L208.632 138.688L208.859 138.526L209.151 138.43Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M647.967 179.605V179.539H648V179.572L647.967 179.605Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.175 134.686L208.143 134.718L207.98 134.622V134.493L208.045 134.396L208.11 134.234H208.24L208.273 134.363L208.24 134.622L208.175 134.686Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.961 123.716L202.831 123.781H202.798L202.701 123.845L202.668 123.813L202.701 123.716L202.896 123.684L202.961 123.716Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.442 125.135L202.539 125.232L202.183 125.296L202.15 125.135L202.377 125.07L202.442 125.135Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.667 123.907L202.602 123.972H202.439V123.907L202.537 123.875L202.667 123.907Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M202.213 123.848L202.343 123.944L202.278 124.009L202.18 123.944H202.018L202.083 123.88L202.213 123.848Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M626.218 203.867L626.055 203.802L626.12 203.673L626.283 203.641L626.348 203.77L626.315 203.835L626.218 203.867Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.826 202.639H625.761L625.664 202.606L625.534 202.445L625.502 202.316V202.187L625.567 202.122L625.599 201.993L625.696 201.961H625.826L625.761 202.058V202.219L625.988 202.38L625.891 202.477L625.826 202.639Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.82 200.738H625.917L625.949 200.802L625.787 200.834L625.82 200.931L625.949 200.996L625.982 201.093L625.949 201.222L625.82 201.254L625.69 201.157H625.561L625.496 201.093L625.398 201.028L625.431 200.899V200.802L625.496 200.641L625.593 200.512H625.755L625.82 200.544L625.787 200.673L625.82 200.738Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M624.854 198.286L625.048 198.254L625.081 198.286L625.146 198.48L625.21 198.577L625.243 198.609L625.113 198.802L624.854 198.867L624.757 198.77L624.724 198.609L624.627 198.577L624.497 198.673L624.465 198.641L624.53 198.512L624.659 198.415L624.789 198.254L624.854 198.286Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.597 197.027L625.564 196.93H625.663L625.597 197.027Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.081 196.25L625.114 196.411V196.476L625.243 196.508L625.308 196.669H625.47V196.799L625.438 196.831L625.341 196.734L625.243 196.702L625.049 196.766L624.952 196.734L624.919 196.669L624.887 196.54L624.952 196.379L625.016 196.282L625.081 196.25Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.376 196.187H625.343L625.311 196.09H625.376V196.187Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.436 195.738L625.371 195.802H625.176L625.079 195.835L625.014 195.77L624.885 195.738L624.723 195.609L624.755 195.544L624.917 195.48L625.047 195.448L625.176 195.351L625.209 195.254H625.274L625.306 195.351V195.544L625.468 195.673L625.436 195.738Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.916 195.313L623.981 195.41L624.175 195.539L624.402 195.765L624.435 195.797V195.926L624.499 196.023L624.402 196.088L624.273 196.217V196.152L624.175 196.12H624.046L623.981 196.152V196.217L623.851 196.281L623.754 196.249V196.023L623.721 195.829L623.754 195.636L623.786 195.474L623.721 195.313L623.527 195.41L623.462 195.345L623.43 195.249V195.152L623.527 195.055V194.926L623.559 194.829L623.657 194.797L623.851 194.894L623.819 194.958L623.884 195.12L623.851 195.184L623.916 195.313Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.716 194.548H623.618L623.455 194.451V194.419L623.52 194.321L623.585 194.289L623.748 194.321L623.716 194.451V194.548Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.557 194.218L623.688 194.121L623.72 194.153L623.753 194.251H623.589L623.557 194.218Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.407 195.058L625.342 195.026L625.374 194.639L625.342 194.542L625.374 194.38L625.472 194.122L625.504 193.961L625.569 194.155L625.537 194.251V194.445V194.768L625.504 194.961L625.407 195.058Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M624.986 193.994H624.759L624.662 193.961V193.897L624.954 193.671L625.116 193.606L625.278 193.574V193.639L625.181 193.768L625.116 193.865L624.986 193.994Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.6 193.766V193.83H625.502L625.535 193.733L625.6 193.314V193.282L625.632 192.895L625.698 192.927L625.665 193.346L625.698 193.443L625.665 193.604L625.6 193.766Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.556 194.222L623.265 194.19L623.07 194.287L623.038 194.351H622.973L622.941 194.158L622.876 194.125L622.746 193.803L622.876 193.545V193.416L622.843 193.351V192.899L622.811 192.802V192.641L622.876 192.544V192.448L622.941 192.351V192.286L623.038 192.254L623.07 192.415L623.135 192.544L623.2 192.641L623.232 193.061L623.2 193.319V193.351L623.394 193.319L623.492 193.222L623.556 192.964V192.899L623.654 192.835L623.751 192.867L623.719 192.996V193.286L623.816 193.319V193.48L623.751 193.512L623.848 193.641L623.783 193.706V193.867L623.848 194.029L623.816 194.093H623.719L623.556 194.222Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M624.921 191.219L625.051 191.316L625.019 191.445L624.921 191.541L624.857 191.606H624.662V191.477L624.695 191.348L624.759 191.251L624.921 191.219Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M625.112 190.607L625.015 190.671L624.95 190.704V190.768L624.885 190.8V190.704L624.82 190.639L624.787 190.542L624.82 190.413L624.885 190.381L625.015 190.316L625.047 190.381L625.08 190.51V190.542L625.112 190.607Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M623.488 189.253L623.455 189.22L623.488 189.059L623.553 189.123L623.488 189.253Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M195.146 137.011H195.082L195.049 136.849L195.082 136.752L195.049 136.656L194.92 136.623L194.822 136.526L194.855 136.43L195.244 136.623L195.211 136.688V136.817L195.146 136.881V137.011Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.616 125.717L205.551 125.75V125.685L205.583 125.652L205.616 125.717Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M205.132 125.429H205.1L205.132 125.363L205.165 125.396L205.132 125.429Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.759 131.299V131.364L208.888 131.331L208.823 131.493L208.888 131.557V131.622L208.953 131.686L209.018 131.977L208.921 132.073L208.888 131.944L208.856 131.977L208.661 131.944H208.532L208.467 131.848L208.661 131.686H208.532L208.402 131.557L208.37 131.396L208.305 131.235L208.402 131.105L208.532 131.138L208.694 131.235L208.759 131.299Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M287.985 104.356L287.888 104.517L287.759 104.678L287.661 104.549H287.532L287.467 104.485L287.532 104.388L287.661 104.42L287.791 104.291L287.888 104.227L287.953 104.259L287.985 104.356Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M292.392 103.614V103.776L292.457 103.905L292.392 104.131L292.424 104.227L292.295 104.356L292.133 104.421L292.068 104.486L291.873 104.421L291.711 104.26L291.646 104.131V103.937L291.841 103.808L291.873 103.647V103.582L292.068 103.614H292.198L292.295 103.647L292.392 103.614Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M289.182 103.868H289.117L289.02 103.803L288.955 103.706L288.987 103.577L289.02 103.48H289.117H289.214L289.376 103.61L289.409 103.706L289.247 103.868H289.182Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M291.159 102.739V102.804L290.964 102.901L290.835 103.062L290.737 103.127V103.256L290.608 103.481L290.575 103.611L290.413 103.804L290.381 103.869H290.316L290.121 103.933L290.089 103.901L290.057 103.772L289.959 103.643L289.927 103.578L289.862 103.481V103.385L289.732 103.191L289.895 103.094L289.992 103.159L290.186 103.094H290.316L290.478 103.03L290.64 102.901V102.836L290.835 102.739H291.029L291.126 102.707L291.159 102.739Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M294.468 103.646L294.37 103.775L294.241 103.808L294.143 103.775H294.014V103.711H294.111L294.305 103.646L294.435 103.549L294.532 103.453L294.565 103.291L294.597 103.194L294.662 103.033L294.759 102.904L294.856 102.71L294.921 102.452L294.986 102.388L295.116 102.355L295.213 102.452L295.245 102.614L295.213 102.775L295.181 102.936V103.098L295.148 103.13L295.051 103.356L294.954 103.453L294.759 103.485L294.532 103.582L294.468 103.646Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M288.119 102.192L288.216 102.16L288.281 102.257L288.346 102.418L288.281 102.515L288.313 102.644L288.119 102.967L288.086 102.935L288.054 102.806L287.924 102.515L287.892 102.418L287.859 102.354L287.924 102.225L288.021 102.16L288.119 102.192Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M295.927 101.545V101.674L295.862 101.836L295.635 101.997L295.473 102.029L295.344 102.191L295.182 102.126V102.094L295.246 101.965V101.836L295.311 101.739L295.409 101.674H295.506L295.603 101.577H295.765L295.798 101.545L295.862 101.384L295.927 101.352L295.992 101.416L295.927 101.545Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M402.027 188.156L402.092 188.253L402.255 188.318V188.414L402.19 188.479L402.222 188.543L402.125 188.737L402.157 188.802L402.06 188.834L401.995 188.737V188.64L402.06 188.576L401.995 188.35L401.962 188.318L401.93 188.253L402.027 188.156Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M419.788 205.156H419.918L420.048 205.221L420.145 205.318V205.414L420.177 205.576L420.274 205.64L420.339 205.705L420.372 205.769L420.307 205.963L420.274 206.092L420.21 206.157L420.08 206.189H419.788L419.723 206.124L419.464 205.995L419.367 205.834V205.737L419.27 205.543L419.302 205.414L419.367 205.35L419.432 205.221H419.464L419.626 205.156H419.788Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.436 129.041H208.339L208.273 128.912L208.306 128.847L208.404 128.75L208.501 128.815L208.534 128.912V128.977L208.436 129.041Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M207.849 128.2H207.946V128.265V128.297L207.881 128.329V128.588V128.717L207.816 128.781L207.622 128.878V128.813L207.557 128.749L207.525 128.588V128.426L207.492 128.265V128.168L207.557 128.071L207.654 128.039L207.816 128.136L207.849 128.2Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M208.306 128.074L208.435 128.106L208.598 128.235L208.176 128.332L208.079 128.364L207.949 128.267L207.982 128.074L208.046 128.041L208.014 127.848L208.046 127.783L208.144 127.719L208.241 127.848V127.977L208.306 128.074Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M644.792 201.645L644.693 201.677L644.726 201.547L644.792 201.645Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M642.357 201.125L642.422 201.19L642.519 201.222V201.319L642.357 201.383L642.195 201.286L642.033 201.383H641.935L641.871 201.48L641.903 201.577L641.773 201.544L641.741 201.609L641.611 201.577L641.579 201.609L641.449 201.544L641.546 201.512L641.611 201.48L641.676 201.415L641.806 201.448L641.903 201.351L641.968 201.254L642.13 201.222L642.292 201.125H642.357Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M642.653 201.096L642.587 201.129L642.521 201.096L642.587 201.031L642.653 201.096Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M644.56 199.126L644.592 199.287L644.527 199.481L644.494 199.416L644.462 199.287H644.396L644.429 199.126L644.494 199.094L644.56 199.126Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M643.72 198.676H643.687L643.654 198.546L643.72 198.482L643.851 198.449V198.579L643.785 198.643L643.72 198.676Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M643.008 197.87L642.975 197.999L643.073 198.064L643.105 198.161L643.202 198.29L643.3 198.322L643.332 198.419H643.397L643.429 198.548L643.332 198.709L643.364 198.774L643.397 198.935L643.3 199V199.161H643.364L643.397 199.322L643.3 199.419L643.105 199.484L643.073 199.419L642.975 199.451L642.943 199.516L642.846 199.419L642.586 199.516L642.327 199.742L642.23 199.709L642.1 199.774L642.003 199.742L641.808 199.774L641.711 199.709L641.419 199.613L641.322 199.58L641.128 199.548L641.063 199.516L640.901 199.451L640.836 199.129L640.933 198.903H641.03L641.128 198.871L641.16 198.709L641.257 198.677L641.29 198.548L641.225 198.483L641.419 198.354L641.549 198.193L641.581 198.225L641.776 198.064H641.841L642.133 197.935L642.327 197.999L642.424 197.967L642.586 197.902L642.781 197.87L642.878 197.773L643.008 197.87Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M645.05 197.931L644.984 197.963L645.05 197.672H645.181L645.148 197.801L645.05 197.931Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M641.353 197.286L641.288 197.383L641.125 197.48V197.383L641.255 197.254L641.353 197.286Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M646.184 197.159L646.119 197.094L646.152 197.03L646.314 196.868L646.411 196.707L646.314 197.062L646.184 197.159Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M646.508 195.544L646.378 195.673L646.119 196.028L646.021 196.06L645.795 196.19L645.73 196.383L645.6 196.448L645.535 196.544L645.503 196.609L645.6 196.641L645.795 196.544L645.827 196.512L645.924 196.415L645.989 196.319L646.184 196.222L646.281 196.125L646.475 196.028V196.125L646.313 196.351L646.248 196.383L646.281 196.577L646.184 196.674L646.086 196.577H645.957L645.795 196.609L645.665 196.706L645.438 196.738H645.114L645.276 196.577L645.146 196.512L644.952 196.577L644.822 196.641V196.706L644.725 196.738L644.66 196.77L644.628 196.899L644.563 196.996L644.465 196.964V196.899L644.336 196.867L644.206 196.932L644.141 197.093L644.044 197.158H643.947V197.061V196.932L643.882 196.803L643.914 196.738L643.882 196.706L643.688 196.77V196.641L643.817 196.544H643.85L643.817 196.383L643.914 196.351L644.077 196.448L644.271 196.319H644.336L644.433 196.222H644.498L644.595 196.125V196.06L644.855 196.028L645.146 195.931L645.243 195.899L645.373 195.931L645.535 195.867L645.6 195.738H645.665L645.73 195.609L645.859 195.641L645.892 195.576L645.957 195.609L646.281 195.447L646.313 195.544L646.378 195.512L646.443 195.544L646.54 195.447L646.702 195.383L646.735 195.415L646.573 195.544H646.508Z",
      "fill": "#EBECED",
      "stroke": "#888F94",
      "stroke-width": "0.0645351",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M329.117 30.6602L326.832 30.6543L326.996 29.7344L329.146 29.7402C329.514 29.7402 329.85 29.6777 330.154 29.5527C330.463 29.4277 330.717 29.2402 330.916 28.9902C331.119 28.7402 331.244 28.4219 331.291 28.0352C331.334 27.7031 331.301 27.418 331.191 27.1797C331.086 26.9375 330.918 26.75 330.688 26.6172C330.457 26.4844 330.178 26.4121 329.85 26.4004L327.834 26.3945L326.516 34H325.408L326.891 25.4688L329.879 25.4746C330.387 25.4863 330.838 25.5938 331.232 25.7969C331.631 25.9961 331.936 26.2832 332.146 26.6582C332.357 27.0332 332.439 27.4883 332.393 28.0234C332.342 28.625 332.162 29.1211 331.854 29.5117C331.549 29.9023 331.156 30.1914 330.676 30.3789C330.199 30.5664 329.68 30.6602 329.117 30.6602ZM332.791 30.9355L332.809 30.8008C332.855 30.375 332.961 29.9648 333.125 29.5703C333.293 29.1758 333.514 28.8242 333.787 28.5156C334.061 28.207 334.385 27.9648 334.76 27.7891C335.135 27.6133 335.553 27.5312 336.014 27.543C336.459 27.5508 336.84 27.6465 337.156 27.8301C337.477 28.0137 337.734 28.2578 337.93 28.5625C338.129 28.8633 338.268 29.2031 338.346 29.582C338.424 29.9609 338.443 30.3516 338.404 30.7539L338.393 30.8887C338.342 31.3145 338.232 31.7227 338.064 32.1133C337.896 32.5039 337.674 32.8516 337.396 33.1562C337.123 33.4609 336.799 33.7012 336.424 33.877C336.049 34.0488 335.633 34.1289 335.176 34.1172C334.734 34.1094 334.354 34.0156 334.033 33.8359C333.717 33.6523 333.461 33.4102 333.266 33.1094C333.07 32.8086 332.934 32.4707 332.855 32.0957C332.777 31.7207 332.756 31.334 332.791 30.9355ZM333.863 30.8008L333.852 30.9414C333.824 31.1875 333.822 31.4434 333.846 31.709C333.873 31.9746 333.936 32.2207 334.033 32.4473C334.135 32.6738 334.281 32.8594 334.473 33.0039C334.664 33.1484 334.912 33.2246 335.217 33.2324C335.541 33.2402 335.826 33.1777 336.072 33.0449C336.318 32.9082 336.527 32.7246 336.699 32.4941C336.875 32.2637 337.014 32.0078 337.115 31.7266C337.221 31.4453 337.291 31.166 337.326 30.8887L337.338 30.7539C337.365 30.5078 337.365 30.252 337.338 29.9863C337.314 29.7168 337.252 29.4668 337.15 29.2363C337.053 29.002 336.908 28.8125 336.717 28.668C336.525 28.5195 336.277 28.4414 335.973 28.4336C335.648 28.4219 335.361 28.4863 335.111 28.627C334.865 28.7637 334.656 28.9492 334.484 29.1836C334.312 29.418 334.174 29.6777 334.068 29.9629C333.967 30.2441 333.898 30.5234 333.863 30.8008ZM343.262 32.7051L344.598 25H345.664L344.1 34H343.133L343.262 32.7051ZM339.441 30.9473L339.453 30.8242C339.504 30.4336 339.598 30.043 339.734 29.6523C339.875 29.2617 340.064 28.9043 340.303 28.5801C340.541 28.2559 340.83 27.998 341.17 27.8066C341.51 27.6152 341.906 27.5254 342.359 27.5371C342.766 27.5488 343.105 27.6445 343.379 27.8242C343.652 28.0039 343.867 28.2422 344.023 28.5391C344.184 28.832 344.291 29.1543 344.346 29.5059C344.404 29.8574 344.422 30.2109 344.398 30.5664L344.334 31.1055C344.268 31.4844 344.158 31.8555 344.006 32.2188C343.854 32.582 343.656 32.9102 343.414 33.2031C343.176 33.4922 342.889 33.7207 342.553 33.8887C342.221 34.0566 341.84 34.1348 341.41 34.123C340.996 34.1074 340.652 34 340.379 33.8008C340.109 33.6016 339.898 33.3457 339.746 33.0332C339.598 32.7168 339.5 32.377 339.453 32.0137C339.41 31.6465 339.406 31.291 339.441 30.9473ZM340.531 30.8125L340.52 30.9355C340.492 31.1699 340.482 31.418 340.49 31.6797C340.502 31.9375 340.547 32.1816 340.625 32.4121C340.703 32.6387 340.83 32.8262 341.006 32.9746C341.182 33.1191 341.42 33.1973 341.721 33.209C342.041 33.2168 342.338 33.1445 342.611 32.9922C342.885 32.8398 343.119 32.6367 343.314 32.3828C343.51 32.1289 343.65 31.8535 343.736 31.5566L343.965 30.1328C343.977 29.918 343.951 29.7129 343.889 29.5176C343.826 29.3184 343.732 29.1406 343.607 28.9844C343.486 28.8281 343.336 28.7031 343.156 28.6094C342.98 28.5117 342.783 28.4609 342.564 28.457C342.236 28.4453 341.953 28.5098 341.715 28.6504C341.477 28.7871 341.275 28.9727 341.111 29.207C340.951 29.4375 340.824 29.6934 340.73 29.9746C340.637 30.2559 340.57 30.5352 340.531 30.8125ZM350.803 27.6602H351.775L350.715 33.8594C350.641 34.3867 350.471 34.8516 350.205 35.2539C349.943 35.6562 349.6 35.9688 349.174 36.1914C348.752 36.4141 348.27 36.5195 347.727 36.5078C347.441 36.5 347.162 36.4512 346.889 36.3613C346.615 36.2715 346.363 36.1445 346.133 35.9805C345.902 35.8164 345.709 35.6152 345.553 35.377L346.162 34.7441C346.346 35.0059 346.562 35.2129 346.812 35.3652C347.066 35.5215 347.355 35.6055 347.68 35.6172C348.035 35.625 348.35 35.5586 348.623 35.418C348.9 35.2812 349.125 35.084 349.297 34.8262C349.473 34.5684 349.588 34.2656 349.643 33.918L350.475 29.002L350.803 27.6602ZM346.016 30.9473L346.033 30.8184C346.08 30.4277 346.172 30.0371 346.309 29.6465C346.449 29.2559 346.637 28.9004 346.871 28.5801C347.105 28.2559 347.393 28 347.732 27.8125C348.072 27.6211 348.469 27.5293 348.922 27.5371C349.332 27.5488 349.674 27.6445 349.947 27.8242C350.221 28.0039 350.436 28.2422 350.592 28.5391C350.752 28.832 350.859 29.1543 350.914 29.5059C350.973 29.8574 350.99 30.2109 350.967 30.5664L350.902 31.1055C350.836 31.4844 350.727 31.8555 350.574 32.2188C350.422 32.582 350.225 32.9102 349.982 33.2031C349.74 33.4922 349.451 33.7207 349.115 33.8887C348.783 34.0566 348.404 34.1348 347.979 34.123C347.561 34.1074 347.215 34 346.941 33.8008C346.672 33.6016 346.463 33.3457 346.314 33.0332C346.166 32.7168 346.07 32.377 346.027 32.0137C345.984 31.6465 345.98 31.291 346.016 30.9473ZM347.1 30.8125L347.082 30.9414C347.055 31.1758 347.047 31.4219 347.059 31.6797C347.07 31.9375 347.115 32.1816 347.193 32.4121C347.271 32.6387 347.396 32.8262 347.568 32.9746C347.744 33.1191 347.982 33.1953 348.283 33.2031C348.604 33.2148 348.9 33.1445 349.174 32.9922C349.447 32.8398 349.682 32.6367 349.877 32.3828C350.072 32.1289 350.213 31.8535 350.299 31.5566L350.527 30.1328C350.539 29.918 350.514 29.7109 350.451 29.5117C350.389 29.3125 350.295 29.1348 350.17 28.9785C350.049 28.8223 349.9 28.6973 349.725 28.6035C349.549 28.5098 349.35 28.4609 349.127 28.457C348.799 28.4453 348.516 28.5098 348.277 28.6504C348.039 28.7871 347.838 28.9727 347.674 29.207C347.514 29.4414 347.387 29.6992 347.293 29.9805C347.199 30.2617 347.135 30.5391 347.1 30.8125ZM352.537 30.9355L352.555 30.8008C352.602 30.375 352.707 29.9648 352.871 29.5703C353.039 29.1758 353.26 28.8242 353.533 28.5156C353.807 28.207 354.131 27.9648 354.506 27.7891C354.881 27.6133 355.299 27.5312 355.76 27.543C356.205 27.5508 356.586 27.6465 356.902 27.8301C357.223 28.0137 357.48 28.2578 357.676 28.5625C357.875 28.8633 358.014 29.2031 358.092 29.582C358.17 29.9609 358.189 30.3516 358.15 30.7539L358.139 30.8887C358.088 31.3145 357.979 31.7227 357.811 32.1133C357.643 32.5039 357.42 32.8516 357.143 33.1562C356.869 33.4609 356.545 33.7012 356.17 33.877C355.795 34.0488 355.379 34.1289 354.922 34.1172C354.48 34.1094 354.1 34.0156 353.779 33.8359C353.463 33.6523 353.207 33.4102 353.012 33.1094C352.816 32.8086 352.68 32.4707 352.602 32.0957C352.523 31.7207 352.502 31.334 352.537 30.9355ZM353.609 30.8008L353.598 30.9414C353.57 31.1875 353.568 31.4434 353.592 31.709C353.619 31.9746 353.682 32.2207 353.779 32.4473C353.881 32.6738 354.027 32.8594 354.219 33.0039C354.41 33.1484 354.658 33.2246 354.963 33.2324C355.287 33.2402 355.572 33.1777 355.818 33.0449C356.064 32.9082 356.273 32.7246 356.445 32.4941C356.621 32.2637 356.76 32.0078 356.861 31.7266C356.967 31.4453 357.037 31.166 357.072 30.8887L357.084 30.7539C357.111 30.5078 357.111 30.252 357.084 29.9863C357.061 29.7168 356.998 29.4668 356.896 29.2363C356.799 29.002 356.654 28.8125 356.463 28.668C356.271 28.5195 356.023 28.4414 355.719 28.4336C355.395 28.4219 355.107 28.4863 354.857 28.627C354.611 28.7637 354.402 28.9492 354.23 29.1836C354.059 29.418 353.92 29.6777 353.814 29.9629C353.713 30.2441 353.645 30.5234 353.609 30.8008ZM360.887 28.7031L359.967 34H358.906L360.008 27.6602H361.039L360.887 28.7031ZM362.943 27.6074L362.844 28.627C362.762 28.6113 362.678 28.5977 362.592 28.5859C362.51 28.5742 362.428 28.5684 362.346 28.5684C362.092 28.5645 361.863 28.6035 361.66 28.6855C361.461 28.7637 361.283 28.875 361.127 29.0195C360.975 29.1641 360.844 29.334 360.734 29.5293C360.629 29.7246 360.545 29.9355 360.482 30.1621L360.148 30.3379C360.191 30.0215 360.262 29.6973 360.359 29.3652C360.461 29.0332 360.6 28.7266 360.775 28.4453C360.955 28.1641 361.18 27.9375 361.449 27.7656C361.723 27.5938 362.051 27.5137 362.434 27.5254C362.52 27.5254 362.604 27.5332 362.686 27.5488C362.771 27.5645 362.857 27.584 362.943 27.6074ZM365.105 27.6602L364.004 34H362.943L364.045 27.6602H365.105ZM364.256 25.9961C364.256 25.8125 364.312 25.6602 364.426 25.5391C364.543 25.4141 364.693 25.3496 364.877 25.3457C365.061 25.3418 365.211 25.3984 365.328 25.5156C365.449 25.6328 365.508 25.7812 365.504 25.9609C365.504 26.1406 365.443 26.291 365.322 26.4121C365.205 26.5293 365.057 26.5898 364.877 26.5938C364.697 26.5977 364.549 26.5449 364.432 26.4355C364.314 26.3223 364.256 26.1758 364.256 25.9961ZM368.334 33.2324C368.592 33.2363 368.832 33.1875 369.055 33.0859C369.277 32.9844 369.467 32.8398 369.623 32.6523C369.779 32.4648 369.891 32.248 369.957 32.002L370.965 31.9961C370.902 32.4219 370.736 32.7949 370.467 33.1152C370.201 33.4355 369.875 33.6855 369.488 33.8652C369.105 34.041 368.705 34.125 368.287 34.1172C367.842 34.1094 367.463 34.0176 367.15 33.8418C366.842 33.6621 366.594 33.4238 366.406 33.127C366.219 32.8301 366.09 32.4961 366.02 32.125C365.949 31.75 365.934 31.3652 365.973 30.9707L365.996 30.7188C366.043 30.293 366.146 29.8887 366.307 29.5059C366.467 29.1191 366.68 28.7773 366.945 28.4805C367.215 28.1797 367.533 27.9453 367.9 27.7773C368.268 27.6094 368.68 27.5312 369.137 27.543C369.582 27.5508 369.969 27.6562 370.297 27.8594C370.625 28.0586 370.879 28.3301 371.059 28.6738C371.238 29.0176 371.328 29.4082 371.328 29.8457L370.332 29.8398C370.328 29.5898 370.279 29.3594 370.186 29.1484C370.092 28.9375 369.953 28.7676 369.77 28.6387C369.586 28.5098 369.359 28.4395 369.09 28.4277C368.766 28.4199 368.482 28.4805 368.24 28.6094C368.002 28.7383 367.799 28.916 367.631 29.1426C367.467 29.3652 367.336 29.6133 367.238 29.8867C367.145 30.1602 367.08 30.4375 367.045 30.7188L367.016 30.9648C366.992 31.2148 366.988 31.4707 367.004 31.7324C367.023 31.9941 367.078 32.2383 367.168 32.4648C367.258 32.6875 367.396 32.8691 367.584 33.0098C367.771 33.1504 368.021 33.2246 368.334 33.2324ZM375.617 32.916L376.145 29.6406C376.172 29.3984 376.148 29.1855 376.074 29.002C376.004 28.8184 375.885 28.6758 375.717 28.5742C375.553 28.4727 375.346 28.418 375.096 28.4102C374.877 28.4062 374.662 28.4414 374.451 28.5156C374.244 28.5898 374.064 28.7012 373.912 28.8496C373.76 28.998 373.66 29.1855 373.613 29.4121L372.559 29.418C372.586 29.1016 372.686 28.8262 372.857 28.5918C373.029 28.3535 373.244 28.1562 373.502 28C373.76 27.8398 374.037 27.7227 374.334 27.6484C374.631 27.5703 374.92 27.5332 375.201 27.5371C375.627 27.5449 375.996 27.6367 376.309 27.8125C376.625 27.9844 376.863 28.2266 377.023 28.5391C377.184 28.8516 377.242 29.2266 377.199 29.6641L376.713 32.6172C376.678 32.832 376.656 33.0488 376.648 33.2676C376.645 33.4824 376.67 33.6934 376.725 33.9004L376.713 34L375.641 34.0059C375.598 33.8262 375.576 33.6445 375.576 33.4609C375.58 33.2773 375.594 33.0957 375.617 32.916ZM376.268 30.1562L376.145 30.918L375.143 30.9121C374.932 30.9121 374.709 30.9277 374.475 30.959C374.24 30.9902 374.018 31.0488 373.807 31.1348C373.596 31.2207 373.418 31.3457 373.273 31.5098C373.129 31.6699 373.041 31.8789 373.01 32.1367C372.986 32.3477 373.012 32.5312 373.086 32.6875C373.164 32.8398 373.281 32.959 373.438 33.0449C373.594 33.1309 373.775 33.1758 373.982 33.1797C374.252 33.1836 374.518 33.1309 374.779 33.0215C375.041 32.9121 375.27 32.7559 375.465 32.5527C375.66 32.3496 375.795 32.1152 375.869 31.8496L376.256 32.3711C376.182 32.6289 376.061 32.8672 375.893 33.0859C375.725 33.3008 375.525 33.4863 375.295 33.6426C375.068 33.7988 374.824 33.9199 374.562 34.0059C374.301 34.0918 374.039 34.1328 373.777 34.1289C373.422 34.1211 373.1 34.041 372.811 33.8887C372.525 33.7363 372.299 33.5234 372.131 33.25C371.967 32.9727 371.896 32.6504 371.92 32.2832C371.943 31.8809 372.049 31.543 372.236 31.2695C372.424 30.9961 372.664 30.7773 372.957 30.6133C373.254 30.4492 373.578 30.332 373.93 30.2617C374.281 30.1875 374.629 30.1504 374.973 30.1504L376.268 30.1562Z",
      "fill": "#484C57"
    }
  }), _c('path', {
    attrs: {
      "d": "M350.271 73.2164C350.271 73.9521 350.868 74.5485 351.604 74.5485C352.339 74.5485 352.936 73.9521 352.936 73.2164C352.936 72.4807 352.339 71.8843 351.604 71.8843C350.868 71.8843 350.271 72.4807 350.271 73.2164ZM351.354 43.7383L351.354 73.2164L351.853 73.2164L351.853 43.7383L351.354 43.7383Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M344 47.3984C344 53.7619 351.5 60.8324 351.5 60.8324C351.5 60.8324 358.999 53.7619 358.999 47.3984C358.999 45.4362 358.209 43.5544 356.803 42.1669C355.396 40.7795 353.489 40 351.5 40C349.511 40 347.603 40.7795 346.197 42.1669C344.79 43.5544 344 45.4362 344 47.3984Z",
      "fill": "#07B53B"
    }
  }), _c('path', {
    attrs: {
      "d": "M349.903 48.4505C349.903 47.9073 350.009 47.4268 350.221 47.0089C350.433 46.591 350.726 46.2636 351.1 46.0245C351.474 45.7861 351.902 45.6669 352.386 45.6669C352.876 45.6669 353.307 45.7861 353.682 46.0245C354.056 46.2629 354.348 46.5933 354.561 47.0134C354.772 47.4344 354.878 47.9134 354.878 48.4497C354.878 48.4701 354.875 48.4889 354.875 48.5093H355.739C355.739 48.4889 355.742 48.4701 355.742 48.4497C355.742 47.9398 355.659 47.4668 355.494 47.033C355.328 46.5993 355.095 46.2191 354.794 45.8947C354.493 45.5704 354.139 45.3177 353.732 45.1389C353.325 44.9601 352.875 44.8711 352.385 44.8711C351.902 44.8711 351.457 44.9609 351.05 45.1396C350.642 45.3184 350.289 45.5704 349.987 45.8955C349.686 46.2206 349.454 46.6001 349.292 47.0338C349.13 47.4683 349.049 47.9405 349.049 48.4505C349.049 48.4708 349.051 48.4897 349.051 48.5101H349.905C349.906 48.4897 349.903 48.4708 349.903 48.4505Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M353.342 48.5117C353.335 49.0239 353.232 49.4841 353.028 49.8884C352.816 50.3093 352.523 50.639 352.148 50.8773C351.774 51.1157 351.342 51.2357 350.853 51.2357C350.369 51.2357 349.941 51.1165 349.567 50.8773C349.193 50.639 348.9 50.3093 348.688 49.8884C348.484 49.4833 348.381 49.0239 348.373 48.5117H347.52C347.526 48.999 347.605 49.4524 347.761 49.8688C347.923 50.3033 348.155 50.6827 348.456 51.0071C348.757 51.3322 349.111 51.5834 349.518 51.7629C349.925 51.9417 350.37 52.0315 350.854 52.0315C351.343 52.0315 351.791 51.9417 352.199 51.7629C352.606 51.5842 352.96 51.3322 353.261 51.0071C353.562 50.6827 353.796 50.3033 353.961 49.8688C354.12 49.4516 354.2 48.999 354.206 48.5117H353.342Z",
      "fill": "white"
    }
  }), _c('path', {
    attrs: {
      "d": "M353.756 47.7744C353.996 47.7744 354.191 47.5792 354.191 47.3384C354.191 47.0976 353.996 46.9023 353.756 46.9023C353.515 46.9023 353.32 47.0976 353.32 47.3384C353.32 47.5792 353.515 47.7744 353.756 47.7744Z",
      "fill": "white"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }